//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import {optionsTransformer} from '@sekoia/shared/requests/nswagBaseClients/baseClient';
import moment from 'moment';

export class BaseClient {
  getBaseUrl(_: string, parsedBaseUrl: string | undefined): string {
    if (parsedBaseUrl) {
      return parsedBaseUrl;
    }

    if (!process.env.NEXUS_SERVICE_URL) {
      throw new Error('NEXUS_SERVICE_URL must be set in environment');
    }

    return process.env.NEXUS_SERVICE_URL;
  }
  
  async transformOptions(options: RequestInit) : Promise<RequestInit> {
    return optionsTransformer.addDefaultHeaders(options);
  }
}

export class ResidentsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nexus-dev.sekoia.one", baseUrl);
    }

    getPersonalData(residentId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<PersonalDataResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/personaldata";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPersonalData(_response);
        });
    }

    protected processGetPersonalData(response: Response): Promise<PersonalDataResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonalDataResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonalDataResponse>(null as any);
    }

    getResidentsPersonalData(residentIds: string[] | null | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<BasePersonalDataResponse[]> {
        let url_ = this.baseUrl + "/api/residents/personaldata?";
        if (residentIds !== undefined && residentIds !== null)
            residentIds && residentIds.forEach(item => { url_ += "residentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResidentsPersonalData(_response);
        });
    }

    protected processGetResidentsPersonalData(response: Response): Promise<BasePersonalDataResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BasePersonalDataResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BasePersonalDataResponse[]>(null as any);
    }

    getResidentsForms(residentIds: string[] | null | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<ResidentsFormsResponse[]> {
        let url_ = this.baseUrl + "/api/residents/forms?";
        if (residentIds !== undefined && residentIds !== null)
            residentIds && residentIds.forEach(item => { url_ += "residentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResidentsForms(_response);
        });
    }

    protected processGetResidentsForms(response: Response): Promise<ResidentsFormsResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResidentsFormsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResidentsFormsResponse[]>(null as any);
    }

    getResidentForms(residentId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<ResidentFormsResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/forms";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResidentForms(_response);
        });
    }

    protected processGetResidentForms(response: Response): Promise<ResidentFormsResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResidentFormsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResidentFormsResponse[]>(null as any);
    }

    getContactsAndRelatives(residentId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<ContactsAndRelativesResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/contactsandrelatives";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetContactsAndRelatives(_response);
        });
    }

    protected processGetContactsAndRelatives(response: Response): Promise<ContactsAndRelativesResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactsAndRelativesResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactsAndRelativesResponse[]>(null as any);
    }

    getConditions(residentId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<ResidentConditionResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/conditions";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConditions(_response);
        });
    }

    protected processGetConditions(response: Response): Promise<ResidentConditionResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResidentConditionResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResidentConditionResponse[]>(null as any);
    }
}

export class PnAdministrationsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nexus-dev.sekoia.one", baseUrl);
    }

    getAdministration(residentId: string, administrationId: number, signal?: AbortSignal, headers?: HeadersInit): Promise<AdministrationResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/pn/administrations/{administrationId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (administrationId === undefined || administrationId === null)
            throw new Error("The parameter 'administrationId' must be defined.");
        url_ = url_.replace("{administrationId}", encodeURIComponent("" + administrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAdministration(_response);
        });
    }

    protected processGetAdministration(response: Response): Promise<AdministrationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdministrationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdministrationResponse>(null as any);
    }

    updateAdministration(residentId: string, administrationId: number, updateEffectRequest: UpdateAdministrationRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/pn/administrations/{administrationId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (administrationId === undefined || administrationId === null)
            throw new Error("The parameter 'administrationId' must be defined.");
        url_ = url_.replace("{administrationId}", encodeURIComponent("" + administrationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateEffectRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAdministration(_response);
        });
    }

    protected processUpdateAdministration(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAvailableActionsForAdministration(residentId: string, administrationId: number, signal?: AbortSignal, headers?: HeadersInit): Promise<AvailableActionResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/pn/administrations/{administrationId}/availableActions";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (administrationId === undefined || administrationId === null)
            throw new Error("The parameter 'administrationId' must be defined.");
        url_ = url_.replace("{administrationId}", encodeURIComponent("" + administrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableActionsForAdministration(_response);
        });
    }

    protected processGetAvailableActionsForAdministration(response: Response): Promise<AvailableActionResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailableActionResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AvailableActionResponse[]>(null as any);
    }

    giveAdministration(residentId: string, administrationId: number, giveAdministrationRequest: GiveOrHandoutAdministrationRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<HttpStatusCode> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/pn/administrations/{administrationId}/give";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (administrationId === undefined || administrationId === null)
            throw new Error("The parameter 'administrationId' must be defined.");
        url_ = url_.replace("{administrationId}", encodeURIComponent("" + administrationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(giveAdministrationRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGiveAdministration(_response);
        });
    }

    protected processGiveAdministration(response: Response): Promise<HttpStatusCode> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HttpStatusCode>(null as any);
    }

    handOutAdministration(residentId: string, administrationId: number, giveAdministrationRequest: GiveOrHandoutAdministrationRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<HttpStatusCode> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/pn/administrations/{administrationId}/handOut";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (administrationId === undefined || administrationId === null)
            throw new Error("The parameter 'administrationId' must be defined.");
        url_ = url_.replace("{administrationId}", encodeURIComponent("" + administrationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(giveAdministrationRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHandOutAdministration(_response);
        });
    }

    protected processHandOutAdministration(response: Response): Promise<HttpStatusCode> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HttpStatusCode>(null as any);
    }

    cancelAdministration(residentId: string, administrationId: number, cancelRequest: CancelRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<HttpStatusCode> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/pn/administrations/{administrationId}/cancel";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (administrationId === undefined || administrationId === null)
            throw new Error("The parameter 'administrationId' must be defined.");
        url_ = url_.replace("{administrationId}", encodeURIComponent("" + administrationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cancelRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelAdministration(_response);
        });
    }

    protected processCancelAdministration(response: Response): Promise<HttpStatusCode> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HttpStatusCode>(null as any);
    }

    getPnHistoryDetails(residentId: string, administrationId: number, signal?: AbortSignal, headers?: HeadersInit): Promise<AdministrationDetailsResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/pn/administrations/{administrationId}/details";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (administrationId === undefined || administrationId === null)
            throw new Error("The parameter 'administrationId' must be defined.");
        url_ = url_.replace("{administrationId}", encodeURIComponent("" + administrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPnHistoryDetails(_response);
        });
    }

    protected processGetPnHistoryDetails(response: Response): Promise<AdministrationDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdministrationDetailsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdministrationDetailsResponse>(null as any);
    }

    getActions(residentId: string, administrationId: number, signal?: AbortSignal, headers?: HeadersInit): Promise<AdministrationResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/pn/administrations/{administrationId}/actions";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (administrationId === undefined || administrationId === null)
            throw new Error("The parameter 'administrationId' must be defined.");
        url_ = url_.replace("{administrationId}", encodeURIComponent("" + administrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActions(_response);
        });
    }

    protected processGetActions(response: Response): Promise<AdministrationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdministrationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdministrationResponse[]>(null as any);
    }

    getStatesAndEffect(residentIds: string[] | null | undefined, from: moment.Moment | undefined, to: moment.Moment | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<StatesAndEffectsResponse[]> {
        let url_ = this.baseUrl + "/api/residents/pn/administrations/statesAndEffects?";
        if (residentIds !== undefined && residentIds !== null)
            residentIds && residentIds.forEach(item => { url_ += "residentIds=" + encodeURIComponent("" + item) + "&"; });
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStatesAndEffect(_response);
        });
    }

    protected processGetStatesAndEffect(response: Response): Promise<StatesAndEffectsResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StatesAndEffectsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatesAndEffectsResponse[]>(null as any);
    }
}

export class PnPrescriptionsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nexus-dev.sekoia.one", baseUrl);
    }

    getPrescriptionsV2(residentId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<GroupedPrescriptionResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/pn/prescriptions/v2";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrescriptionsV2(_response);
        });
    }

    protected processGetPrescriptionsV2(response: Response): Promise<GroupedPrescriptionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupedPrescriptionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupedPrescriptionResponse>(null as any);
    }

    getPrescription(residentId: string, prescriptionId: number, signal?: AbortSignal, headers?: HeadersInit): Promise<PrescriptionResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/pn/prescriptions/{prescriptionId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrescription(_response);
        });
    }

    protected processGetPrescription(response: Response): Promise<PrescriptionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrescriptionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrescriptionResponse>(null as any);
    }

    getAvailableActionsForMedication(residentId: string, prescriptionId: number, signal?: AbortSignal, headers?: HeadersInit): Promise<AvailableActionResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/pn/prescriptions/{prescriptionId}/availableActions";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableActionsForMedication(_response);
        });
    }

    protected processGetAvailableActionsForMedication(response: Response): Promise<AvailableActionResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailableActionResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AvailableActionResponse[]>(null as any);
    }

    prescriptionMeasure(residentId: string, prescriptionId: number, measureRequest: MeasureRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<HttpStatusCode> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/pn/prescriptions/{prescriptionId}/measure";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(measureRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPrescriptionMeasure(_response);
        });
    }

    protected processPrescriptionMeasure(response: Response): Promise<HttpStatusCode> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HttpStatusCode>(null as any);
    }

    prescriptionControl(residentId: string, prescriptionId: number, controlRequest: ControlRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<HttpStatusCode> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/pn/prescriptions/{prescriptionId}/control";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(controlRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPrescriptionControl(_response);
        });
    }

    protected processPrescriptionControl(response: Response): Promise<HttpStatusCode> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HttpStatusCode>(null as any);
    }

    prescriptionGive(residentId: string, prescriptionId: number, giveRequest: GiveRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<HttpStatusCode> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/pn/prescriptions/{prescriptionId}/give";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(giveRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPrescriptionGive(_response);
        });
    }

    protected processPrescriptionGive(response: Response): Promise<HttpStatusCode> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HttpStatusCode>(null as any);
    }

    prescriptionHandOut(residentId: string, prescriptionId: number, handOutRequest: HandOutRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<HttpStatusCode> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/pn/prescriptions/{prescriptionId}/handOut";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(handOutRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPrescriptionHandOut(_response);
        });
    }

    protected processPrescriptionHandOut(response: Response): Promise<HttpStatusCode> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HttpStatusCode>(null as any);
    }

    getAdministrations(residentId: string, prescriptionId: number, signal?: AbortSignal, headers?: HeadersInit): Promise<AdministrationResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/pn/prescriptions/{prescriptionId}/administrations";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAdministrations(_response);
        });
    }

    protected processGetAdministrations(response: Response): Promise<AdministrationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdministrationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdministrationResponse[]>(null as any);
    }

    getMeasuredControlledAdministrations(residentId: string, prescriptionId: number, signal?: AbortSignal, headers?: HeadersInit): Promise<AdministrationResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/pn/prescriptions/{prescriptionId}/administrations/measuredControlled";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMeasuredControlledAdministrations(_response);
        });
    }

    protected processGetMeasuredControlledAdministrations(response: Response): Promise<AdministrationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdministrationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdministrationResponse[]>(null as any);
    }
}

export class HandlingsanvisningerClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nexus-dev.sekoia.one", baseUrl);
    }

    getHandlingsanvisningerForResident(residentId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<HandlingsanvisningTitleAndIdResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/handlingsanvisninger";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHandlingsanvisningerForResident(_response);
        });
    }

    protected processGetHandlingsanvisningerForResident(response: Response): Promise<HandlingsanvisningTitleAndIdResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HandlingsanvisningTitleAndIdResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HandlingsanvisningTitleAndIdResponse[]>(null as any);
    }
}

export class PlansClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nexus-dev.sekoia.one", baseUrl);
    }

    getPlans(residentId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<PlanResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/plans";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPlans(_response);
        });
    }

    protected processGetPlans(response: Response): Promise<PlanResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlanResponse[]>(null as any);
    }

    getPlanReferences(residentId: string, planId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<PlanReferencesResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/plans/{planId}/references";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (planId === undefined || planId === null)
            throw new Error("The parameter 'planId' must be defined.");
        url_ = url_.replace("{planId}", encodeURIComponent("" + planId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPlanReferences(_response);
        });
    }

    protected processGetPlanReferences(response: Response): Promise<PlanReferencesResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlanReferencesResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlanReferencesResponse[]>(null as any);
    }
}

export class PlansVumClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nexus-dev.sekoia.one", baseUrl);
    }

    getVumProblems(residentId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<VumProblemResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/plans/vum";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVumProblems(_response);
        });
    }

    protected processGetVumProblems(response: Response): Promise<VumProblemResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VumProblemResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VumProblemResponse[]>(null as any);
    }

    getVumSubGoals(residentId: string, subGoalIds: number[] | null | undefined, onlyActive: boolean | undefined, includeActions: boolean | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<VumSubGoalDetailResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/plans/vum/subGoals?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (subGoalIds !== undefined && subGoalIds !== null)
            subGoalIds && subGoalIds.forEach(item => { url_ += "subGoalIds=" + encodeURIComponent("" + item) + "&"; });
        if (onlyActive === null)
            throw new Error("The parameter 'onlyActive' cannot be null.");
        else if (onlyActive !== undefined)
            url_ += "onlyActive=" + encodeURIComponent("" + onlyActive) + "&";
        if (includeActions === null)
            throw new Error("The parameter 'includeActions' cannot be null.");
        else if (includeActions !== undefined)
            url_ += "includeActions=" + encodeURIComponent("" + includeActions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVumSubGoals(_response);
        });
    }

    protected processGetVumSubGoals(response: Response): Promise<VumSubGoalDetailResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VumSubGoalDetailResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VumSubGoalDetailResponse[]>(null as any);
    }

    getSubGoals(residentId: string, subGoalIds: number[] | null | undefined, onlyActive: boolean | undefined, includeActions: boolean | undefined, version: string, signal?: AbortSignal, headers?: HeadersInit): Promise<SubGoalDetailResponse[]> {
        let url_ = this.baseUrl + "/api/v{version}/residents/{residentId}/plans/vum/subGoals?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (subGoalIds !== undefined && subGoalIds !== null)
            subGoalIds && subGoalIds.forEach(item => { url_ += "subGoalIds=" + encodeURIComponent("" + item) + "&"; });
        if (onlyActive === null)
            throw new Error("The parameter 'onlyActive' cannot be null.");
        else if (onlyActive !== undefined)
            url_ += "onlyActive=" + encodeURIComponent("" + onlyActive) + "&";
        if (includeActions === null)
            throw new Error("The parameter 'includeActions' cannot be null.");
        else if (includeActions !== undefined)
            url_ += "includeActions=" + encodeURIComponent("" + includeActions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSubGoals(_response);
        });
    }

    protected processGetSubGoals(response: Response): Promise<SubGoalDetailResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubGoalDetailResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubGoalDetailResponse[]>(null as any);
    }

    getEvaluationPrototype(residentId: string, subGoalId: number, signal?: AbortSignal, headers?: HeadersInit): Promise<EvaluationPrototypeResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/plans/vum/subGoals/{subGoalId}/evaluationPrototype";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (subGoalId === undefined || subGoalId === null)
            throw new Error("The parameter 'subGoalId' must be defined.");
        url_ = url_.replace("{subGoalId}", encodeURIComponent("" + subGoalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEvaluationPrototype(_response);
        });
    }

    protected processGetEvaluationPrototype(response: Response): Promise<EvaluationPrototypeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EvaluationPrototypeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EvaluationPrototypeResponse>(null as any);
    }

    createEvaluation(residentId: string, subGoalId: number, request: CreateEvaluationRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/plans/vum/subGoals/{subGoalId}/createEvaluation";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (subGoalId === undefined || subGoalId === null)
            throw new Error("The parameter 'subGoalId' must be defined.");
        url_ = url_.replace("{subGoalId}", encodeURIComponent("" + subGoalId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateEvaluation(_response);
        });
    }

    protected processCreateEvaluation(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PlannedAdministrationsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nexus-dev.sekoia.one", baseUrl);
    }

    /**
     * @param date Date with local date pattern 'uuuu-MM-dd'
     */
    getAvailableActions(residentId: string, date: string, signal?: AbortSignal, headers?: HeadersInit): Promise<PlannedAvailableActionsResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/planned/{Date}/availableActions";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{Date}", encodeURIComponent("" + date));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableActions(_response);
        });
    }

    protected processGetAvailableActions(response: Response): Promise<PlannedAvailableActionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlannedAvailableActionsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedAvailableActionsResponse>(null as any);
    }

    /**
     * @param residentIds (optional) 
     * @param date (optional) Date with local date pattern 'uuuu-MM-dd'
     * @param from (optional) 
     * @param to (optional) 
     * @param includeSelfAdministrated (optional) 
     * @param includeInsidePausedInterval (optional) 
     */
    getPlannedAdministrations(residentIds: string[] | null | undefined, date: string | null | undefined, from: string | null | undefined, to: string | null | undefined, includeSelfAdministrated: boolean | undefined, includeInsidePausedInterval: boolean | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<PlannedAdministrationsForResidentResponse[]> {
        let url_ = this.baseUrl + "/api/residents/planned/administrations?";
        if (residentIds !== undefined && residentIds !== null)
            residentIds && residentIds.forEach(item => { url_ += "residentIds=" + encodeURIComponent("" + item) + "&"; });
        if (date !== undefined && date !== null)
            url_ += "Date=" + encodeURIComponent("" + date) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (includeSelfAdministrated === null)
            throw new Error("The parameter 'includeSelfAdministrated' cannot be null.");
        else if (includeSelfAdministrated !== undefined)
            url_ += "IncludeSelfAdministrated=" + encodeURIComponent("" + includeSelfAdministrated) + "&";
        if (includeInsidePausedInterval === null)
            throw new Error("The parameter 'includeInsidePausedInterval' cannot be null.");
        else if (includeInsidePausedInterval !== undefined)
            url_ += "IncludeInsidePausedInterval=" + encodeURIComponent("" + includeInsidePausedInterval) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPlannedAdministrations(_response);
        });
    }

    protected processGetPlannedAdministrations(response: Response): Promise<PlannedAdministrationsForResidentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlannedAdministrationsForResidentResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedAdministrationsForResidentResponse[]>(null as any);
    }

    getPlannedAdministrationTasksForReport(from: moment.Moment | undefined, to: moment.Moment | undefined, residentIds: string[] | null | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<PlannedAdministrationTasksForReportResponse[]> {
        let url_ = this.baseUrl + "/api/residents/planned/administrations/report?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (residentIds !== undefined && residentIds !== null)
            residentIds && residentIds.forEach(item => { url_ += "ResidentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPlannedAdministrationTasksForReport(_response);
        });
    }

    protected processGetPlannedAdministrationTasksForReport(response: Response): Promise<PlannedAdministrationTasksForReportResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlannedAdministrationTasksForReportResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedAdministrationTasksForReportResponse[]>(null as any);
    }
}

export class PlannedDosedAdministrationsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nexus-dev.sekoia.one", baseUrl);
    }

    getPlannedAdministrationDetails(residentId: string, administrationTime: moment.Moment | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<DosedAdministrationDetailsResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/planned/administrations/dosed/details?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (administrationTime === null)
            throw new Error("The parameter 'administrationTime' cannot be null.");
        else if (administrationTime !== undefined)
            url_ += "AdministrationTime=" + encodeURIComponent(administrationTime ? "" + administrationTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPlannedAdministrationDetails(_response);
        });
    }

    protected processGetPlannedAdministrationDetails(response: Response): Promise<DosedAdministrationDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DosedAdministrationDetailsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DosedAdministrationDetailsResponse>(null as any);
    }

    givePlannedAdministration(residentId: string, plannedAdministrationsRequest: PlannedAdministrationDosedRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/planned/administrations/dosed/give";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(plannedAdministrationsRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGivePlannedAdministration(_response);
        });
    }

    protected processGivePlannedAdministration(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    notGivenPlannedAdministration(residentId: string, plannedAdministrationsRequest: PlannedAdministrationDosedRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/planned/administrations/dosed/notgiven";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(plannedAdministrationsRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNotGivenPlannedAdministration(_response);
        });
    }

    protected processNotGivenPlannedAdministration(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    handedOverPlannedAdministration(residentId: string, plannedAdministrationsRequest: PlannedAdministrationDosedRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/planned/administrations/dosed/handedover";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(plannedAdministrationsRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHandedOverPlannedAdministration(_response);
        });
    }

    protected processHandedOverPlannedAdministration(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deletePlannedAdministration(residentId: string, plannedAdministrationsRequest: PlannedAdministrationDosedRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/planned/administrations/dosed/delete";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(plannedAdministrationsRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeletePlannedAdministration(_response);
        });
    }

    protected processDeletePlannedAdministration(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    notIngestedPlannedAdministration(residentId: string, plannedAdministrationsRequest: PlannedAdministrationDosedRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/planned/administrations/dosed/notingested";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(plannedAdministrationsRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNotIngestedPlannedAdministration(_response);
        });
    }

    protected processNotIngestedPlannedAdministration(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateDosedAdministrationMetadata(residentId: string, request: UpdateDosedAdministrationMetadataRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/planned/administrations/dosed/metadata";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateDosedAdministrationMetadata(_response);
        });
    }

    protected processUpdateDosedAdministrationMetadata(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    setDosedAdministrationsInstructions(residentId: string, request: SetAdministrationInstructionsRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/planned/administrations/dosed/instructions";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetDosedAdministrationsInstructions(_response);
        });
    }

    protected processSetDosedAdministrationsInstructions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PlannedNotDispensedAdministrationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nexus-dev.sekoia.one", baseUrl);
    }

    getPlannedAdministrationNotDispensedDetails(residentId: string, administrationTime: moment.Moment | undefined, prescriptionId: number | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<NotDispensedAdministrationDetailsResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/planned/administrations/notdispensed/details?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (administrationTime === null)
            throw new Error("The parameter 'administrationTime' cannot be null.");
        else if (administrationTime !== undefined)
            url_ += "AdministrationTime=" + encodeURIComponent(administrationTime ? "" + administrationTime.toISOString() : "") + "&";
        if (prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' cannot be null.");
        else if (prescriptionId !== undefined)
            url_ += "PrescriptionId=" + encodeURIComponent("" + prescriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPlannedAdministrationNotDispensedDetails(_response);
        });
    }

    protected processGetPlannedAdministrationNotDispensedDetails(response: Response): Promise<NotDispensedAdministrationDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotDispensedAdministrationDetailsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotDispensedAdministrationDetailsResponse>(null as any);
    }

    givePlannedAdministrationNotDispensed(residentId: string, plannedAdministrationsRequest: PlannedAdministrationNotDispensedRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/planned/administrations/notdispensed/give";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(plannedAdministrationsRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGivePlannedAdministrationNotDispensed(_response);
        });
    }

    protected processGivePlannedAdministrationNotDispensed(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    notGivenPlannedAdministrationNotDispensed(residentId: string, plannedAdministrationsRequest: PlannedAdministrationNotDispensedRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/planned/administrations/notdispensed/notgiven";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(plannedAdministrationsRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNotGivenPlannedAdministrationNotDispensed(_response);
        });
    }

    protected processNotGivenPlannedAdministrationNotDispensed(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deletePlannedAdministrationNotDispensed(residentId: string, plannedAdministrationsRequest: PlannedAdministrationNotDispensedRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/planned/administrations/notdispensed/delete";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(plannedAdministrationsRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeletePlannedAdministrationNotDispensed(_response);
        });
    }

    protected processDeletePlannedAdministrationNotDispensed(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    handedOverPlannedAdministrationNotDispensed(residentId: string, plannedAdministrationsRequest: PlannedAdministrationNotDispensedRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/planned/administrations/notdispensed/handedover";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(plannedAdministrationsRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHandedOverPlannedAdministrationNotDispensed(_response);
        });
    }

    protected processHandedOverPlannedAdministrationNotDispensed(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    notIngestedPlannedAdministrationNotDispensed(residentId: string, plannedAdministrationsRequest: PlannedAdministrationNotDispensedRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/planned/administrations/notdispensed/notingested";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(plannedAdministrationsRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNotIngestedPlannedAdministrationNotDispensed(_response);
        });
    }

    protected processNotIngestedPlannedAdministrationNotDispensed(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateNotDispensedAdministrationConfigurationForResident(residentId: string, prescriptionId: number, request: UpdateNotDispensedMetadataRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/planned/administrations/notDispensed/{prescriptionId}/metadata";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateNotDispensedAdministrationConfigurationForResident(_response);
        });
    }

    protected processUpdateNotDispensedAdministrationConfigurationForResident(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    setNotDispensedAdministrationsInstructions(residentId: string, prescriptionId: number, request: SetAdministrationInstructionsRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<void> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/planned/administrations/notDispensed/{prescriptionId}/instructions";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetNotDispensedAdministrationsInstructions(_response);
        });
    }

    protected processSetNotDispensedAdministrationsInstructions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ObservationsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nexus-dev.sekoia.one", baseUrl);
    }

    getObservationRegistrationsv2(residentId: string, from: moment.Moment | undefined, to: moment.Moment | undefined, version: string, signal?: AbortSignal, headers?: HeadersInit): Promise<ObservationsRegistrationsResponse[]> {
        let url_ = this.baseUrl + "/api/v{version}/residents/{residentId}/observations/registrations?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetObservationRegistrationsv2(_response);
        });
    }

    protected processGetObservationRegistrationsv2(response: Response): Promise<ObservationsRegistrationsResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationsRegistrationsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ObservationsRegistrationsResponse[]>(null as any);
    }

    getRegistrationDetails(residentId: string, registrationId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<FormResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/observations/registrations/{registrationId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (registrationId === undefined || registrationId === null)
            throw new Error("The parameter 'registrationId' must be defined.");
        url_ = url_.replace("{registrationId}", encodeURIComponent("" + registrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegistrationDetails(_response);
        });
    }

    protected processGetRegistrationDetails(response: Response): Promise<FormResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormResponse>(null as any);
    }

    getObservationTypesOld(residentId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<ObservationsTypeResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/observations";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetObservationTypesOld(_response);
        });
    }

    protected processGetObservationTypesOld(response: Response): Promise<ObservationsTypeResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationsTypeResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ObservationsTypeResponse[]>(null as any);
    }

    getObservationTypes(residentId: string, version: string, signal?: AbortSignal, headers?: HeadersInit): Promise<ObservationsTypeResponse[]> {
        let url_ = this.baseUrl + "/api/v{version}/residents/{residentId}/observations";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetObservationTypes(_response);
        });
    }

    protected processGetObservationTypes(response: Response): Promise<ObservationsTypeResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationsTypeResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ObservationsTypeResponse[]>(null as any);
    }

    getPrototype(residentId: string, id: number, signal?: AbortSignal, headers?: HeadersInit): Promise<FormPrototypeResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/observations/{id}/prototype";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrototype(_response);
        });
    }

    protected processGetPrototype(response: Response): Promise<FormPrototypeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormPrototypeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormPrototypeResponse>(null as any);
    }

    createRegistration(residentId: string, id: number, version: string, request: CreateRegistrationRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/residents/{residentId}/observations/{id}/registrations";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRegistration(_response);
        });
    }

    protected processCreateRegistration(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class NexusTokenClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nexus-dev.sekoia.one", baseUrl);
    }

    initiateNexusSession(request: InitiateNexusSessionRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<InitiateNexusSessionResponse> {
        let url_ = this.baseUrl + "/api/NexusToken/employee/session/initiate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInitiateNexusSession(_response);
        });
    }

    protected processInitiateNexusSession(response: Response): Promise<InitiateNexusSessionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InitiateNexusSessionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InitiateNexusSessionResponse>(null as any);
    }

    confirmNexusSession(signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/NexusToken/employee/session/confirm";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConfirmNexusSession(_response);
        });
    }

    protected processConfirmNexusSession(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    isAuthenticated(employeeId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<moment.Moment> {
        let url_ = this.baseUrl + "/api/NexusToken/employees/{EmployeeId}/token/expirationTimestamp";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{EmployeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsAuthenticated(_response);
        });
    }

    protected processIsAuthenticated(response: Response): Promise<moment.Moment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? moment(resultData200.toString()) : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<moment.Moment>(null as any);
    }
}

export class HealthMeasurementClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nexus-dev.sekoia.one", baseUrl);
    }

    getHealthMeasurementsIds(residentId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<InstructionIdAndNameResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/healthmeasurements";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHealthMeasurementsIds(_response);
        });
    }

    protected processGetHealthMeasurementsIds(response: Response): Promise<InstructionIdAndNameResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstructionIdAndNameResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstructionIdAndNameResponse[]>(null as any);
    }

    getAvailableMeasurementInstructionsForEmployee(residentId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<InstructionIdAndNameResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/healthmeasurements/availablemeasurements";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableMeasurementInstructionsForEmployee(_response);
        });
    }

    protected processGetAvailableMeasurementInstructionsForEmployee(response: Response): Promise<InstructionIdAndNameResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstructionIdAndNameResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstructionIdAndNameResponse[]>(null as any);
    }

    getHealthMeasurementsByInstructionId(residentId: string, instructionId: number, pageNumber: number | null | undefined, pageSize: number | null | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<NexusHealthMeasurementResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/healthmeasurements/{instructionId}?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (instructionId === undefined || instructionId === null)
            throw new Error("The parameter 'instructionId' must be defined.");
        url_ = url_.replace("{instructionId}", encodeURIComponent("" + instructionId));
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHealthMeasurementsByInstructionId(_response);
        });
    }

    protected processGetHealthMeasurementsByInstructionId(response: Response): Promise<NexusHealthMeasurementResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NexusHealthMeasurementResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NexusHealthMeasurementResponse>(null as any);
    }

    getPrototype(residentId: string, id: number, signal?: AbortSignal, headers?: HeadersInit): Promise<NexusHealthMeasurementPrototypeResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/healthmeasurements/{id}/prototype";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrototype(_response);
        });
    }

    protected processGetPrototype(response: Response): Promise<NexusHealthMeasurementPrototypeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NexusHealthMeasurementPrototypeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NexusHealthMeasurementPrototypeResponse>(null as any);
    }

    createMeasurement(residentId: string, request: CreateMeasurementRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<HttpStatusCode> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/healthmeasurements/createmeasurement";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateMeasurement(_response);
        });
    }

    protected processCreateMeasurement(response: Response): Promise<HttpStatusCode> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HttpStatusCode>(null as any);
    }
}

export class FormsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nexus-dev.sekoia.one", baseUrl);
    }

    getForms(residentId: string, ids: string[] | null | undefined, signal?: AbortSignal, headers?: HeadersInit): Promise<FormResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/genericForms?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetForms(_response);
        });
    }

    protected processGetForms(response: Response): Promise<FormResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormResponse[]>(null as any);
    }

    getAvailableActionsForEditingForm(residentId: string, formId: string, signal?: AbortSignal, headers?: HeadersInit): Promise<AvailableActionResponse2[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/genericForms/{formId}/availableActions";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableActionsForEditingForm(_response);
        });
    }

    protected processGetAvailableActionsForEditingForm(response: Response): Promise<AvailableActionResponse2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailableActionResponse2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AvailableActionResponse2[]>(null as any);
    }

    updateForm(residentId: string, version: string, updateFormRequest: UpdateFormRequest, signal?: AbortSignal, headers?: HeadersInit): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/residents/{residentId}/genericForms";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateFormRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateForm(_response);
        });
    }

    protected processUpdateForm(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ConfigurationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://services-nexus-dev.sekoia.one", baseUrl);
    }

    getConfiguration(signal?: AbortSignal, headers?: HeadersInit): Promise<ConfigurationResponse> {
        let url_ = this.baseUrl + "/api/Configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json",
                ...headers
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConfiguration(_response);
        });
    }

    protected processGetConfiguration(response: Response): Promise<ConfigurationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigurationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfigurationResponse>(null as any);
    }
}

export abstract class BasePersonalDataResponse implements IBasePersonalDataResponse {
    residentId?: string | null;

    protected _discriminator: string;

    constructor(data?: IBasePersonalDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BasePersonalDataResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : <any>null;
        }
    }

    static fromJS(data: any): BasePersonalDataResponse {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "PersonalDataResponse") {
            let result = new PersonalDataResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "NoPersonalDataResponse") {
            let result = new NoPersonalDataResponse();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BasePersonalDataResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["swagger_discriminator"] = this._discriminator;
        data["residentId"] = this.residentId !== undefined ? this.residentId : <any>null;
        return data;
    }
}

export interface IBasePersonalDataResponse {
    residentId?: string | null;
}

export class PersonalDataResponse extends BasePersonalDataResponse implements IPersonalDataResponse {
    firstName?: string | null;
    fullName?: string | null;
    homeTelephone?: string | null;
    knownAs?: string | null;
    lastName?: string | null;
    maritalStatus!: MaritalStatusResponse;
    middleName?: string | null;
    mobileTelephone?: string | null;
    notes?: string | null;
    ssn?: string | null;
    title?: string | null;
    residentState?: string | null;
    noResuscitationDecision!: boolean;

    constructor(data?: IPersonalDataResponse) {
        super(data);
        this._discriminator = "PersonalDataResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.homeTelephone = _data["homeTelephone"] !== undefined ? _data["homeTelephone"] : <any>null;
            this.knownAs = _data["knownAs"] !== undefined ? _data["knownAs"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.maritalStatus = _data["maritalStatus"] !== undefined ? _data["maritalStatus"] : <any>null;
            this.middleName = _data["middleName"] !== undefined ? _data["middleName"] : <any>null;
            this.mobileTelephone = _data["mobileTelephone"] !== undefined ? _data["mobileTelephone"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.residentState = _data["residentState"] !== undefined ? _data["residentState"] : <any>null;
            this.noResuscitationDecision = _data["noResuscitationDecision"] !== undefined ? _data["noResuscitationDecision"] : <any>null;
        }
    }

    static fromJS(data: any): PersonalDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["homeTelephone"] = this.homeTelephone !== undefined ? this.homeTelephone : <any>null;
        data["knownAs"] = this.knownAs !== undefined ? this.knownAs : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["maritalStatus"] = this.maritalStatus !== undefined ? this.maritalStatus : <any>null;
        data["middleName"] = this.middleName !== undefined ? this.middleName : <any>null;
        data["mobileTelephone"] = this.mobileTelephone !== undefined ? this.mobileTelephone : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["ssn"] = this.ssn !== undefined ? this.ssn : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["residentState"] = this.residentState !== undefined ? this.residentState : <any>null;
        data["noResuscitationDecision"] = this.noResuscitationDecision !== undefined ? this.noResuscitationDecision : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPersonalDataResponse extends IBasePersonalDataResponse {
    firstName?: string | null;
    fullName?: string | null;
    homeTelephone?: string | null;
    knownAs?: string | null;
    lastName?: string | null;
    maritalStatus: MaritalStatusResponse;
    middleName?: string | null;
    mobileTelephone?: string | null;
    notes?: string | null;
    ssn?: string | null;
    title?: string | null;
    residentState?: string | null;
    noResuscitationDecision: boolean;
}

export enum MaritalStatusResponse {
    NONE = "NONE",
    WIDOW = "WIDOW",
    DIVORCED = "DIVORCED",
    UNMARRIED = "UNMARRIED",
    SEPARATED = "SEPARATED",
    NOT_INFORMED = "NOT_INFORMED",
    COHABITING = "COHABITING",
    MARRIED = "MARRIED",
}

export class NoPersonalDataResponse extends BasePersonalDataResponse implements INoPersonalDataResponse {

    constructor(data?: INoPersonalDataResponse) {
        super(data);
        this._discriminator = "NoPersonalDataResponse";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): NoPersonalDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NoPersonalDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface INoPersonalDataResponse extends IBasePersonalDataResponse {
}

export class ResidentsFormsResponse implements IResidentsFormsResponse {
    residentId?: string | null;
    residentFormsResponse?: ResidentFormsResponse[] | null;

    constructor(data?: IResidentsFormsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : <any>null;
            if (Array.isArray(_data["residentFormsResponse"])) {
                this.residentFormsResponse = [] as any;
                for (let item of _data["residentFormsResponse"])
                    this.residentFormsResponse!.push(ResidentFormsResponse.fromJS(item));
            }
            else {
                this.residentFormsResponse = <any>null;
            }
        }
    }

    static fromJS(data: any): ResidentsFormsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResidentsFormsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residentId"] = this.residentId !== undefined ? this.residentId : <any>null;
        if (Array.isArray(this.residentFormsResponse)) {
            data["residentFormsResponse"] = [];
            for (let item of this.residentFormsResponse)
                data["residentFormsResponse"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IResidentsFormsResponse {
    residentId?: string | null;
    residentFormsResponse?: ResidentFormsResponse[] | null;
}

export class ResidentFormsResponse implements IResidentFormsResponse {
    id!: number;
    formItems?: FormItemResponse[] | null;
    title?: string | null;
    observationDateTime!: moment.Moment;
    lastUpdatedDateTime!: moment.Moment;
    color?: string | null;
    value?: string | null;
    valueName?: string | null;

    constructor(data?: IResidentFormsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            if (Array.isArray(_data["formItems"])) {
                this.formItems = [] as any;
                for (let item of _data["formItems"])
                    this.formItems!.push(FormItemResponse.fromJS(item));
            }
            else {
                this.formItems = <any>null;
            }
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.observationDateTime = _data["observationDateTime"] ? moment(_data["observationDateTime"].toString()) : <any>null;
            this.lastUpdatedDateTime = _data["lastUpdatedDateTime"] ? moment(_data["lastUpdatedDateTime"].toString()) : <any>null;
            this.color = _data["color"] !== undefined ? _data["color"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.valueName = _data["valueName"] !== undefined ? _data["valueName"] : <any>null;
        }
    }

    static fromJS(data: any): ResidentFormsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResidentFormsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        if (Array.isArray(this.formItems)) {
            data["formItems"] = [];
            for (let item of this.formItems)
                data["formItems"].push(item ? item.toJSON() : <any>null);
        }
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["observationDateTime"] = this.observationDateTime ? this.observationDateTime.toISOString() : <any>null;
        data["lastUpdatedDateTime"] = this.lastUpdatedDateTime ? this.lastUpdatedDateTime.toISOString() : <any>null;
        data["color"] = this.color !== undefined ? this.color : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["valueName"] = this.valueName !== undefined ? this.valueName : <any>null;
        return data;
    }
}

export interface IResidentFormsResponse {
    id: number;
    formItems?: FormItemResponse[] | null;
    title?: string | null;
    observationDateTime: moment.Moment;
    lastUpdatedDateTime: moment.Moment;
    color?: string | null;
    value?: string | null;
    valueName?: string | null;
}

export class FormItemResponse implements IFormItemResponse {
    id!: number;
    label?: string | null;
    possibleValues?: FormItemValueResponse[] | null;
    value?: FormItemValueResponse | null;
    valueAsString?: string | null;

    constructor(data?: IFormItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            if (Array.isArray(_data["possibleValues"])) {
                this.possibleValues = [] as any;
                for (let item of _data["possibleValues"])
                    this.possibleValues!.push(FormItemValueResponse.fromJS(item));
            }
            else {
                this.possibleValues = <any>null;
            }
            this.value = _data["value"] ? FormItemValueResponse.fromJS(_data["value"]) : <any>null;
            this.valueAsString = _data["valueAsString"] !== undefined ? _data["valueAsString"] : <any>null;
        }
    }

    static fromJS(data: any): FormItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        if (Array.isArray(this.possibleValues)) {
            data["possibleValues"] = [];
            for (let item of this.possibleValues)
                data["possibleValues"].push(item ? item.toJSON() : <any>null);
        }
        data["value"] = this.value ? this.value.toJSON() : <any>null;
        data["valueAsString"] = this.valueAsString !== undefined ? this.valueAsString : <any>null;
        return data;
    }
}

export interface IFormItemResponse {
    id: number;
    label?: string | null;
    possibleValues?: FormItemValueResponse[] | null;
    value?: FormItemValueResponse | null;
    valueAsString?: string | null;
}

export class FormItemValueResponse implements IFormItemValueResponse {
    id?: string | null;
    name?: string | null;

    constructor(data?: IFormItemValueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): FormItemValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormItemValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IFormItemValueResponse {
    id?: string | null;
    name?: string | null;
}

export class ContactsAndRelativesResponse implements IContactsAndRelativesResponse {
    type!: ContactType;
    fullName?: string | null;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    phoneNumber?: string | null;
    emailAddress?: string | null;
    typeName?: string | null;
    address?: AddressResponse | null;
    notes?: string | null;

    constructor(data?: IContactsAndRelativesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.middleName = _data["middleName"] !== undefined ? _data["middleName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.typeName = _data["typeName"] !== undefined ? _data["typeName"] : <any>null;
            this.address = _data["address"] ? AddressResponse.fromJS(_data["address"]) : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
        }
    }

    static fromJS(data: any): ContactsAndRelativesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ContactsAndRelativesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["middleName"] = this.middleName !== undefined ? this.middleName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["typeName"] = this.typeName !== undefined ? this.typeName : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        return data;
    }
}

export interface IContactsAndRelativesResponse {
    type: ContactType;
    fullName?: string | null;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    phoneNumber?: string | null;
    emailAddress?: string | null;
    typeName?: string | null;
    address?: AddressResponse | null;
    notes?: string | null;
}

export enum ContactType {
    RELATIVE = "RELATIVE",
    ORGANIZATION = "ORGANIZATION",
    PROFESSIONAL = "PROFESSIONAL",
}

export class AddressResponse implements IAddressResponse {
    addressLine1?: string | null;
    addressLine2?: string | null;
    addressLine3?: string | null;
    addressLine4?: string | null;
    addressLine5?: string | null;
    administrativeAreaCode?: string | null;
    countryCode?: string | null;
    postalCode?: string | null;
    postalDistrict?: string | null;

    constructor(data?: IAddressResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressLine1 = _data["addressLine1"] !== undefined ? _data["addressLine1"] : <any>null;
            this.addressLine2 = _data["addressLine2"] !== undefined ? _data["addressLine2"] : <any>null;
            this.addressLine3 = _data["addressLine3"] !== undefined ? _data["addressLine3"] : <any>null;
            this.addressLine4 = _data["addressLine4"] !== undefined ? _data["addressLine4"] : <any>null;
            this.addressLine5 = _data["addressLine5"] !== undefined ? _data["addressLine5"] : <any>null;
            this.administrativeAreaCode = _data["administrativeAreaCode"] !== undefined ? _data["administrativeAreaCode"] : <any>null;
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : <any>null;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : <any>null;
            this.postalDistrict = _data["postalDistrict"] !== undefined ? _data["postalDistrict"] : <any>null;
        }
    }

    static fromJS(data: any): AddressResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddressResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressLine1"] = this.addressLine1 !== undefined ? this.addressLine1 : <any>null;
        data["addressLine2"] = this.addressLine2 !== undefined ? this.addressLine2 : <any>null;
        data["addressLine3"] = this.addressLine3 !== undefined ? this.addressLine3 : <any>null;
        data["addressLine4"] = this.addressLine4 !== undefined ? this.addressLine4 : <any>null;
        data["addressLine5"] = this.addressLine5 !== undefined ? this.addressLine5 : <any>null;
        data["administrativeAreaCode"] = this.administrativeAreaCode !== undefined ? this.administrativeAreaCode : <any>null;
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : <any>null;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : <any>null;
        data["postalDistrict"] = this.postalDistrict !== undefined ? this.postalDistrict : <any>null;
        return data;
    }
}

export interface IAddressResponse {
    addressLine1?: string | null;
    addressLine2?: string | null;
    addressLine3?: string | null;
    addressLine4?: string | null;
    addressLine5?: string | null;
    administrativeAreaCode?: string | null;
    countryCode?: string | null;
    postalCode?: string | null;
    postalDistrict?: string | null;
}

export class ResidentConditionResponse implements IResidentConditionResponse {
    id!: number;
    name!: string;
    groupName!: string;
    law!: string;
    status!: Status;
    currentLevel?: ConditionLevel | null;
    currentAssessment?: string | null;
    currentLevelDescription?: string | null;
    expectedLevel?: ConditionLevel | null;
    expectedAssessment?: string | null;
    expectedLevelDescription?: string | null;
    goals?: string | null;
    execution?: string | null;
    limitations?: string | null;

    constructor(data?: IResidentConditionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.groupName = _data["groupName"] !== undefined ? _data["groupName"] : <any>null;
            this.law = _data["law"] !== undefined ? _data["law"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.currentLevel = _data["currentLevel"] ? ConditionLevel.fromJS(_data["currentLevel"]) : <any>null;
            this.currentAssessment = _data["currentAssessment"] !== undefined ? _data["currentAssessment"] : <any>null;
            this.currentLevelDescription = _data["currentLevelDescription"] !== undefined ? _data["currentLevelDescription"] : <any>null;
            this.expectedLevel = _data["expectedLevel"] ? ConditionLevel.fromJS(_data["expectedLevel"]) : <any>null;
            this.expectedAssessment = _data["expectedAssessment"] !== undefined ? _data["expectedAssessment"] : <any>null;
            this.expectedLevelDescription = _data["expectedLevelDescription"] !== undefined ? _data["expectedLevelDescription"] : <any>null;
            this.goals = _data["goals"] !== undefined ? _data["goals"] : <any>null;
            this.execution = _data["execution"] !== undefined ? _data["execution"] : <any>null;
            this.limitations = _data["limitations"] !== undefined ? _data["limitations"] : <any>null;
        }
    }

    static fromJS(data: any): ResidentConditionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResidentConditionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["groupName"] = this.groupName !== undefined ? this.groupName : <any>null;
        data["law"] = this.law !== undefined ? this.law : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["currentLevel"] = this.currentLevel ? this.currentLevel.toJSON() : <any>null;
        data["currentAssessment"] = this.currentAssessment !== undefined ? this.currentAssessment : <any>null;
        data["currentLevelDescription"] = this.currentLevelDescription !== undefined ? this.currentLevelDescription : <any>null;
        data["expectedLevel"] = this.expectedLevel ? this.expectedLevel.toJSON() : <any>null;
        data["expectedAssessment"] = this.expectedAssessment !== undefined ? this.expectedAssessment : <any>null;
        data["expectedLevelDescription"] = this.expectedLevelDescription !== undefined ? this.expectedLevelDescription : <any>null;
        data["goals"] = this.goals !== undefined ? this.goals : <any>null;
        data["execution"] = this.execution !== undefined ? this.execution : <any>null;
        data["limitations"] = this.limitations !== undefined ? this.limitations : <any>null;
        return data;
    }
}

export interface IResidentConditionResponse {
    id: number;
    name: string;
    groupName: string;
    law: string;
    status: Status;
    currentLevel?: ConditionLevel | null;
    currentAssessment?: string | null;
    currentLevelDescription?: string | null;
    expectedLevel?: ConditionLevel | null;
    expectedAssessment?: string | null;
    expectedLevelDescription?: string | null;
    goals?: string | null;
    execution?: string | null;
    limitations?: string | null;
}

export enum Status {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
    POTENTIAL = "POTENTIAL",
    NOT_RELEVANT = "NOT_RELEVANT",
}

export class ConditionLevel implements IConditionLevel {
    name!: string;
    numericRepresentation?: number | null;

    constructor(data?: IConditionLevel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.numericRepresentation = _data["numericRepresentation"] !== undefined ? _data["numericRepresentation"] : <any>null;
        }
    }

    static fromJS(data: any): ConditionLevel {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionLevel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["numericRepresentation"] = this.numericRepresentation !== undefined ? this.numericRepresentation : <any>null;
        return data;
    }
}

export interface IConditionLevel {
    name: string;
    numericRepresentation?: number | null;
}

export class AdministrationResponse implements IAdministrationResponse {
    administrationId!: number;
    dosageQuantity!: number;
    latestPnAction!: LatestPnActionResponse;
    latestPnActionDateTime!: moment.Moment;
    reason?: string | null;
    effect?: string | null;
    measuredDate?: moment.Moment | null;
    controlledDate?: moment.Moment | null;
    handedOutDate?: moment.Moment | null;
    givenDate?: moment.Moment | null;
    cancelledDate?: moment.Moment | null;
    expirationDate?: moment.Moment | null;

    constructor(data?: IAdministrationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.administrationId = _data["administrationId"] !== undefined ? _data["administrationId"] : <any>null;
            this.dosageQuantity = _data["dosageQuantity"] !== undefined ? _data["dosageQuantity"] : <any>null;
            this.latestPnAction = _data["latestPnAction"] !== undefined ? _data["latestPnAction"] : <any>null;
            this.latestPnActionDateTime = _data["latestPnActionDateTime"] ? moment(_data["latestPnActionDateTime"].toString()) : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
            this.effect = _data["effect"] !== undefined ? _data["effect"] : <any>null;
            this.measuredDate = _data["measuredDate"] ? moment(_data["measuredDate"].toString()) : <any>null;
            this.controlledDate = _data["controlledDate"] ? moment(_data["controlledDate"].toString()) : <any>null;
            this.handedOutDate = _data["handedOutDate"] ? moment(_data["handedOutDate"].toString()) : <any>null;
            this.givenDate = _data["givenDate"] ? moment(_data["givenDate"].toString()) : <any>null;
            this.cancelledDate = _data["cancelledDate"] ? moment(_data["cancelledDate"].toString()) : <any>null;
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): AdministrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdministrationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["administrationId"] = this.administrationId !== undefined ? this.administrationId : <any>null;
        data["dosageQuantity"] = this.dosageQuantity !== undefined ? this.dosageQuantity : <any>null;
        data["latestPnAction"] = this.latestPnAction !== undefined ? this.latestPnAction : <any>null;
        data["latestPnActionDateTime"] = this.latestPnActionDateTime ? this.latestPnActionDateTime.toISOString() : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        data["effect"] = this.effect !== undefined ? this.effect : <any>null;
        data["measuredDate"] = this.measuredDate ? this.measuredDate.toISOString() : <any>null;
        data["controlledDate"] = this.controlledDate ? this.controlledDate.toISOString() : <any>null;
        data["handedOutDate"] = this.handedOutDate ? this.handedOutDate.toISOString() : <any>null;
        data["givenDate"] = this.givenDate ? this.givenDate.toISOString() : <any>null;
        data["cancelledDate"] = this.cancelledDate ? this.cancelledDate.toISOString() : <any>null;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>null;
        return data;
    }
}

export interface IAdministrationResponse {
    administrationId: number;
    dosageQuantity: number;
    latestPnAction: LatestPnActionResponse;
    latestPnActionDateTime: moment.Moment;
    reason?: string | null;
    effect?: string | null;
    measuredDate?: moment.Moment | null;
    controlledDate?: moment.Moment | null;
    handedOutDate?: moment.Moment | null;
    givenDate?: moment.Moment | null;
    cancelledDate?: moment.Moment | null;
    expirationDate?: moment.Moment | null;
}

export enum LatestPnActionResponse {
    None = "None",
    Measured = "Measured",
    HandedOut = "HandedOut",
    Controlled = "Controlled",
    Cancelled = "Cancelled",
    Given = "Given",
}

export class AvailableActionResponse implements IAvailableActionResponse {
    id!: number;
    name?: string | null;

    constructor(data?: IAvailableActionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): AvailableActionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableActionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IAvailableActionResponse {
    id: number;
    name?: string | null;
}

export enum HttpStatusCode {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    Processing = "Processing",
    EarlyHints = "EarlyHints",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultiStatus = "MultiStatus",
    AlreadyReported = "AlreadyReported",
    IMUsed = "IMUsed",
    MultipleChoices = "MultipleChoices",
    Ambiguous = "MultipleChoices",
    MovedPermanently = "MovedPermanently",
    Moved = "MovedPermanently",
    Found = "Found",
    Redirect = "Found",
    SeeOther = "SeeOther",
    RedirectMethod = "SeeOther",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "RedirectKeepVerb",
    RedirectKeepVerb = "RedirectKeepVerb",
    PermanentRedirect = "PermanentRedirect",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    MisdirectedRequest = "MisdirectedRequest",
    UnprocessableEntity = "UnprocessableEntity",
    UnprocessableContent = "UnprocessableEntity",
    Locked = "Locked",
    FailedDependency = "FailedDependency",
    UpgradeRequired = "UpgradeRequired",
    PreconditionRequired = "PreconditionRequired",
    TooManyRequests = "TooManyRequests",
    RequestHeaderFieldsTooLarge = "RequestHeaderFieldsTooLarge",
    UnavailableForLegalReasons = "UnavailableForLegalReasons",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
    VariantAlsoNegotiates = "VariantAlsoNegotiates",
    InsufficientStorage = "InsufficientStorage",
    LoopDetected = "LoopDetected",
    NotExtended = "NotExtended",
    NetworkAuthenticationRequired = "NetworkAuthenticationRequired",
}

export class GiveOrHandoutAdministrationRequest implements IGiveOrHandoutAdministrationRequest {
    prescriptionId!: number;
    controlDate?: moment.Moment | null;
    effect?: string | null;
    effectRegistrationEndTime!: moment.Moment;
    effectRegistrationStartTime!: moment.Moment;
    expirationDate?: moment.Moment | null;
    giveDate!: moment.Moment;
    reason?: string | null;

    constructor(data?: IGiveOrHandoutAdministrationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionId = _data["prescriptionId"] !== undefined ? _data["prescriptionId"] : <any>null;
            this.controlDate = _data["controlDate"] ? moment(_data["controlDate"].toString()) : <any>null;
            this.effect = _data["effect"] !== undefined ? _data["effect"] : <any>null;
            this.effectRegistrationEndTime = _data["effectRegistrationEndTime"] ? moment(_data["effectRegistrationEndTime"].toString()) : <any>null;
            this.effectRegistrationStartTime = _data["effectRegistrationStartTime"] ? moment(_data["effectRegistrationStartTime"].toString()) : <any>null;
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>null;
            this.giveDate = _data["giveDate"] ? moment(_data["giveDate"].toString()) : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
        }
    }

    static fromJS(data: any): GiveOrHandoutAdministrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GiveOrHandoutAdministrationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionId"] = this.prescriptionId !== undefined ? this.prescriptionId : <any>null;
        data["controlDate"] = this.controlDate ? this.controlDate.toISOString() : <any>null;
        data["effect"] = this.effect !== undefined ? this.effect : <any>null;
        data["effectRegistrationEndTime"] = this.effectRegistrationEndTime ? this.effectRegistrationEndTime.toISOString() : <any>null;
        data["effectRegistrationStartTime"] = this.effectRegistrationStartTime ? this.effectRegistrationStartTime.toISOString() : <any>null;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>null;
        data["giveDate"] = this.giveDate ? this.giveDate.toISOString() : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        return data;
    }
}

export interface IGiveOrHandoutAdministrationRequest {
    prescriptionId: number;
    controlDate?: moment.Moment | null;
    effect?: string | null;
    effectRegistrationEndTime: moment.Moment;
    effectRegistrationStartTime: moment.Moment;
    expirationDate?: moment.Moment | null;
    giveDate: moment.Moment;
    reason?: string | null;
}

export class UpdateAdministrationRequest implements IUpdateAdministrationRequest {
    effect?: string | null;

    constructor(data?: IUpdateAdministrationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.effect = _data["effect"] !== undefined ? _data["effect"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateAdministrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAdministrationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["effect"] = this.effect !== undefined ? this.effect : <any>null;
        return data;
    }
}

export interface IUpdateAdministrationRequest {
    effect?: string | null;
}

export class CancelRequest implements ICancelRequest {
    expirationDate?: moment.Moment | null;
    cancellationDate!: moment.Moment;

    constructor(data?: ICancelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>null;
            this.cancellationDate = _data["cancellationDate"] ? moment(_data["cancellationDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): CancelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CancelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>null;
        data["cancellationDate"] = this.cancellationDate ? this.cancellationDate.toISOString() : <any>null;
        return data;
    }
}

export interface ICancelRequest {
    expirationDate?: moment.Moment | null;
    cancellationDate: moment.Moment;
}

export class AdministrationDetailsResponse implements IAdministrationDetailsResponse {
    latestEffect?: PnActionHistoryResponse | null;
    latestAction?: PnActionHistoryResponse | null;

    constructor(data?: IAdministrationDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latestEffect = _data["latestEffect"] ? PnActionHistoryResponse.fromJS(_data["latestEffect"]) : <any>null;
            this.latestAction = _data["latestAction"] ? PnActionHistoryResponse.fromJS(_data["latestAction"]) : <any>null;
        }
    }

    static fromJS(data: any): AdministrationDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdministrationDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latestEffect"] = this.latestEffect ? this.latestEffect.toJSON() : <any>null;
        data["latestAction"] = this.latestAction ? this.latestAction.toJSON() : <any>null;
        return data;
    }
}

export interface IAdministrationDetailsResponse {
    latestEffect?: PnActionHistoryResponse | null;
    latestAction?: PnActionHistoryResponse | null;
}

export class PnActionHistoryResponse implements IPnActionHistoryResponse {
    nexusEmployeeName?: string | null;
    timeStamp!: moment.Moment;
    isSekoiaEmployeeLatest!: boolean;
    sekoiaEmployeeId?: string | null;

    constructor(data?: IPnActionHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nexusEmployeeName = _data["nexusEmployeeName"] !== undefined ? _data["nexusEmployeeName"] : <any>null;
            this.timeStamp = _data["timeStamp"] ? moment(_data["timeStamp"].toString()) : <any>null;
            this.isSekoiaEmployeeLatest = _data["isSekoiaEmployeeLatest"] !== undefined ? _data["isSekoiaEmployeeLatest"] : <any>null;
            this.sekoiaEmployeeId = _data["sekoiaEmployeeId"] !== undefined ? _data["sekoiaEmployeeId"] : <any>null;
        }
    }

    static fromJS(data: any): PnActionHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnActionHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nexusEmployeeName"] = this.nexusEmployeeName !== undefined ? this.nexusEmployeeName : <any>null;
        data["timeStamp"] = this.timeStamp ? this.timeStamp.toISOString() : <any>null;
        data["isSekoiaEmployeeLatest"] = this.isSekoiaEmployeeLatest !== undefined ? this.isSekoiaEmployeeLatest : <any>null;
        data["sekoiaEmployeeId"] = this.sekoiaEmployeeId !== undefined ? this.sekoiaEmployeeId : <any>null;
        return data;
    }
}

export interface IPnActionHistoryResponse {
    nexusEmployeeName?: string | null;
    timeStamp: moment.Moment;
    isSekoiaEmployeeLatest: boolean;
    sekoiaEmployeeId?: string | null;
}

export class StatesAndEffectsResponse implements IStatesAndEffectsResponse {
    pnAdministrationsEndStateActionWithEffectRegistrations?: PnAdministrationEndStateActionWithEffectRegistrationResponse[] | null;
    residentId?: string | null;

    constructor(data?: IStatesAndEffectsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pnAdministrationsEndStateActionWithEffectRegistrations"])) {
                this.pnAdministrationsEndStateActionWithEffectRegistrations = [] as any;
                for (let item of _data["pnAdministrationsEndStateActionWithEffectRegistrations"])
                    this.pnAdministrationsEndStateActionWithEffectRegistrations!.push(PnAdministrationEndStateActionWithEffectRegistrationResponse.fromJS(item));
            }
            else {
                this.pnAdministrationsEndStateActionWithEffectRegistrations = <any>null;
            }
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : <any>null;
        }
    }

    static fromJS(data: any): StatesAndEffectsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatesAndEffectsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pnAdministrationsEndStateActionWithEffectRegistrations)) {
            data["pnAdministrationsEndStateActionWithEffectRegistrations"] = [];
            for (let item of this.pnAdministrationsEndStateActionWithEffectRegistrations)
                data["pnAdministrationsEndStateActionWithEffectRegistrations"].push(item ? item.toJSON() : <any>null);
        }
        data["residentId"] = this.residentId !== undefined ? this.residentId : <any>null;
        return data;
    }
}

export interface IStatesAndEffectsResponse {
    pnAdministrationsEndStateActionWithEffectRegistrations?: PnAdministrationEndStateActionWithEffectRegistrationResponse[] | null;
    residentId?: string | null;
}

export class PnAdministrationEndStateActionWithEffectRegistrationResponse implements IPnAdministrationEndStateActionWithEffectRegistrationResponse {
    administrationId!: number;
    effect?: string | null;
    effectRegistration?: EffectRegistrationResponse | null;
    latestPnAction!: LatestPnAction;
    latestPnActionDateTimeExceptCancellation!: moment.Moment;
    prescriptionId!: number;
    prescriptionName?: string | null;
    isEffectRegistrationInActiveResidentStatusInterval!: boolean;

    constructor(data?: IPnAdministrationEndStateActionWithEffectRegistrationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.administrationId = _data["administrationId"] !== undefined ? _data["administrationId"] : <any>null;
            this.effect = _data["effect"] !== undefined ? _data["effect"] : <any>null;
            this.effectRegistration = _data["effectRegistration"] ? EffectRegistrationResponse.fromJS(_data["effectRegistration"]) : <any>null;
            this.latestPnAction = _data["latestPnAction"] !== undefined ? _data["latestPnAction"] : <any>null;
            this.latestPnActionDateTimeExceptCancellation = _data["latestPnActionDateTimeExceptCancellation"] ? moment(_data["latestPnActionDateTimeExceptCancellation"].toString()) : <any>null;
            this.prescriptionId = _data["prescriptionId"] !== undefined ? _data["prescriptionId"] : <any>null;
            this.prescriptionName = _data["prescriptionName"] !== undefined ? _data["prescriptionName"] : <any>null;
            this.isEffectRegistrationInActiveResidentStatusInterval = _data["isEffectRegistrationInActiveResidentStatusInterval"] !== undefined ? _data["isEffectRegistrationInActiveResidentStatusInterval"] : <any>null;
        }
    }

    static fromJS(data: any): PnAdministrationEndStateActionWithEffectRegistrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnAdministrationEndStateActionWithEffectRegistrationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["administrationId"] = this.administrationId !== undefined ? this.administrationId : <any>null;
        data["effect"] = this.effect !== undefined ? this.effect : <any>null;
        data["effectRegistration"] = this.effectRegistration ? this.effectRegistration.toJSON() : <any>null;
        data["latestPnAction"] = this.latestPnAction !== undefined ? this.latestPnAction : <any>null;
        data["latestPnActionDateTimeExceptCancellation"] = this.latestPnActionDateTimeExceptCancellation ? this.latestPnActionDateTimeExceptCancellation.toISOString() : <any>null;
        data["prescriptionId"] = this.prescriptionId !== undefined ? this.prescriptionId : <any>null;
        data["prescriptionName"] = this.prescriptionName !== undefined ? this.prescriptionName : <any>null;
        data["isEffectRegistrationInActiveResidentStatusInterval"] = this.isEffectRegistrationInActiveResidentStatusInterval !== undefined ? this.isEffectRegistrationInActiveResidentStatusInterval : <any>null;
        return data;
    }
}

export interface IPnAdministrationEndStateActionWithEffectRegistrationResponse {
    administrationId: number;
    effect?: string | null;
    effectRegistration?: EffectRegistrationResponse | null;
    latestPnAction: LatestPnAction;
    latestPnActionDateTimeExceptCancellation: moment.Moment;
    prescriptionId: number;
    prescriptionName?: string | null;
    isEffectRegistrationInActiveResidentStatusInterval: boolean;
}

export class EffectRegistrationResponse implements IEffectRegistrationResponse {
    endTime!: moment.Moment;
    startTime!: moment.Moment;

    constructor(data?: IEffectRegistrationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>null;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): EffectRegistrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EffectRegistrationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        return data;
    }
}

export interface IEffectRegistrationResponse {
    endTime: moment.Moment;
    startTime: moment.Moment;
}

export enum LatestPnAction {
    None = "None",
    Measured = "Measured",
    HandedOut = "HandedOut",
    Controlled = "Controlled",
    Cancelled = "Cancelled",
    Given = "Given",
    Created = "Created",
}

export class GroupedPrescriptionResponse implements IGroupedPrescriptionResponse {
    pn?: PrescriptionResponse[] | null;
    pnSelfManaged?: PrescriptionResponse[] | null;

    constructor(data?: IGroupedPrescriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pn"])) {
                this.pn = [] as any;
                for (let item of _data["pn"])
                    this.pn!.push(PrescriptionResponse.fromJS(item));
            }
            else {
                this.pn = <any>null;
            }
            if (Array.isArray(_data["pnSelfManaged"])) {
                this.pnSelfManaged = [] as any;
                for (let item of _data["pnSelfManaged"])
                    this.pnSelfManaged!.push(PrescriptionResponse.fromJS(item));
            }
            else {
                this.pnSelfManaged = <any>null;
            }
        }
    }

    static fromJS(data: any): GroupedPrescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GroupedPrescriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pn)) {
            data["pn"] = [];
            for (let item of this.pn)
                data["pn"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.pnSelfManaged)) {
            data["pnSelfManaged"] = [];
            for (let item of this.pnSelfManaged)
                data["pnSelfManaged"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IGroupedPrescriptionResponse {
    pn?: PrescriptionResponse[] | null;
    pnSelfManaged?: PrescriptionResponse[] | null;
}

export class PrescriptionResponse implements IPrescriptionResponse {
    id!: number;
    activeIngredient?: string | null;
    dosageText?: string | null;
    dosageUnit?: string | null;
    drugForm?: string | null;
    drugPackageSizeTitle?: string | null;
    indicationText?: string | null;
    name?: string | null;
    pauseStart?: moment.Moment | null;
    pauseEnd?: moment.Moment | null;
    prescriberDisplayName?: string | null;
    prescriberTitle?: string | null;
    remarks?: string | null;
    sideEffects?: string | null;
    strength?: string | null;
    treatmentEndDate?: moment.Moment | null;
    treatmentStartDate?: moment.Moment | null;
    workflowDescription?: string | null;
    pnMaxDosageQuantity!: number;
    pnMaxDosageStateMessage?: string | null;

    constructor(data?: IPrescriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.activeIngredient = _data["activeIngredient"] !== undefined ? _data["activeIngredient"] : <any>null;
            this.dosageText = _data["dosageText"] !== undefined ? _data["dosageText"] : <any>null;
            this.dosageUnit = _data["dosageUnit"] !== undefined ? _data["dosageUnit"] : <any>null;
            this.drugForm = _data["drugForm"] !== undefined ? _data["drugForm"] : <any>null;
            this.drugPackageSizeTitle = _data["drugPackageSizeTitle"] !== undefined ? _data["drugPackageSizeTitle"] : <any>null;
            this.indicationText = _data["indicationText"] !== undefined ? _data["indicationText"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.pauseStart = _data["pauseStart"] ? moment(_data["pauseStart"].toString()) : <any>null;
            this.pauseEnd = _data["pauseEnd"] ? moment(_data["pauseEnd"].toString()) : <any>null;
            this.prescriberDisplayName = _data["prescriberDisplayName"] !== undefined ? _data["prescriberDisplayName"] : <any>null;
            this.prescriberTitle = _data["prescriberTitle"] !== undefined ? _data["prescriberTitle"] : <any>null;
            this.remarks = _data["remarks"] !== undefined ? _data["remarks"] : <any>null;
            this.sideEffects = _data["sideEffects"] !== undefined ? _data["sideEffects"] : <any>null;
            this.strength = _data["strength"] !== undefined ? _data["strength"] : <any>null;
            this.treatmentEndDate = _data["treatmentEndDate"] ? moment(_data["treatmentEndDate"].toString()) : <any>null;
            this.treatmentStartDate = _data["treatmentStartDate"] ? moment(_data["treatmentStartDate"].toString()) : <any>null;
            this.workflowDescription = _data["workflowDescription"] !== undefined ? _data["workflowDescription"] : <any>null;
            this.pnMaxDosageQuantity = _data["pnMaxDosageQuantity"] !== undefined ? _data["pnMaxDosageQuantity"] : <any>null;
            this.pnMaxDosageStateMessage = _data["pnMaxDosageStateMessage"] !== undefined ? _data["pnMaxDosageStateMessage"] : <any>null;
        }
    }

    static fromJS(data: any): PrescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["activeIngredient"] = this.activeIngredient !== undefined ? this.activeIngredient : <any>null;
        data["dosageText"] = this.dosageText !== undefined ? this.dosageText : <any>null;
        data["dosageUnit"] = this.dosageUnit !== undefined ? this.dosageUnit : <any>null;
        data["drugForm"] = this.drugForm !== undefined ? this.drugForm : <any>null;
        data["drugPackageSizeTitle"] = this.drugPackageSizeTitle !== undefined ? this.drugPackageSizeTitle : <any>null;
        data["indicationText"] = this.indicationText !== undefined ? this.indicationText : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["pauseStart"] = this.pauseStart ? this.pauseStart.toISOString() : <any>null;
        data["pauseEnd"] = this.pauseEnd ? this.pauseEnd.toISOString() : <any>null;
        data["prescriberDisplayName"] = this.prescriberDisplayName !== undefined ? this.prescriberDisplayName : <any>null;
        data["prescriberTitle"] = this.prescriberTitle !== undefined ? this.prescriberTitle : <any>null;
        data["remarks"] = this.remarks !== undefined ? this.remarks : <any>null;
        data["sideEffects"] = this.sideEffects !== undefined ? this.sideEffects : <any>null;
        data["strength"] = this.strength !== undefined ? this.strength : <any>null;
        data["treatmentEndDate"] = this.treatmentEndDate ? this.treatmentEndDate.format('YYYY-MM-DD') : <any>null;
        data["treatmentStartDate"] = this.treatmentStartDate ? this.treatmentStartDate.format('YYYY-MM-DD') : <any>null;
        data["workflowDescription"] = this.workflowDescription !== undefined ? this.workflowDescription : <any>null;
        data["pnMaxDosageQuantity"] = this.pnMaxDosageQuantity !== undefined ? this.pnMaxDosageQuantity : <any>null;
        data["pnMaxDosageStateMessage"] = this.pnMaxDosageStateMessage !== undefined ? this.pnMaxDosageStateMessage : <any>null;
        return data;
    }
}

export interface IPrescriptionResponse {
    id: number;
    activeIngredient?: string | null;
    dosageText?: string | null;
    dosageUnit?: string | null;
    drugForm?: string | null;
    drugPackageSizeTitle?: string | null;
    indicationText?: string | null;
    name?: string | null;
    pauseStart?: moment.Moment | null;
    pauseEnd?: moment.Moment | null;
    prescriberDisplayName?: string | null;
    prescriberTitle?: string | null;
    remarks?: string | null;
    sideEffects?: string | null;
    strength?: string | null;
    treatmentEndDate?: moment.Moment | null;
    treatmentStartDate?: moment.Moment | null;
    workflowDescription?: string | null;
    pnMaxDosageQuantity: number;
    pnMaxDosageStateMessage?: string | null;
}

export class MeasureRequest implements IMeasureRequest {
    dosageQuantity!: number;
    expirationDate?: moment.Moment | null;
    measureDate!: moment.Moment;

    constructor(data?: IMeasureRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dosageQuantity = _data["dosageQuantity"] !== undefined ? _data["dosageQuantity"] : <any>null;
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>null;
            this.measureDate = _data["measureDate"] ? moment(_data["measureDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): MeasureRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MeasureRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dosageQuantity"] = this.dosageQuantity !== undefined ? this.dosageQuantity : <any>null;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>null;
        data["measureDate"] = this.measureDate ? this.measureDate.toISOString() : <any>null;
        return data;
    }
}

export interface IMeasureRequest {
    dosageQuantity: number;
    expirationDate?: moment.Moment | null;
    measureDate: moment.Moment;
}

export class ControlRequest implements IControlRequest {
    dosageQuantity!: number;
    expirationDate?: moment.Moment | null;
    measureDate!: moment.Moment;
    controlDate!: moment.Moment;

    constructor(data?: IControlRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dosageQuantity = _data["dosageQuantity"] !== undefined ? _data["dosageQuantity"] : <any>null;
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>null;
            this.measureDate = _data["measureDate"] ? moment(_data["measureDate"].toString()) : <any>null;
            this.controlDate = _data["controlDate"] ? moment(_data["controlDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): ControlRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ControlRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dosageQuantity"] = this.dosageQuantity !== undefined ? this.dosageQuantity : <any>null;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>null;
        data["measureDate"] = this.measureDate ? this.measureDate.toISOString() : <any>null;
        data["controlDate"] = this.controlDate ? this.controlDate.toISOString() : <any>null;
        return data;
    }
}

export interface IControlRequest {
    dosageQuantity: number;
    expirationDate?: moment.Moment | null;
    measureDate: moment.Moment;
    controlDate: moment.Moment;
}

export class GiveRequest implements IGiveRequest {
    controlDate!: moment.Moment;
    dosageQuantity!: number;
    effect?: string | null;
    effectRegistrationEndTime!: moment.Moment;
    effectRegistrationStartTime!: moment.Moment;
    expirationDate?: moment.Moment | null;
    giveDate!: moment.Moment;
    measureDate!: moment.Moment;
    reason?: string | null;

    constructor(data?: IGiveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.controlDate = _data["controlDate"] ? moment(_data["controlDate"].toString()) : <any>null;
            this.dosageQuantity = _data["dosageQuantity"] !== undefined ? _data["dosageQuantity"] : <any>null;
            this.effect = _data["effect"] !== undefined ? _data["effect"] : <any>null;
            this.effectRegistrationEndTime = _data["effectRegistrationEndTime"] ? moment(_data["effectRegistrationEndTime"].toString()) : <any>null;
            this.effectRegistrationStartTime = _data["effectRegistrationStartTime"] ? moment(_data["effectRegistrationStartTime"].toString()) : <any>null;
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>null;
            this.giveDate = _data["giveDate"] ? moment(_data["giveDate"].toString()) : <any>null;
            this.measureDate = _data["measureDate"] ? moment(_data["measureDate"].toString()) : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
        }
    }

    static fromJS(data: any): GiveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GiveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["controlDate"] = this.controlDate ? this.controlDate.toISOString() : <any>null;
        data["dosageQuantity"] = this.dosageQuantity !== undefined ? this.dosageQuantity : <any>null;
        data["effect"] = this.effect !== undefined ? this.effect : <any>null;
        data["effectRegistrationEndTime"] = this.effectRegistrationEndTime ? this.effectRegistrationEndTime.toISOString() : <any>null;
        data["effectRegistrationStartTime"] = this.effectRegistrationStartTime ? this.effectRegistrationStartTime.toISOString() : <any>null;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>null;
        data["giveDate"] = this.giveDate ? this.giveDate.toISOString() : <any>null;
        data["measureDate"] = this.measureDate ? this.measureDate.toISOString() : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        return data;
    }
}

export interface IGiveRequest {
    controlDate: moment.Moment;
    dosageQuantity: number;
    effect?: string | null;
    effectRegistrationEndTime: moment.Moment;
    effectRegistrationStartTime: moment.Moment;
    expirationDate?: moment.Moment | null;
    giveDate: moment.Moment;
    measureDate: moment.Moment;
    reason?: string | null;
}

export class HandOutRequest implements IHandOutRequest {
    controlDate!: moment.Moment;
    dosageQuantity!: number;
    effectRegistrationEndTime!: moment.Moment;
    effectRegistrationStartTime!: moment.Moment;
    expirationDate?: moment.Moment | null;
    handOutDate!: moment.Moment;
    measureDate!: moment.Moment;
    reason?: string | null;
    effect?: string | null;

    constructor(data?: IHandOutRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.controlDate = _data["controlDate"] ? moment(_data["controlDate"].toString()) : <any>null;
            this.dosageQuantity = _data["dosageQuantity"] !== undefined ? _data["dosageQuantity"] : <any>null;
            this.effectRegistrationEndTime = _data["effectRegistrationEndTime"] ? moment(_data["effectRegistrationEndTime"].toString()) : <any>null;
            this.effectRegistrationStartTime = _data["effectRegistrationStartTime"] ? moment(_data["effectRegistrationStartTime"].toString()) : <any>null;
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>null;
            this.handOutDate = _data["handOutDate"] ? moment(_data["handOutDate"].toString()) : <any>null;
            this.measureDate = _data["measureDate"] ? moment(_data["measureDate"].toString()) : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
            this.effect = _data["effect"] !== undefined ? _data["effect"] : <any>null;
        }
    }

    static fromJS(data: any): HandOutRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HandOutRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["controlDate"] = this.controlDate ? this.controlDate.toISOString() : <any>null;
        data["dosageQuantity"] = this.dosageQuantity !== undefined ? this.dosageQuantity : <any>null;
        data["effectRegistrationEndTime"] = this.effectRegistrationEndTime ? this.effectRegistrationEndTime.toISOString() : <any>null;
        data["effectRegistrationStartTime"] = this.effectRegistrationStartTime ? this.effectRegistrationStartTime.toISOString() : <any>null;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>null;
        data["handOutDate"] = this.handOutDate ? this.handOutDate.toISOString() : <any>null;
        data["measureDate"] = this.measureDate ? this.measureDate.toISOString() : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        data["effect"] = this.effect !== undefined ? this.effect : <any>null;
        return data;
    }
}

export interface IHandOutRequest {
    controlDate: moment.Moment;
    dosageQuantity: number;
    effectRegistrationEndTime: moment.Moment;
    effectRegistrationStartTime: moment.Moment;
    expirationDate?: moment.Moment | null;
    handOutDate: moment.Moment;
    measureDate: moment.Moment;
    reason?: string | null;
    effect?: string | null;
}

export class HandlingsanvisningTitleAndIdResponse implements IHandlingsanvisningTitleAndIdResponse {
    id?: string | null;
    title?: string | null;
    secondaryTitle?: string | null;

    constructor(data?: IHandlingsanvisningTitleAndIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.secondaryTitle = _data["secondaryTitle"] !== undefined ? _data["secondaryTitle"] : <any>null;
        }
    }

    static fromJS(data: any): HandlingsanvisningTitleAndIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HandlingsanvisningTitleAndIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["secondaryTitle"] = this.secondaryTitle !== undefined ? this.secondaryTitle : <any>null;
        return data;
    }
}

export interface IHandlingsanvisningTitleAndIdResponse {
    id?: string | null;
    title?: string | null;
    secondaryTitle?: string | null;
}

export class PlanResponse implements IPlanResponse {
    description?: string | null;
    id?: string | null;
    name?: string | null;
    references?: Reference[] | null;

    constructor(data?: IPlanResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["references"])) {
                this.references = [] as any;
                for (let item of _data["references"])
                    this.references!.push(Reference.fromJS(item));
            }
            else {
                this.references = <any>null;
            }
        }
    }

    static fromJS(data: any): PlanResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlanResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.references)) {
            data["references"] = [];
            for (let item of this.references)
                data["references"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPlanResponse {
    description?: string | null;
    id?: string | null;
    name?: string | null;
    references?: Reference[] | null;
}

export class Reference implements IReference {
    id?: string | null;
    title?: string | null;

    constructor(data?: IReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): Reference {
        data = typeof data === 'object' ? data : {};
        let result = new Reference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data;
    }
}

export interface IReference {
    id?: string | null;
    title?: string | null;
}

export class PlanReferencesResponse implements IPlanReferencesResponse {
    schemeName?: string | null;
    id?: string | null;
    items?: SchemeItemDto[] | null;
    observationTime!: moment.Moment;
    title?: string | null;

    constructor(data?: IPlanReferencesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.schemeName = _data["schemeName"] !== undefined ? _data["schemeName"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SchemeItemDto.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
            this.observationTime = _data["observationTime"] ? moment(_data["observationTime"].toString()) : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): PlanReferencesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlanReferencesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schemeName"] = this.schemeName !== undefined ? this.schemeName : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>null);
        }
        data["observationTime"] = this.observationTime ? this.observationTime.toISOString() : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data;
    }
}

export interface IPlanReferencesResponse {
    schemeName?: string | null;
    id?: string | null;
    items?: SchemeItemDto[] | null;
    observationTime: moment.Moment;
    title?: string | null;
}

export class SchemeItemDto implements ISchemeItemDto {
    id?: string | null;
    label?: string | null;
    value?: SchemeItemValueDto | null;
    valueAsString?: string | null;
    values?: SchemeItemValueDto[] | null;

    constructor(data?: ISchemeItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.value = _data["value"] ? SchemeItemValueDto.fromJS(_data["value"]) : <any>null;
            this.valueAsString = _data["valueAsString"] !== undefined ? _data["valueAsString"] : <any>null;
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(SchemeItemValueDto.fromJS(item));
            }
            else {
                this.values = <any>null;
            }
        }
    }

    static fromJS(data: any): SchemeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SchemeItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["value"] = this.value ? this.value.toJSON() : <any>null;
        data["valueAsString"] = this.valueAsString !== undefined ? this.valueAsString : <any>null;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface ISchemeItemDto {
    id?: string | null;
    label?: string | null;
    value?: SchemeItemValueDto | null;
    valueAsString?: string | null;
    values?: SchemeItemValueDto[] | null;
}

export class SchemeItemValueDto implements ISchemeItemValueDto {
    id!: number;
    name?: string | null;

    constructor(data?: ISchemeItemValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): SchemeItemValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new SchemeItemValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface ISchemeItemValueDto {
    id: number;
    name?: string | null;
}

export class VumProblemResponse implements IVumProblemResponse {
    id!: number;
    name?: string | null;
    primarySubTheme?: string | null;
    dueDate!: moment.Moment;
    subGoals?: VumSubGoalResponse[] | null;
    grants?: VumGrantResponse[] | null;

    constructor(data?: IVumProblemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.primarySubTheme = _data["primarySubTheme"] !== undefined ? _data["primarySubTheme"] : <any>null;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>null;
            if (Array.isArray(_data["subGoals"])) {
                this.subGoals = [] as any;
                for (let item of _data["subGoals"])
                    this.subGoals!.push(VumSubGoalResponse.fromJS(item));
            }
            else {
                this.subGoals = <any>null;
            }
            if (Array.isArray(_data["grants"])) {
                this.grants = [] as any;
                for (let item of _data["grants"])
                    this.grants!.push(VumGrantResponse.fromJS(item));
            }
            else {
                this.grants = <any>null;
            }
        }
    }

    static fromJS(data: any): VumProblemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VumProblemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["primarySubTheme"] = this.primarySubTheme !== undefined ? this.primarySubTheme : <any>null;
        data["dueDate"] = this.dueDate ? this.dueDate.format('YYYY-MM-DD') : <any>null;
        if (Array.isArray(this.subGoals)) {
            data["subGoals"] = [];
            for (let item of this.subGoals)
                data["subGoals"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.grants)) {
            data["grants"] = [];
            for (let item of this.grants)
                data["grants"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IVumProblemResponse {
    id: number;
    name?: string | null;
    primarySubTheme?: string | null;
    dueDate: moment.Moment;
    subGoals?: VumSubGoalResponse[] | null;
    grants?: VumGrantResponse[] | null;
}

export class VumSubGoalResponse implements IVumSubGoalResponse {
    id!: number;
    name?: string | null;
    dueDate!: moment.Moment;

    constructor(data?: IVumSubGoalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): VumSubGoalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VumSubGoalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["dueDate"] = this.dueDate ? this.dueDate.format('YYYY-MM-DD') : <any>null;
        return data;
    }
}

export interface IVumSubGoalResponse {
    id: number;
    name?: string | null;
    dueDate: moment.Moment;
}

export class VumGrantResponse implements IVumGrantResponse {
    name?: string | null;
    id!: number;
    additionalInfo?: AdditionalInfoBaseResponse[] | null;

    constructor(data?: IVumGrantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            if (Array.isArray(_data["additionalInfo"])) {
                this.additionalInfo = [] as any;
                for (let item of _data["additionalInfo"])
                    this.additionalInfo!.push(AdditionalInfoBaseResponse.fromJS(item));
            }
            else {
                this.additionalInfo = <any>null;
            }
        }
    }

    static fromJS(data: any): VumGrantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VumGrantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        if (Array.isArray(this.additionalInfo)) {
            data["additionalInfo"] = [];
            for (let item of this.additionalInfo)
                data["additionalInfo"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IVumGrantResponse {
    name?: string | null;
    id: number;
    additionalInfo?: AdditionalInfoBaseResponse[] | null;
}

export class AdditionalInfoBaseResponse implements IAdditionalInfoBaseResponse {

    protected _discriminator: string;

    constructor(data?: IAdditionalInfoBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "AdditionalInfoBaseResponse";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AdditionalInfoBaseResponse {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "AdditionalInfoColorResponse") {
            let result = new AdditionalInfoColorResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "AdditionalInfoKeyValueResponse") {
            let result = new AdditionalInfoKeyValueResponse();
            result.init(data);
            return result;
        }
        let result = new AdditionalInfoBaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["swagger_discriminator"] = this._discriminator;
        return data;
    }
}

export interface IAdditionalInfoBaseResponse {
}

export class AdditionalInfoColorResponse extends AdditionalInfoBaseResponse implements IAdditionalInfoColorResponse {
    color?: string | null;

    constructor(data?: IAdditionalInfoColorResponse) {
        super(data);
        this._discriminator = "AdditionalInfoColorResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.color = _data["color"] !== undefined ? _data["color"] : <any>null;
        }
    }

    static fromJS(data: any): AdditionalInfoColorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalInfoColorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color !== undefined ? this.color : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalInfoColorResponse extends IAdditionalInfoBaseResponse {
    color?: string | null;
}

export class AdditionalInfoKeyValueResponse extends AdditionalInfoBaseResponse implements IAdditionalInfoKeyValueResponse {
    key?: string | null;
    value?: string | null;

    constructor(data?: IAdditionalInfoKeyValueResponse) {
        super(data);
        this._discriminator = "AdditionalInfoKeyValueResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): AdditionalInfoKeyValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalInfoKeyValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAdditionalInfoKeyValueResponse extends IAdditionalInfoBaseResponse {
    key?: string | null;
    value?: string | null;
}

export class VumSubGoalDetailResponse implements IVumSubGoalDetailResponse {
    name?: string | null;
    id!: number;
    problemName?: string | null;
    problemTheme?: string | null;
    problemId!: number;
    actions?: VumSubGoalActionResponse[] | null;

    constructor(data?: IVumSubGoalDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.problemName = _data["problemName"] !== undefined ? _data["problemName"] : <any>null;
            this.problemTheme = _data["problemTheme"] !== undefined ? _data["problemTheme"] : <any>null;
            this.problemId = _data["problemId"] !== undefined ? _data["problemId"] : <any>null;
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(VumSubGoalActionResponse.fromJS(item));
            }
            else {
                this.actions = <any>null;
            }
        }
    }

    static fromJS(data: any): VumSubGoalDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VumSubGoalDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["problemName"] = this.problemName !== undefined ? this.problemName : <any>null;
        data["problemTheme"] = this.problemTheme !== undefined ? this.problemTheme : <any>null;
        data["problemId"] = this.problemId !== undefined ? this.problemId : <any>null;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IVumSubGoalDetailResponse {
    name?: string | null;
    id: number;
    problemName?: string | null;
    problemTheme?: string | null;
    problemId: number;
    actions?: VumSubGoalActionResponse[] | null;
}

export class VumSubGoalActionResponse implements IVumSubGoalActionResponse {
    name?: string | null;
    id!: number;
    elements?: VumActionBaseElementResponse[] | null;

    constructor(data?: IVumSubGoalActionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(VumActionBaseElementResponse.fromJS(item));
            }
            else {
                this.elements = <any>null;
            }
        }
    }

    static fromJS(data: any): VumSubGoalActionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VumSubGoalActionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IVumSubGoalActionResponse {
    name?: string | null;
    id: number;
    elements?: VumActionBaseElementResponse[] | null;
}

export class VumActionBaseElementResponse implements IVumActionBaseElementResponse {
    label?: string | null;
    type?: string | null;

    protected _discriminator: string;

    constructor(data?: IVumActionBaseElementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "VumActionBaseElementResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): VumActionBaseElementResponse {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "VumActionStringElementResponse") {
            let result = new VumActionStringElementResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "VumActionActionApproachElementResponse") {
            let result = new VumActionActionApproachElementResponse();
            result.init(data);
            return result;
        }
        let result = new VumActionBaseElementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["swagger_discriminator"] = this._discriminator;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}

export interface IVumActionBaseElementResponse {
    label?: string | null;
    type?: string | null;
}

export class VumActionStringElementResponse extends VumActionBaseElementResponse implements IVumActionStringElementResponse {
    value?: string | null;

    constructor(data?: IVumActionStringElementResponse) {
        super(data);
        this._discriminator = "VumActionStringElementResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): VumActionStringElementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VumActionStringElementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IVumActionStringElementResponse extends IVumActionBaseElementResponse {
    value?: string | null;
}

export class VumActionActionApproachElementResponse extends VumActionBaseElementResponse implements IVumActionActionApproachElementResponse {
    value?: VumActionApproachValue | null;

    constructor(data?: IVumActionActionApproachElementResponse) {
        super(data);
        this._discriminator = "VumActionActionApproachElementResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? VumActionApproachValue.fromJS(_data["value"]) : <any>null;
        }
    }

    static fromJS(data: any): VumActionActionApproachElementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VumActionActionApproachElementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IVumActionActionApproachElementResponse extends IVumActionBaseElementResponse {
    value?: VumActionApproachValue | null;
}

export class VumActionApproachValue implements IVumActionApproachValue {
    stringRepresentation?: string | null;

    constructor(data?: IVumActionApproachValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stringRepresentation = _data["stringRepresentation"] !== undefined ? _data["stringRepresentation"] : <any>null;
        }
    }

    static fromJS(data: any): VumActionApproachValue {
        data = typeof data === 'object' ? data : {};
        let result = new VumActionApproachValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stringRepresentation"] = this.stringRepresentation !== undefined ? this.stringRepresentation : <any>null;
        return data;
    }
}

export interface IVumActionApproachValue {
    stringRepresentation?: string | null;
}

export class SubGoalDetailResponse implements ISubGoalDetailResponse {
    name!: string;
    id!: number;
    problemName!: string;
    problemTheme!: string;
    problemId!: number;
    actions!: ActionResponse[];
    evaluations!: EvaluationResponse[];

    constructor(data?: ISubGoalDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.actions = [];
            this.evaluations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.problemName = _data["problemName"] !== undefined ? _data["problemName"] : <any>null;
            this.problemTheme = _data["problemTheme"] !== undefined ? _data["problemTheme"] : <any>null;
            this.problemId = _data["problemId"] !== undefined ? _data["problemId"] : <any>null;
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(ActionResponse.fromJS(item));
            }
            else {
                this.actions = <any>null;
            }
            if (Array.isArray(_data["evaluations"])) {
                this.evaluations = [] as any;
                for (let item of _data["evaluations"])
                    this.evaluations!.push(EvaluationResponse.fromJS(item));
            }
            else {
                this.evaluations = <any>null;
            }
        }
    }

    static fromJS(data: any): SubGoalDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubGoalDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["problemName"] = this.problemName !== undefined ? this.problemName : <any>null;
        data["problemTheme"] = this.problemTheme !== undefined ? this.problemTheme : <any>null;
        data["problemId"] = this.problemId !== undefined ? this.problemId : <any>null;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.evaluations)) {
            data["evaluations"] = [];
            for (let item of this.evaluations)
                data["evaluations"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface ISubGoalDetailResponse {
    name: string;
    id: number;
    problemName: string;
    problemTheme: string;
    problemId: number;
    actions: ActionResponse[];
    evaluations: EvaluationResponse[];
}

export class ActionResponse implements IActionResponse {
    name!: string;
    id!: number;
    elements!: FieldElementResponse[];

    constructor(data?: IActionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.elements = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(FieldElementResponse.fromJS(item));
            }
            else {
                this.elements = <any>null;
            }
        }
    }

    static fromJS(data: any): ActionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IActionResponse {
    name: string;
    id: number;
    elements: FieldElementResponse[];
}

export class FieldElementResponse implements IFieldElementResponse {
    elementType!: ElementType;
    hint?: string | null;
    label?: string | null;
    mandatoryFor?: WorkFlowStateType[] | null;
    rules?: RuleResponse[] | null;

    protected _discriminator: string;

    constructor(data?: IFieldElementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "FieldElementResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.elementType = _data["elementType"] !== undefined ? _data["elementType"] : <any>null;
            this.hint = _data["hint"] !== undefined ? _data["hint"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            if (Array.isArray(_data["mandatoryFor"])) {
                this.mandatoryFor = [] as any;
                for (let item of _data["mandatoryFor"])
                    this.mandatoryFor!.push(item);
            }
            else {
                this.mandatoryFor = <any>null;
            }
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(RuleResponse.fromJS(item));
            }
            else {
                this.rules = <any>null;
            }
        }
    }

    static fromJS(data: any): FieldElementResponse {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "DefinedValueElementResponse") {
            let result = new DefinedValueElementResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "StringValueElementResponse") {
            let result = new StringValueElementResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "DateTimeValueElementResponse") {
            let result = new DateTimeValueElementResponse();
            result.init(data);
            return result;
        }
        let result = new FieldElementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["swagger_discriminator"] = this._discriminator;
        data["elementType"] = this.elementType !== undefined ? this.elementType : <any>null;
        data["hint"] = this.hint !== undefined ? this.hint : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        if (Array.isArray(this.mandatoryFor)) {
            data["mandatoryFor"] = [];
            for (let item of this.mandatoryFor)
                data["mandatoryFor"].push(item);
        }
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IFieldElementResponse {
    elementType: ElementType;
    hint?: string | null;
    label?: string | null;
    mandatoryFor?: WorkFlowStateType[] | null;
    rules?: RuleResponse[] | null;
}

export enum ElementType {
    EvaluationDate = "EvaluationDate",
    ActionDateTime = "ActionDateTime",
    EvaluationDescription = "EvaluationDescription",
    Title = "Title",
    CitizenResponsibility = "CitizenResponsibility",
    EmployeeResponsibility = "EmployeeResponsibility",
    DetailedApproach = "DetailedApproach",
    RelativeResponsibility = "RelativeResponsibility",
    Notes = "Notes",
    ActionCustomApproachMethod = "ActionCustomApproachMethod",
    ActionCustomMethod = "ActionCustomMethod",
    EvaluationScore = "EvaluationScore",
    ActionApproachMethod = "ActionApproachMethod",
    TherapeuticMethod = "TherapeuticMethod",
    TreatmentMethod = "TreatmentMethod",
    SocialEducationMethod = "SocialEducationMethod",
    ConversationMethod = "ConversationMethod",
}

export enum WorkFlowStateType {
    ACTIVE = "ACTIVE",
    DRAFT = "DRAFT",
    CLOSED = "CLOSED",
    DELETED = "DELETED",
}

export abstract class RuleResponse implements IRuleResponse {
    type!: RuleType;

    protected _discriminator: string;

    constructor(data?: IRuleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "RuleResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): RuleResponse {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "MaxLengthRuleResponse") {
            let result = new MaxLengthRuleResponse();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'RuleResponse' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["swagger_discriminator"] = this._discriminator;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}

export interface IRuleResponse {
    type: RuleType;
}

export enum RuleType {
    MaxLength = "MaxLength",
    DateNotInFuture = "DateNotInFuture",
    DateTimeNotInFuture = "DateTimeNotInFuture",
    DateNotBefore = "DateNotBefore",
    DateBefore = "DateBefore",
    MandatoryWhenFilled = "MandatoryWhenFilled",
}

export class MaxLengthRuleResponse extends RuleResponse implements IMaxLengthRuleResponse {
    value?: string | null;

    constructor(data?: IMaxLengthRuleResponse) {
        super(data);
        this._discriminator = "MaxLengthRuleResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): MaxLengthRuleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MaxLengthRuleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IMaxLengthRuleResponse extends IRuleResponse {
    value?: string | null;
}

export class DefinedValueElementResponse extends FieldElementResponse implements IDefinedValueElementResponse {
    value?: DefinedValueResponse | null;
    possibleValues?: DefinedValueResponse[] | null;

    constructor(data?: IDefinedValueElementResponse) {
        super(data);
        this._discriminator = "DefinedValueElementResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? DefinedValueResponse.fromJS(_data["value"]) : <any>null;
            if (Array.isArray(_data["possibleValues"])) {
                this.possibleValues = [] as any;
                for (let item of _data["possibleValues"])
                    this.possibleValues!.push(DefinedValueResponse.fromJS(item));
            }
            else {
                this.possibleValues = <any>null;
            }
        }
    }

    static fromJS(data: any): DefinedValueElementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DefinedValueElementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>null;
        if (Array.isArray(this.possibleValues)) {
            data["possibleValues"] = [];
            for (let item of this.possibleValues)
                data["possibleValues"].push(item ? item.toJSON() : <any>null);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDefinedValueElementResponse extends IFieldElementResponse {
    value?: DefinedValueResponse | null;
    possibleValues?: DefinedValueResponse[] | null;
}

export class DefinedValueResponse implements IDefinedValueResponse {
    code?: string | null;
    numericRepresentation?: string | null;
    stringRepresentation?: string | null;

    constructor(data?: IDefinedValueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.numericRepresentation = _data["numericRepresentation"] !== undefined ? _data["numericRepresentation"] : <any>null;
            this.stringRepresentation = _data["stringRepresentation"] !== undefined ? _data["stringRepresentation"] : <any>null;
        }
    }

    static fromJS(data: any): DefinedValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DefinedValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["numericRepresentation"] = this.numericRepresentation !== undefined ? this.numericRepresentation : <any>null;
        data["stringRepresentation"] = this.stringRepresentation !== undefined ? this.stringRepresentation : <any>null;
        return data;
    }
}

export interface IDefinedValueResponse {
    code?: string | null;
    numericRepresentation?: string | null;
    stringRepresentation?: string | null;
}

export class StringValueElementResponse extends FieldElementResponse implements IStringValueElementResponse {
    value?: string | null;

    constructor(data?: IStringValueElementResponse) {
        super(data);
        this._discriminator = "StringValueElementResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): StringValueElementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StringValueElementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IStringValueElementResponse extends IFieldElementResponse {
    value?: string | null;
}

export class DateTimeValueElementResponse extends FieldElementResponse implements IDateTimeValueElementResponse {
    value!: moment.Moment;

    constructor(data?: IDateTimeValueElementResponse) {
        super(data);
        this._discriminator = "DateTimeValueElementResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? moment(_data["value"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): DateTimeValueElementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeValueElementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDateTimeValueElementResponse extends IFieldElementResponse {
    value: moment.Moment;
}

export class EvaluationResponse implements IEvaluationResponse {
    description?: string | null;
    date!: moment.Moment;
    score?: DefinedValueResponse | null;
    state?: string | null;
    type!: EvaluationType;
    professionalInitials?: string | null;

    constructor(data?: IEvaluationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>null;
            this.score = _data["score"] ? DefinedValueResponse.fromJS(_data["score"]) : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.professionalInitials = _data["professionalInitials"] !== undefined ? _data["professionalInitials"] : <any>null;
        }
    }

    static fromJS(data: any): EvaluationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["score"] = this.score ? this.score.toJSON() : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["professionalInitials"] = this.professionalInitials !== undefined ? this.professionalInitials : <any>null;
        return data;
    }
}

export interface IEvaluationResponse {
    description?: string | null;
    date: moment.Moment;
    score?: DefinedValueResponse | null;
    state?: string | null;
    type: EvaluationType;
    professionalInitials?: string | null;
}

export enum EvaluationType {
    EVALUATION = "EVALUATION",
    BASELINE = "BASELINE",
}

export class EvaluationPrototypeResponse implements IEvaluationPrototypeResponse {
    evaluationDetail?: EvaluationDetailResponse | null;
    possiblePathwayAssociations?: PathwayReferenceResponse[] | null;

    constructor(data?: IEvaluationPrototypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.evaluationDetail = _data["evaluationDetail"] ? EvaluationDetailResponse.fromJS(_data["evaluationDetail"]) : <any>null;
            if (Array.isArray(_data["possiblePathwayAssociations"])) {
                this.possiblePathwayAssociations = [] as any;
                for (let item of _data["possiblePathwayAssociations"])
                    this.possiblePathwayAssociations!.push(PathwayReferenceResponse.fromJS(item));
            }
            else {
                this.possiblePathwayAssociations = <any>null;
            }
        }
    }

    static fromJS(data: any): EvaluationPrototypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationPrototypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evaluationDetail"] = this.evaluationDetail ? this.evaluationDetail.toJSON() : <any>null;
        if (Array.isArray(this.possiblePathwayAssociations)) {
            data["possiblePathwayAssociations"] = [];
            for (let item of this.possiblePathwayAssociations)
                data["possiblePathwayAssociations"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IEvaluationPrototypeResponse {
    evaluationDetail?: EvaluationDetailResponse | null;
    possiblePathwayAssociations?: PathwayReferenceResponse[] | null;
}

export class EvaluationDetailResponse implements IEvaluationDetailResponse {
    elements?: FieldElementResponse[] | null;
    availableActions?: WorkFlowActionResponse[] | null;
    pathwayAssociation!: PathwayReferenceResponse | null;

    constructor(data?: IEvaluationDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(FieldElementResponse.fromJS(item));
            }
            else {
                this.elements = <any>null;
            }
            if (Array.isArray(_data["availableActions"])) {
                this.availableActions = [] as any;
                for (let item of _data["availableActions"])
                    this.availableActions!.push(WorkFlowActionResponse.fromJS(item));
            }
            else {
                this.availableActions = <any>null;
            }
            this.pathwayAssociation = _data["pathwayAssociation"] ? PathwayReferenceResponse.fromJS(_data["pathwayAssociation"]) : <any>null;
        }
    }

    static fromJS(data: any): EvaluationDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.availableActions)) {
            data["availableActions"] = [];
            for (let item of this.availableActions)
                data["availableActions"].push(item ? item.toJSON() : <any>null);
        }
        data["pathwayAssociation"] = this.pathwayAssociation ? this.pathwayAssociation.toJSON() : <any>null;
        return data;
    }
}

export interface IEvaluationDetailResponse {
    elements?: FieldElementResponse[] | null;
    availableActions?: WorkFlowActionResponse[] | null;
    pathwayAssociation: PathwayReferenceResponse | null;
}

export class WorkFlowActionResponse implements IWorkFlowActionResponse {
    id!: number;
    actionName?: string | null;
    resultWith?: WorkFlowStateResponse | null;

    constructor(data?: IWorkFlowActionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.actionName = _data["actionName"] !== undefined ? _data["actionName"] : <any>null;
            this.resultWith = _data["resultWith"] ? WorkFlowStateResponse.fromJS(_data["resultWith"]) : <any>null;
        }
    }

    static fromJS(data: any): WorkFlowActionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WorkFlowActionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["actionName"] = this.actionName !== undefined ? this.actionName : <any>null;
        data["resultWith"] = this.resultWith ? this.resultWith.toJSON() : <any>null;
        return data;
    }
}

export interface IWorkFlowActionResponse {
    id: number;
    actionName?: string | null;
    resultWith?: WorkFlowStateResponse | null;
}

export class WorkFlowStateResponse implements IWorkFlowStateResponse {
    name?: string | null;
    type!: WorkFlowStateType;

    constructor(data?: IWorkFlowStateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): WorkFlowStateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WorkFlowStateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}

export interface IWorkFlowStateResponse {
    name?: string | null;
    type: WorkFlowStateType;
}

export class PathwayReferenceResponse implements IPathwayReferenceResponse {
    name?: string | null;
    programPathwayId!: number;
    activityIdentifier?: ActivityIdentifierResponse | null;
    pathwayStatus?: PathwayStatus | null;

    constructor(data?: IPathwayReferenceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.programPathwayId = _data["programPathwayId"] !== undefined ? _data["programPathwayId"] : <any>null;
            this.activityIdentifier = _data["activityIdentifier"] ? ActivityIdentifierResponse.fromJS(_data["activityIdentifier"]) : <any>null;
            this.pathwayStatus = _data["pathwayStatus"] !== undefined ? _data["pathwayStatus"] : <any>null;
        }
    }

    static fromJS(data: any): PathwayReferenceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PathwayReferenceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["programPathwayId"] = this.programPathwayId !== undefined ? this.programPathwayId : <any>null;
        data["activityIdentifier"] = this.activityIdentifier ? this.activityIdentifier.toJSON() : <any>null;
        data["pathwayStatus"] = this.pathwayStatus !== undefined ? this.pathwayStatus : <any>null;
        return data;
    }
}

export interface IPathwayReferenceResponse {
    name?: string | null;
    programPathwayId: number;
    activityIdentifier?: ActivityIdentifierResponse | null;
    pathwayStatus?: PathwayStatus | null;
}

export class ActivityIdentifierResponse implements IActivityIdentifierResponse {
    activityId!: number;
    identifier?: string | null;
    type!: ActivityType;

    constructor(data?: IActivityIdentifierResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"] !== undefined ? _data["activityId"] : <any>null;
            this.identifier = _data["identifier"] !== undefined ? _data["identifier"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): ActivityIdentifierResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityIdentifierResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId !== undefined ? this.activityId : <any>null;
        data["identifier"] = this.identifier !== undefined ? this.identifier : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}

export interface IActivityIdentifierResponse {
    activityId: number;
    identifier?: string | null;
    type: ActivityType;
}

export enum ActivityType {
    EOP_PROBLEM = "EOP_PROBLEM",
    EOP_VISITATION = "EOP_VISITATION",
    EOP_SUBGOAL = "EOP_SUBGOAL",
    EOP_ACTION = "EOP_ACTION",
    EOP_EVALUATION = "EOP_EVALUATION",
    EOP_FOLLOW_UP = "EOP_FOLLOW_UP",
    PATIENT_CONDITION = "PATIENT_CONDITION",
    FORM_DATA = "FORM_DATA",
    BASKET_GRANT = "BASKET_GRANT",
    ORDER_GRANT = "ORDER_GRANT",
    PATIENT_PATHWAY = "PATIENT_PATHWAY",
}

export enum PathwayStatus {
    DRAFT = "DRAFT",
    ACTIVE = "ACTIVE",
    INACTIVATED = "INACTIVATED",
}

export class CreateEvaluationRequest implements ICreateEvaluationRequest {
    elements?: FieldElementRequest[] | null;
    pathwayAssociation?: PathwayReferenceRequest | null;
    actionId!: number;

    constructor(data?: ICreateEvaluationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(FieldElementRequest.fromJS(item));
            }
            else {
                this.elements = <any>null;
            }
            this.pathwayAssociation = _data["pathwayAssociation"] ? PathwayReferenceRequest.fromJS(_data["pathwayAssociation"]) : <any>null;
            this.actionId = _data["actionId"] !== undefined ? _data["actionId"] : <any>null;
        }
    }

    static fromJS(data: any): CreateEvaluationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEvaluationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : <any>null);
        }
        data["pathwayAssociation"] = this.pathwayAssociation ? this.pathwayAssociation.toJSON() : <any>null;
        data["actionId"] = this.actionId !== undefined ? this.actionId : <any>null;
        return data;
    }
}

export interface ICreateEvaluationRequest {
    elements?: FieldElementRequest[] | null;
    pathwayAssociation?: PathwayReferenceRequest | null;
    actionId: number;
}

export abstract class FieldElementRequest implements IFieldElementRequest {
    elementType!: ElementType;
    hint?: string | null;
    label?: string | null;
    mandatoryFor?: WorkFlowStateType[] | null;
    rules?: RuleRequest[] | null;

    protected _discriminator: string;

    constructor(data?: IFieldElementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "FieldElementRequest";
    }

    init(_data?: any) {
        if (_data) {
            this.elementType = _data["elementType"] !== undefined ? _data["elementType"] : <any>null;
            this.hint = _data["hint"] !== undefined ? _data["hint"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            if (Array.isArray(_data["mandatoryFor"])) {
                this.mandatoryFor = [] as any;
                for (let item of _data["mandatoryFor"])
                    this.mandatoryFor!.push(item);
            }
            else {
                this.mandatoryFor = <any>null;
            }
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(RuleRequest.fromJS(item));
            }
            else {
                this.rules = <any>null;
            }
        }
    }

    static fromJS(data: any): FieldElementRequest {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "DefinedValueElementRequest") {
            let result = new DefinedValueElementRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "StringValueElementRequest") {
            let result = new StringValueElementRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "DateTimeValueElementRequest") {
            let result = new DateTimeValueElementRequest();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'FieldElementRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["swagger_discriminator"] = this._discriminator;
        data["elementType"] = this.elementType !== undefined ? this.elementType : <any>null;
        data["hint"] = this.hint !== undefined ? this.hint : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        if (Array.isArray(this.mandatoryFor)) {
            data["mandatoryFor"] = [];
            for (let item of this.mandatoryFor)
                data["mandatoryFor"].push(item);
        }
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IFieldElementRequest {
    elementType: ElementType;
    hint?: string | null;
    label?: string | null;
    mandatoryFor?: WorkFlowStateType[] | null;
    rules?: RuleRequest[] | null;
}

export abstract class RuleRequest implements IRuleRequest {
    type!: RuleType;

    protected _discriminator: string;

    constructor(data?: IRuleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "RuleRequest";
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): RuleRequest {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "MaxLengthRuleRequest") {
            let result = new MaxLengthRuleRequest();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'RuleRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["swagger_discriminator"] = this._discriminator;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}

export interface IRuleRequest {
    type: RuleType;
}

export class MaxLengthRuleRequest extends RuleRequest implements IMaxLengthRuleRequest {
    value?: string | null;

    constructor(data?: IMaxLengthRuleRequest) {
        super(data);
        this._discriminator = "MaxLengthRuleRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): MaxLengthRuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MaxLengthRuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IMaxLengthRuleRequest extends IRuleRequest {
    value?: string | null;
}

export class DefinedValueElementRequest extends FieldElementRequest implements IDefinedValueElementRequest {
    value?: DefinedValueRequest | null;
    possibleValues?: DefinedValueRequest[] | null;

    constructor(data?: IDefinedValueElementRequest) {
        super(data);
        this._discriminator = "DefinedValueElementRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? DefinedValueRequest.fromJS(_data["value"]) : <any>null;
            if (Array.isArray(_data["possibleValues"])) {
                this.possibleValues = [] as any;
                for (let item of _data["possibleValues"])
                    this.possibleValues!.push(DefinedValueRequest.fromJS(item));
            }
            else {
                this.possibleValues = <any>null;
            }
        }
    }

    static fromJS(data: any): DefinedValueElementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DefinedValueElementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>null;
        if (Array.isArray(this.possibleValues)) {
            data["possibleValues"] = [];
            for (let item of this.possibleValues)
                data["possibleValues"].push(item ? item.toJSON() : <any>null);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDefinedValueElementRequest extends IFieldElementRequest {
    value?: DefinedValueRequest | null;
    possibleValues?: DefinedValueRequest[] | null;
}

export class DefinedValueRequest implements IDefinedValueRequest {
    code?: string | null;
    numericRepresentation?: string | null;
    stringRepresentation?: string | null;

    constructor(data?: IDefinedValueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.numericRepresentation = _data["numericRepresentation"] !== undefined ? _data["numericRepresentation"] : <any>null;
            this.stringRepresentation = _data["stringRepresentation"] !== undefined ? _data["stringRepresentation"] : <any>null;
        }
    }

    static fromJS(data: any): DefinedValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DefinedValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["numericRepresentation"] = this.numericRepresentation !== undefined ? this.numericRepresentation : <any>null;
        data["stringRepresentation"] = this.stringRepresentation !== undefined ? this.stringRepresentation : <any>null;
        return data;
    }
}

export interface IDefinedValueRequest {
    code?: string | null;
    numericRepresentation?: string | null;
    stringRepresentation?: string | null;
}

export class StringValueElementRequest extends FieldElementRequest implements IStringValueElementRequest {
    value?: string | null;

    constructor(data?: IStringValueElementRequest) {
        super(data);
        this._discriminator = "StringValueElementRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): StringValueElementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StringValueElementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IStringValueElementRequest extends IFieldElementRequest {
    value?: string | null;
}

export class DateTimeValueElementRequest extends FieldElementRequest implements IDateTimeValueElementRequest {
    value!: moment.Moment;

    constructor(data?: IDateTimeValueElementRequest) {
        super(data);
        this._discriminator = "DateTimeValueElementRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? moment(_data["value"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): DateTimeValueElementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeValueElementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDateTimeValueElementRequest extends IFieldElementRequest {
    value: moment.Moment;
}

export class PathwayReferenceRequest implements IPathwayReferenceRequest {
    name?: string | null;
    programPathwayId!: number;
    activityIdentifier?: ActivityIdentifierRequest | null;
    pathwayStatus?: PathwayStatus | null;

    constructor(data?: IPathwayReferenceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.programPathwayId = _data["programPathwayId"] !== undefined ? _data["programPathwayId"] : <any>null;
            this.activityIdentifier = _data["activityIdentifier"] ? ActivityIdentifierRequest.fromJS(_data["activityIdentifier"]) : <any>null;
            this.pathwayStatus = _data["pathwayStatus"] !== undefined ? _data["pathwayStatus"] : <any>null;
        }
    }

    static fromJS(data: any): PathwayReferenceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PathwayReferenceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["programPathwayId"] = this.programPathwayId !== undefined ? this.programPathwayId : <any>null;
        data["activityIdentifier"] = this.activityIdentifier ? this.activityIdentifier.toJSON() : <any>null;
        data["pathwayStatus"] = this.pathwayStatus !== undefined ? this.pathwayStatus : <any>null;
        return data;
    }
}

export interface IPathwayReferenceRequest {
    name?: string | null;
    programPathwayId: number;
    activityIdentifier?: ActivityIdentifierRequest | null;
    pathwayStatus?: PathwayStatus | null;
}

export class ActivityIdentifierRequest implements IActivityIdentifierRequest {
    activityId!: number;
    identifier!: string | null;
    type!: ActivityType;

    constructor(data?: IActivityIdentifierRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"] !== undefined ? _data["activityId"] : <any>null;
            this.identifier = _data["identifier"] !== undefined ? _data["identifier"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): ActivityIdentifierRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityIdentifierRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId !== undefined ? this.activityId : <any>null;
        data["identifier"] = this.identifier !== undefined ? this.identifier : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}

export interface IActivityIdentifierRequest {
    activityId: number;
    identifier: string | null;
    type: ActivityType;
}

export class PlannedAvailableActionsResponse implements IPlannedAvailableActionsResponse {
    give!: boolean;
    notGiven!: boolean;
    delete!: boolean;
    handedOver!: boolean;
    notIngested!: boolean;

    constructor(data?: IPlannedAvailableActionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.give = _data["give"] !== undefined ? _data["give"] : <any>null;
            this.notGiven = _data["notGiven"] !== undefined ? _data["notGiven"] : <any>null;
            this.delete = _data["delete"] !== undefined ? _data["delete"] : <any>null;
            this.handedOver = _data["handedOver"] !== undefined ? _data["handedOver"] : <any>null;
            this.notIngested = _data["notIngested"] !== undefined ? _data["notIngested"] : <any>null;
        }
    }

    static fromJS(data: any): PlannedAvailableActionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedAvailableActionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["give"] = this.give !== undefined ? this.give : <any>null;
        data["notGiven"] = this.notGiven !== undefined ? this.notGiven : <any>null;
        data["delete"] = this.delete !== undefined ? this.delete : <any>null;
        data["handedOver"] = this.handedOver !== undefined ? this.handedOver : <any>null;
        data["notIngested"] = this.notIngested !== undefined ? this.notIngested : <any>null;
        return data;
    }
}

export interface IPlannedAvailableActionsResponse {
    give: boolean;
    notGiven: boolean;
    delete: boolean;
    handedOver: boolean;
    notIngested: boolean;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions!: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key] !== undefined ? _data["extensions"][key] : <any>null;
                }
            }
            else {
                this.extensions = <any>null;
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = this.extensions[key] !== undefined ? this.extensions[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export class PlannedAdministrationsForResidentResponse implements IPlannedAdministrationsForResidentResponse {
    dispensedAdministrations?: DispensedAdministrationResponse[] | null;
    notDispensedAdministrations?: NotDispensedAdministrationResponse[] | null;
    residentId?: string | null;
    errorCallingNexus!: boolean;
    residentsDosedSelfAdministrated!: boolean;

    constructor(data?: IPlannedAdministrationsForResidentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dispensedAdministrations"])) {
                this.dispensedAdministrations = [] as any;
                for (let item of _data["dispensedAdministrations"])
                    this.dispensedAdministrations!.push(DispensedAdministrationResponse.fromJS(item));
            }
            else {
                this.dispensedAdministrations = <any>null;
            }
            if (Array.isArray(_data["notDispensedAdministrations"])) {
                this.notDispensedAdministrations = [] as any;
                for (let item of _data["notDispensedAdministrations"])
                    this.notDispensedAdministrations!.push(NotDispensedAdministrationResponse.fromJS(item));
            }
            else {
                this.notDispensedAdministrations = <any>null;
            }
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : <any>null;
            this.errorCallingNexus = _data["errorCallingNexus"] !== undefined ? _data["errorCallingNexus"] : <any>null;
            this.residentsDosedSelfAdministrated = _data["residentsDosedSelfAdministrated"] !== undefined ? _data["residentsDosedSelfAdministrated"] : <any>null;
        }
    }

    static fromJS(data: any): PlannedAdministrationsForResidentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedAdministrationsForResidentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dispensedAdministrations)) {
            data["dispensedAdministrations"] = [];
            for (let item of this.dispensedAdministrations)
                data["dispensedAdministrations"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.notDispensedAdministrations)) {
            data["notDispensedAdministrations"] = [];
            for (let item of this.notDispensedAdministrations)
                data["notDispensedAdministrations"].push(item ? item.toJSON() : <any>null);
        }
        data["residentId"] = this.residentId !== undefined ? this.residentId : <any>null;
        data["errorCallingNexus"] = this.errorCallingNexus !== undefined ? this.errorCallingNexus : <any>null;
        data["residentsDosedSelfAdministrated"] = this.residentsDosedSelfAdministrated !== undefined ? this.residentsDosedSelfAdministrated : <any>null;
        return data;
    }
}

export interface IPlannedAdministrationsForResidentResponse {
    dispensedAdministrations?: DispensedAdministrationResponse[] | null;
    notDispensedAdministrations?: NotDispensedAdministrationResponse[] | null;
    residentId?: string | null;
    errorCallingNexus: boolean;
    residentsDosedSelfAdministrated: boolean;
}

export class DispensedAdministrationResponse implements IDispensedAdministrationResponse {
    id?: string | null;
    administrationTime!: moment.Moment;
    isDelegated!: boolean;
    prescriptionsDetails?: AdministrationPrescriptionDetailsResponse[] | null;
    delegatedProfessionId!: number;
    description?: string | null;
    instructions?: AdministrationInstruction[] | null;

    constructor(data?: IDispensedAdministrationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.administrationTime = _data["administrationTime"] ? moment(_data["administrationTime"].toString()) : <any>null;
            this.isDelegated = _data["isDelegated"] !== undefined ? _data["isDelegated"] : <any>null;
            if (Array.isArray(_data["prescriptionsDetails"])) {
                this.prescriptionsDetails = [] as any;
                for (let item of _data["prescriptionsDetails"])
                    this.prescriptionsDetails!.push(AdministrationPrescriptionDetailsResponse.fromJS(item));
            }
            else {
                this.prescriptionsDetails = <any>null;
            }
            this.delegatedProfessionId = _data["delegatedProfessionId"] !== undefined ? _data["delegatedProfessionId"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            if (Array.isArray(_data["instructions"])) {
                this.instructions = [] as any;
                for (let item of _data["instructions"])
                    this.instructions!.push(AdministrationInstruction.fromJS(item));
            }
            else {
                this.instructions = <any>null;
            }
        }
    }

    static fromJS(data: any): DispensedAdministrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DispensedAdministrationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["administrationTime"] = this.administrationTime ? this.administrationTime.toISOString() : <any>null;
        data["isDelegated"] = this.isDelegated !== undefined ? this.isDelegated : <any>null;
        if (Array.isArray(this.prescriptionsDetails)) {
            data["prescriptionsDetails"] = [];
            for (let item of this.prescriptionsDetails)
                data["prescriptionsDetails"].push(item ? item.toJSON() : <any>null);
        }
        data["delegatedProfessionId"] = this.delegatedProfessionId !== undefined ? this.delegatedProfessionId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        if (Array.isArray(this.instructions)) {
            data["instructions"] = [];
            for (let item of this.instructions)
                data["instructions"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IDispensedAdministrationResponse {
    id?: string | null;
    administrationTime: moment.Moment;
    isDelegated: boolean;
    prescriptionsDetails?: AdministrationPrescriptionDetailsResponse[] | null;
    delegatedProfessionId: number;
    description?: string | null;
    instructions?: AdministrationInstruction[] | null;
}

export class AdministrationPrescriptionDetailsResponse implements IAdministrationPrescriptionDetailsResponse {
    /** One of(DISPENSED_BY_MUNICIPALITY, DOSAGE_DISPENSED, ADMINISTRATED_BY_MUNICIPALITY) */
    administrationType?: string | null;
    prescriptionId!: number;
    /** One of (NONE, GIVEN, NOT_GIVEN, HANDED_OVER, NOT_INGESTED) */
    registrationState?: string | null;
    tooltip?: string | null;
    isCooperationWorkflow!: boolean;
    isRegistrable!: boolean;

    constructor(data?: IAdministrationPrescriptionDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.administrationType = _data["administrationType"] !== undefined ? _data["administrationType"] : <any>null;
            this.prescriptionId = _data["prescriptionId"] !== undefined ? _data["prescriptionId"] : <any>null;
            this.registrationState = _data["registrationState"] !== undefined ? _data["registrationState"] : <any>null;
            this.tooltip = _data["tooltip"] !== undefined ? _data["tooltip"] : <any>null;
            this.isCooperationWorkflow = _data["isCooperationWorkflow"] !== undefined ? _data["isCooperationWorkflow"] : <any>null;
            this.isRegistrable = _data["isRegistrable"] !== undefined ? _data["isRegistrable"] : <any>null;
        }
    }

    static fromJS(data: any): AdministrationPrescriptionDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdministrationPrescriptionDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["administrationType"] = this.administrationType !== undefined ? this.administrationType : <any>null;
        data["prescriptionId"] = this.prescriptionId !== undefined ? this.prescriptionId : <any>null;
        data["registrationState"] = this.registrationState !== undefined ? this.registrationState : <any>null;
        data["tooltip"] = this.tooltip !== undefined ? this.tooltip : <any>null;
        data["isCooperationWorkflow"] = this.isCooperationWorkflow !== undefined ? this.isCooperationWorkflow : <any>null;
        data["isRegistrable"] = this.isRegistrable !== undefined ? this.isRegistrable : <any>null;
        return data;
    }
}

export interface IAdministrationPrescriptionDetailsResponse {
    /** One of(DISPENSED_BY_MUNICIPALITY, DOSAGE_DISPENSED, ADMINISTRATED_BY_MUNICIPALITY) */
    administrationType?: string | null;
    prescriptionId: number;
    /** One of (NONE, GIVEN, NOT_GIVEN, HANDED_OVER, NOT_INGESTED) */
    registrationState?: string | null;
    tooltip?: string | null;
    isCooperationWorkflow: boolean;
    isRegistrable: boolean;
}

export class AdministrationInstruction implements IAdministrationInstruction {
    instructionId?: string | null;
    order!: number;

    constructor(data?: IAdministrationInstruction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instructionId = _data["instructionId"] !== undefined ? _data["instructionId"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
        }
    }

    static fromJS(data: any): AdministrationInstruction {
        data = typeof data === 'object' ? data : {};
        let result = new AdministrationInstruction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instructionId"] = this.instructionId !== undefined ? this.instructionId : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        return data;
    }
}

export interface IAdministrationInstruction {
    instructionId?: string | null;
    order: number;
}

export class NotDispensedAdministrationResponse implements INotDispensedAdministrationResponse {
    id?: string | null;
    administrationTime!: moment.Moment;
    isDelegated!: boolean;
    name?: string | null;
    prescriptionId!: number;
    delegatedProfessionId!: number;
    registrationState?: string | null;
    tooltip?: string | null;
    selfAdministrating!: boolean;
    isDeliveryWorkFlow!: boolean;
    isCooperationWorkflow!: boolean;
    isRegistrable!: boolean;
    description?: string | null;
    instructions?: AdministrationInstruction[] | null;

    constructor(data?: INotDispensedAdministrationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.administrationTime = _data["administrationTime"] ? moment(_data["administrationTime"].toString()) : <any>null;
            this.isDelegated = _data["isDelegated"] !== undefined ? _data["isDelegated"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.prescriptionId = _data["prescriptionId"] !== undefined ? _data["prescriptionId"] : <any>null;
            this.delegatedProfessionId = _data["delegatedProfessionId"] !== undefined ? _data["delegatedProfessionId"] : <any>null;
            this.registrationState = _data["registrationState"] !== undefined ? _data["registrationState"] : <any>null;
            this.tooltip = _data["tooltip"] !== undefined ? _data["tooltip"] : <any>null;
            this.selfAdministrating = _data["selfAdministrating"] !== undefined ? _data["selfAdministrating"] : <any>null;
            this.isDeliveryWorkFlow = _data["isDeliveryWorkFlow"] !== undefined ? _data["isDeliveryWorkFlow"] : <any>null;
            this.isCooperationWorkflow = _data["isCooperationWorkflow"] !== undefined ? _data["isCooperationWorkflow"] : <any>null;
            this.isRegistrable = _data["isRegistrable"] !== undefined ? _data["isRegistrable"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            if (Array.isArray(_data["instructions"])) {
                this.instructions = [] as any;
                for (let item of _data["instructions"])
                    this.instructions!.push(AdministrationInstruction.fromJS(item));
            }
            else {
                this.instructions = <any>null;
            }
        }
    }

    static fromJS(data: any): NotDispensedAdministrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NotDispensedAdministrationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["administrationTime"] = this.administrationTime ? this.administrationTime.toISOString() : <any>null;
        data["isDelegated"] = this.isDelegated !== undefined ? this.isDelegated : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["prescriptionId"] = this.prescriptionId !== undefined ? this.prescriptionId : <any>null;
        data["delegatedProfessionId"] = this.delegatedProfessionId !== undefined ? this.delegatedProfessionId : <any>null;
        data["registrationState"] = this.registrationState !== undefined ? this.registrationState : <any>null;
        data["tooltip"] = this.tooltip !== undefined ? this.tooltip : <any>null;
        data["selfAdministrating"] = this.selfAdministrating !== undefined ? this.selfAdministrating : <any>null;
        data["isDeliveryWorkFlow"] = this.isDeliveryWorkFlow !== undefined ? this.isDeliveryWorkFlow : <any>null;
        data["isCooperationWorkflow"] = this.isCooperationWorkflow !== undefined ? this.isCooperationWorkflow : <any>null;
        data["isRegistrable"] = this.isRegistrable !== undefined ? this.isRegistrable : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        if (Array.isArray(this.instructions)) {
            data["instructions"] = [];
            for (let item of this.instructions)
                data["instructions"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface INotDispensedAdministrationResponse {
    id?: string | null;
    administrationTime: moment.Moment;
    isDelegated: boolean;
    name?: string | null;
    prescriptionId: number;
    delegatedProfessionId: number;
    registrationState?: string | null;
    tooltip?: string | null;
    selfAdministrating: boolean;
    isDeliveryWorkFlow: boolean;
    isCooperationWorkflow: boolean;
    isRegistrable: boolean;
    description?: string | null;
    instructions?: AdministrationInstruction[] | null;
}

export class PlannedAdministrationTasksForReportResponse implements IPlannedAdministrationTasksForReportResponse {
    administrationType?: string | null;
    plannedExecutionTime!: moment.Moment;
    residentId?: string | null;
    registrationState?: string | null;
    duration!: number;
    prescriptionIds?: string | null;

    constructor(data?: IPlannedAdministrationTasksForReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.administrationType = _data["administrationType"] !== undefined ? _data["administrationType"] : <any>null;
            this.plannedExecutionTime = _data["plannedExecutionTime"] ? moment(_data["plannedExecutionTime"].toString()) : <any>null;
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : <any>null;
            this.registrationState = _data["registrationState"] !== undefined ? _data["registrationState"] : <any>null;
            this.duration = _data["duration"] !== undefined ? _data["duration"] : <any>null;
            this.prescriptionIds = _data["prescriptionIds"] !== undefined ? _data["prescriptionIds"] : <any>null;
        }
    }

    static fromJS(data: any): PlannedAdministrationTasksForReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedAdministrationTasksForReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["administrationType"] = this.administrationType !== undefined ? this.administrationType : <any>null;
        data["plannedExecutionTime"] = this.plannedExecutionTime ? this.plannedExecutionTime.toISOString() : <any>null;
        data["residentId"] = this.residentId !== undefined ? this.residentId : <any>null;
        data["registrationState"] = this.registrationState !== undefined ? this.registrationState : <any>null;
        data["duration"] = this.duration !== undefined ? this.duration : <any>null;
        data["prescriptionIds"] = this.prescriptionIds !== undefined ? this.prescriptionIds : <any>null;
        return data;
    }
}

export interface IPlannedAdministrationTasksForReportResponse {
    administrationType?: string | null;
    plannedExecutionTime: moment.Moment;
    residentId?: string | null;
    registrationState?: string | null;
    duration: number;
    prescriptionIds?: string | null;
}

export class DosedAdministrationDetailsResponse implements IDosedAdministrationDetailsResponse {
    id?: string | null;
    residentId?: string | null;
    administrationTime!: moment.Moment;
    description?: string | null;
    instructions?: AdministrationInstruction[] | null;
    isDelegated!: boolean;
    delegatedProfessionId!: number;
    toBeMeasured?: PlannedPrescription[] | null;
    measured?: PlannedPrescription[] | null;
    controlled?: PlannedPrescription[] | null;
    dosageDispensedMeasured?: PlannedPrescription[] | null;
    dosedAdministrationData?: DosedAdministrationDosageData | null;

    constructor(data?: IDosedAdministrationDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : <any>null;
            this.administrationTime = _data["administrationTime"] ? moment(_data["administrationTime"].toString()) : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            if (Array.isArray(_data["instructions"])) {
                this.instructions = [] as any;
                for (let item of _data["instructions"])
                    this.instructions!.push(AdministrationInstruction.fromJS(item));
            }
            else {
                this.instructions = <any>null;
            }
            this.isDelegated = _data["isDelegated"] !== undefined ? _data["isDelegated"] : <any>null;
            this.delegatedProfessionId = _data["delegatedProfessionId"] !== undefined ? _data["delegatedProfessionId"] : <any>null;
            if (Array.isArray(_data["toBeMeasured"])) {
                this.toBeMeasured = [] as any;
                for (let item of _data["toBeMeasured"])
                    this.toBeMeasured!.push(PlannedPrescription.fromJS(item));
            }
            else {
                this.toBeMeasured = <any>null;
            }
            if (Array.isArray(_data["measured"])) {
                this.measured = [] as any;
                for (let item of _data["measured"])
                    this.measured!.push(PlannedPrescription.fromJS(item));
            }
            else {
                this.measured = <any>null;
            }
            if (Array.isArray(_data["controlled"])) {
                this.controlled = [] as any;
                for (let item of _data["controlled"])
                    this.controlled!.push(PlannedPrescription.fromJS(item));
            }
            else {
                this.controlled = <any>null;
            }
            if (Array.isArray(_data["dosageDispensedMeasured"])) {
                this.dosageDispensedMeasured = [] as any;
                for (let item of _data["dosageDispensedMeasured"])
                    this.dosageDispensedMeasured!.push(PlannedPrescription.fromJS(item));
            }
            else {
                this.dosageDispensedMeasured = <any>null;
            }
            this.dosedAdministrationData = _data["dosedAdministrationData"] ? DosedAdministrationDosageData.fromJS(_data["dosedAdministrationData"]) : <any>null;
        }
    }

    static fromJS(data: any): DosedAdministrationDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DosedAdministrationDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["residentId"] = this.residentId !== undefined ? this.residentId : <any>null;
        data["administrationTime"] = this.administrationTime ? this.administrationTime.toISOString() : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        if (Array.isArray(this.instructions)) {
            data["instructions"] = [];
            for (let item of this.instructions)
                data["instructions"].push(item ? item.toJSON() : <any>null);
        }
        data["isDelegated"] = this.isDelegated !== undefined ? this.isDelegated : <any>null;
        data["delegatedProfessionId"] = this.delegatedProfessionId !== undefined ? this.delegatedProfessionId : <any>null;
        if (Array.isArray(this.toBeMeasured)) {
            data["toBeMeasured"] = [];
            for (let item of this.toBeMeasured)
                data["toBeMeasured"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.measured)) {
            data["measured"] = [];
            for (let item of this.measured)
                data["measured"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.controlled)) {
            data["controlled"] = [];
            for (let item of this.controlled)
                data["controlled"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.dosageDispensedMeasured)) {
            data["dosageDispensedMeasured"] = [];
            for (let item of this.dosageDispensedMeasured)
                data["dosageDispensedMeasured"].push(item ? item.toJSON() : <any>null);
        }
        data["dosedAdministrationData"] = this.dosedAdministrationData ? this.dosedAdministrationData.toJSON() : <any>null;
        return data;
    }
}

export interface IDosedAdministrationDetailsResponse {
    id?: string | null;
    residentId?: string | null;
    administrationTime: moment.Moment;
    description?: string | null;
    instructions?: AdministrationInstruction[] | null;
    isDelegated: boolean;
    delegatedProfessionId: number;
    toBeMeasured?: PlannedPrescription[] | null;
    measured?: PlannedPrescription[] | null;
    controlled?: PlannedPrescription[] | null;
    dosageDispensedMeasured?: PlannedPrescription[] | null;
    dosedAdministrationData?: DosedAdministrationDosageData | null;
}

export class PlannedPrescription implements IPlannedPrescription {
    /** One of (DISPENSED_BY_MUNICIPALITY, DOSAGE_DISPENSED, ADMINISTRATED_BY_MUNICIPALITY) */
    administrationType?: string | null;
    /** One of (NONE, GIVEN, NOT_GIVEN, HANDED_OVER, NOT_INGESTED) */
    registrationState?: string | null;
    tooltip?: string | null;
    prescriptionId!: number;
    name?: string | null;
    remark?: string | null;
    dosageText?: string | null;
    dosageUnit?: string | null;
    dosageValue!: number;
    strength?: string | null;
    formText?: string | null;
    indicationText?: string | null;
    activeIngredient?: string | null;
    isCooperationWorkflow!: boolean;
    isRegistrable!: boolean;

    constructor(data?: IPlannedPrescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.administrationType = _data["administrationType"] !== undefined ? _data["administrationType"] : <any>null;
            this.registrationState = _data["registrationState"] !== undefined ? _data["registrationState"] : <any>null;
            this.tooltip = _data["tooltip"] !== undefined ? _data["tooltip"] : <any>null;
            this.prescriptionId = _data["prescriptionId"] !== undefined ? _data["prescriptionId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : <any>null;
            this.dosageText = _data["dosageText"] !== undefined ? _data["dosageText"] : <any>null;
            this.dosageUnit = _data["dosageUnit"] !== undefined ? _data["dosageUnit"] : <any>null;
            this.dosageValue = _data["dosageValue"] !== undefined ? _data["dosageValue"] : <any>null;
            this.strength = _data["strength"] !== undefined ? _data["strength"] : <any>null;
            this.formText = _data["formText"] !== undefined ? _data["formText"] : <any>null;
            this.indicationText = _data["indicationText"] !== undefined ? _data["indicationText"] : <any>null;
            this.activeIngredient = _data["activeIngredient"] !== undefined ? _data["activeIngredient"] : <any>null;
            this.isCooperationWorkflow = _data["isCooperationWorkflow"] !== undefined ? _data["isCooperationWorkflow"] : <any>null;
            this.isRegistrable = _data["isRegistrable"] !== undefined ? _data["isRegistrable"] : <any>null;
        }
    }

    static fromJS(data: any): PlannedPrescription {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedPrescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["administrationType"] = this.administrationType !== undefined ? this.administrationType : <any>null;
        data["registrationState"] = this.registrationState !== undefined ? this.registrationState : <any>null;
        data["tooltip"] = this.tooltip !== undefined ? this.tooltip : <any>null;
        data["prescriptionId"] = this.prescriptionId !== undefined ? this.prescriptionId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["remark"] = this.remark !== undefined ? this.remark : <any>null;
        data["dosageText"] = this.dosageText !== undefined ? this.dosageText : <any>null;
        data["dosageUnit"] = this.dosageUnit !== undefined ? this.dosageUnit : <any>null;
        data["dosageValue"] = this.dosageValue !== undefined ? this.dosageValue : <any>null;
        data["strength"] = this.strength !== undefined ? this.strength : <any>null;
        data["formText"] = this.formText !== undefined ? this.formText : <any>null;
        data["indicationText"] = this.indicationText !== undefined ? this.indicationText : <any>null;
        data["activeIngredient"] = this.activeIngredient !== undefined ? this.activeIngredient : <any>null;
        data["isCooperationWorkflow"] = this.isCooperationWorkflow !== undefined ? this.isCooperationWorkflow : <any>null;
        data["isRegistrable"] = this.isRegistrable !== undefined ? this.isRegistrable : <any>null;
        return data;
    }
}

export interface IPlannedPrescription {
    /** One of (DISPENSED_BY_MUNICIPALITY, DOSAGE_DISPENSED, ADMINISTRATED_BY_MUNICIPALITY) */
    administrationType?: string | null;
    /** One of (NONE, GIVEN, NOT_GIVEN, HANDED_OVER, NOT_INGESTED) */
    registrationState?: string | null;
    tooltip?: string | null;
    prescriptionId: number;
    name?: string | null;
    remark?: string | null;
    dosageText?: string | null;
    dosageUnit?: string | null;
    dosageValue: number;
    strength?: string | null;
    formText?: string | null;
    indicationText?: string | null;
    activeIngredient?: string | null;
    isCooperationWorkflow: boolean;
    isRegistrable: boolean;
}

export class DosedAdministrationDosageData implements IDosedAdministrationDosageData {
    dispensedByMunicipality?: AdministrationDosageData | null;
    dosageDispensed?: AdministrationDosageData | null;

    constructor(data?: IDosedAdministrationDosageData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dispensedByMunicipality = _data["dispensedByMunicipality"] ? AdministrationDosageData.fromJS(_data["dispensedByMunicipality"]) : <any>null;
            this.dosageDispensed = _data["dosageDispensed"] ? AdministrationDosageData.fromJS(_data["dosageDispensed"]) : <any>null;
        }
    }

    static fromJS(data: any): DosedAdministrationDosageData {
        data = typeof data === 'object' ? data : {};
        let result = new DosedAdministrationDosageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dispensedByMunicipality"] = this.dispensedByMunicipality ? this.dispensedByMunicipality.toJSON() : <any>null;
        data["dosageDispensed"] = this.dosageDispensed ? this.dosageDispensed.toJSON() : <any>null;
        return data;
    }
}

export interface IDosedAdministrationDosageData {
    dispensedByMunicipality?: AdministrationDosageData | null;
    dosageDispensed?: AdministrationDosageData | null;
}

export class AdministrationDosageData implements IAdministrationDosageData {
    whole!: number;
    half!: number;
    quarter!: number;

    constructor(data?: IAdministrationDosageData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.whole = _data["whole"] !== undefined ? _data["whole"] : <any>null;
            this.half = _data["half"] !== undefined ? _data["half"] : <any>null;
            this.quarter = _data["quarter"] !== undefined ? _data["quarter"] : <any>null;
        }
    }

    static fromJS(data: any): AdministrationDosageData {
        data = typeof data === 'object' ? data : {};
        let result = new AdministrationDosageData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["whole"] = this.whole !== undefined ? this.whole : <any>null;
        data["half"] = this.half !== undefined ? this.half : <any>null;
        data["quarter"] = this.quarter !== undefined ? this.quarter : <any>null;
        return data;
    }
}

export interface IAdministrationDosageData {
    whole: number;
    half: number;
    quarter: number;
}

export class PlannedAdministrationDosedRequest implements IPlannedAdministrationDosedRequest {
    prescriptionIds?: number[] | null;
    registrationTime!: moment.Moment;
    currentRegistrationState?: string | null;
    registrationReason?: string | null;

    constructor(data?: IPlannedAdministrationDosedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["prescriptionIds"])) {
                this.prescriptionIds = [] as any;
                for (let item of _data["prescriptionIds"])
                    this.prescriptionIds!.push(item);
            }
            else {
                this.prescriptionIds = <any>null;
            }
            this.registrationTime = _data["registrationTime"] ? moment(_data["registrationTime"].toString()) : <any>null;
            this.currentRegistrationState = _data["currentRegistrationState"] !== undefined ? _data["currentRegistrationState"] : <any>null;
            this.registrationReason = _data["registrationReason"] !== undefined ? _data["registrationReason"] : <any>null;
        }
    }

    static fromJS(data: any): PlannedAdministrationDosedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedAdministrationDosedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.prescriptionIds)) {
            data["prescriptionIds"] = [];
            for (let item of this.prescriptionIds)
                data["prescriptionIds"].push(item);
        }
        data["registrationTime"] = this.registrationTime ? this.registrationTime.toISOString() : <any>null;
        data["currentRegistrationState"] = this.currentRegistrationState !== undefined ? this.currentRegistrationState : <any>null;
        data["registrationReason"] = this.registrationReason !== undefined ? this.registrationReason : <any>null;
        return data;
    }
}

export interface IPlannedAdministrationDosedRequest {
    prescriptionIds?: number[] | null;
    registrationTime: moment.Moment;
    currentRegistrationState?: string | null;
    registrationReason?: string | null;
}

export class UpdateDosedAdministrationMetadataRequest implements IUpdateDosedAdministrationMetadataRequest {
    updateDelegatedProfessionRequest?: UpdateDelegatedProfessionRequest | null;
    updateSelfAdministratedRequest?: UpdateSelfAdministratedRequest | null;
    updateDescriptionRequest?: UpdateDescriptionRequest | null;

    constructor(data?: IUpdateDosedAdministrationMetadataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updateDelegatedProfessionRequest = _data["updateDelegatedProfessionRequest"] ? UpdateDelegatedProfessionRequest.fromJS(_data["updateDelegatedProfessionRequest"]) : <any>null;
            this.updateSelfAdministratedRequest = _data["updateSelfAdministratedRequest"] ? UpdateSelfAdministratedRequest.fromJS(_data["updateSelfAdministratedRequest"]) : <any>null;
            this.updateDescriptionRequest = _data["updateDescriptionRequest"] ? UpdateDescriptionRequest.fromJS(_data["updateDescriptionRequest"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateDosedAdministrationMetadataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDosedAdministrationMetadataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateDelegatedProfessionRequest"] = this.updateDelegatedProfessionRequest ? this.updateDelegatedProfessionRequest.toJSON() : <any>null;
        data["updateSelfAdministratedRequest"] = this.updateSelfAdministratedRequest ? this.updateSelfAdministratedRequest.toJSON() : <any>null;
        data["updateDescriptionRequest"] = this.updateDescriptionRequest ? this.updateDescriptionRequest.toJSON() : <any>null;
        return data;
    }
}

export interface IUpdateDosedAdministrationMetadataRequest {
    updateDelegatedProfessionRequest?: UpdateDelegatedProfessionRequest | null;
    updateSelfAdministratedRequest?: UpdateSelfAdministratedRequest | null;
    updateDescriptionRequest?: UpdateDescriptionRequest | null;
}

export class UpdateDelegatedProfessionRequest implements IUpdateDelegatedProfessionRequest {
    isDelegated!: boolean;
    delegatedProfessionId!: number;

    constructor(data?: IUpdateDelegatedProfessionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDelegated = _data["isDelegated"] !== undefined ? _data["isDelegated"] : <any>null;
            this.delegatedProfessionId = _data["delegatedProfessionId"] !== undefined ? _data["delegatedProfessionId"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateDelegatedProfessionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDelegatedProfessionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDelegated"] = this.isDelegated !== undefined ? this.isDelegated : <any>null;
        data["delegatedProfessionId"] = this.delegatedProfessionId !== undefined ? this.delegatedProfessionId : <any>null;
        return data;
    }
}

export interface IUpdateDelegatedProfessionRequest {
    isDelegated: boolean;
    delegatedProfessionId: number;
}

export class UpdateSelfAdministratedRequest implements IUpdateSelfAdministratedRequest {
    selfAdministrated!: boolean;

    constructor(data?: IUpdateSelfAdministratedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selfAdministrated = _data["selfAdministrated"] !== undefined ? _data["selfAdministrated"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateSelfAdministratedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSelfAdministratedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selfAdministrated"] = this.selfAdministrated !== undefined ? this.selfAdministrated : <any>null;
        return data;
    }
}

export interface IUpdateSelfAdministratedRequest {
    selfAdministrated: boolean;
}

export class UpdateDescriptionRequest implements IUpdateDescriptionRequest {
    description?: string | null;

    constructor(data?: IUpdateDescriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateDescriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDescriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data;
    }
}

export interface IUpdateDescriptionRequest {
    description?: string | null;
}

export class SetAdministrationInstructionsRequest implements ISetAdministrationInstructionsRequest {
    instructions?: InstructionIdRequest[] | null;

    constructor(data?: ISetAdministrationInstructionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["instructions"])) {
                this.instructions = [] as any;
                for (let item of _data["instructions"])
                    this.instructions!.push(InstructionIdRequest.fromJS(item));
            }
            else {
                this.instructions = <any>null;
            }
        }
    }

    static fromJS(data: any): SetAdministrationInstructionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetAdministrationInstructionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.instructions)) {
            data["instructions"] = [];
            for (let item of this.instructions)
                data["instructions"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface ISetAdministrationInstructionsRequest {
    instructions?: InstructionIdRequest[] | null;
}

export class InstructionIdRequest implements IInstructionIdRequest {
    id?: string | null;
    order!: number;

    constructor(data?: IInstructionIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
        }
    }

    static fromJS(data: any): InstructionIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InstructionIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        return data;
    }
}

export interface IInstructionIdRequest {
    id?: string | null;
    order: number;
}

export class NotDispensedAdministrationDetailsResponse implements INotDispensedAdministrationDetailsResponse {
    id!: number;
    registrationState?: string | null;
    activeIngredient?: string | null;
    dosageText?: string | null;
    dosageUnit?: string | null;
    drugForm?: string | null;
    drugPackageSizeTitle?: string | null;
    indicationText?: string | null;
    name?: string | null;
    pauseStart?: moment.Moment | null;
    pauseEnd?: moment.Moment | null;
    prescriberDisplayName?: string | null;
    prescriberTitle?: string | null;
    remarks?: string | null;
    sideEffects?: string | null;
    strength?: string | null;
    treatmentEndDate?: moment.Moment | null;
    treatmentStartDate?: moment.Moment | null;
    dosageValue?: number | null;
    tooltip?: string | null;
    isDelegated!: boolean;
    delegatedProfessionId!: number;
    description?: string | null;
    instructions?: AdministrationInstruction[] | null;
    isDeliveryWorkFlow!: boolean;
    isCooperationWorkflow!: boolean;
    isRegistrable!: boolean;

    constructor(data?: INotDispensedAdministrationDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.registrationState = _data["registrationState"] !== undefined ? _data["registrationState"] : <any>null;
            this.activeIngredient = _data["activeIngredient"] !== undefined ? _data["activeIngredient"] : <any>null;
            this.dosageText = _data["dosageText"] !== undefined ? _data["dosageText"] : <any>null;
            this.dosageUnit = _data["dosageUnit"] !== undefined ? _data["dosageUnit"] : <any>null;
            this.drugForm = _data["drugForm"] !== undefined ? _data["drugForm"] : <any>null;
            this.drugPackageSizeTitle = _data["drugPackageSizeTitle"] !== undefined ? _data["drugPackageSizeTitle"] : <any>null;
            this.indicationText = _data["indicationText"] !== undefined ? _data["indicationText"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.pauseStart = _data["pauseStart"] ? moment(_data["pauseStart"].toString()) : <any>null;
            this.pauseEnd = _data["pauseEnd"] ? moment(_data["pauseEnd"].toString()) : <any>null;
            this.prescriberDisplayName = _data["prescriberDisplayName"] !== undefined ? _data["prescriberDisplayName"] : <any>null;
            this.prescriberTitle = _data["prescriberTitle"] !== undefined ? _data["prescriberTitle"] : <any>null;
            this.remarks = _data["remarks"] !== undefined ? _data["remarks"] : <any>null;
            this.sideEffects = _data["sideEffects"] !== undefined ? _data["sideEffects"] : <any>null;
            this.strength = _data["strength"] !== undefined ? _data["strength"] : <any>null;
            this.treatmentEndDate = _data["treatmentEndDate"] ? moment(_data["treatmentEndDate"].toString()) : <any>null;
            this.treatmentStartDate = _data["treatmentStartDate"] ? moment(_data["treatmentStartDate"].toString()) : <any>null;
            this.dosageValue = _data["dosageValue"] !== undefined ? _data["dosageValue"] : <any>null;
            this.tooltip = _data["tooltip"] !== undefined ? _data["tooltip"] : <any>null;
            this.isDelegated = _data["isDelegated"] !== undefined ? _data["isDelegated"] : <any>null;
            this.delegatedProfessionId = _data["delegatedProfessionId"] !== undefined ? _data["delegatedProfessionId"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            if (Array.isArray(_data["instructions"])) {
                this.instructions = [] as any;
                for (let item of _data["instructions"])
                    this.instructions!.push(AdministrationInstruction.fromJS(item));
            }
            else {
                this.instructions = <any>null;
            }
            this.isDeliveryWorkFlow = _data["isDeliveryWorkFlow"] !== undefined ? _data["isDeliveryWorkFlow"] : <any>null;
            this.isCooperationWorkflow = _data["isCooperationWorkflow"] !== undefined ? _data["isCooperationWorkflow"] : <any>null;
            this.isRegistrable = _data["isRegistrable"] !== undefined ? _data["isRegistrable"] : <any>null;
        }
    }

    static fromJS(data: any): NotDispensedAdministrationDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NotDispensedAdministrationDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["registrationState"] = this.registrationState !== undefined ? this.registrationState : <any>null;
        data["activeIngredient"] = this.activeIngredient !== undefined ? this.activeIngredient : <any>null;
        data["dosageText"] = this.dosageText !== undefined ? this.dosageText : <any>null;
        data["dosageUnit"] = this.dosageUnit !== undefined ? this.dosageUnit : <any>null;
        data["drugForm"] = this.drugForm !== undefined ? this.drugForm : <any>null;
        data["drugPackageSizeTitle"] = this.drugPackageSizeTitle !== undefined ? this.drugPackageSizeTitle : <any>null;
        data["indicationText"] = this.indicationText !== undefined ? this.indicationText : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["pauseStart"] = this.pauseStart ? this.pauseStart.toISOString() : <any>null;
        data["pauseEnd"] = this.pauseEnd ? this.pauseEnd.toISOString() : <any>null;
        data["prescriberDisplayName"] = this.prescriberDisplayName !== undefined ? this.prescriberDisplayName : <any>null;
        data["prescriberTitle"] = this.prescriberTitle !== undefined ? this.prescriberTitle : <any>null;
        data["remarks"] = this.remarks !== undefined ? this.remarks : <any>null;
        data["sideEffects"] = this.sideEffects !== undefined ? this.sideEffects : <any>null;
        data["strength"] = this.strength !== undefined ? this.strength : <any>null;
        data["treatmentEndDate"] = this.treatmentEndDate ? this.treatmentEndDate.format('YYYY-MM-DD') : <any>null;
        data["treatmentStartDate"] = this.treatmentStartDate ? this.treatmentStartDate.format('YYYY-MM-DD') : <any>null;
        data["dosageValue"] = this.dosageValue !== undefined ? this.dosageValue : <any>null;
        data["tooltip"] = this.tooltip !== undefined ? this.tooltip : <any>null;
        data["isDelegated"] = this.isDelegated !== undefined ? this.isDelegated : <any>null;
        data["delegatedProfessionId"] = this.delegatedProfessionId !== undefined ? this.delegatedProfessionId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        if (Array.isArray(this.instructions)) {
            data["instructions"] = [];
            for (let item of this.instructions)
                data["instructions"].push(item ? item.toJSON() : <any>null);
        }
        data["isDeliveryWorkFlow"] = this.isDeliveryWorkFlow !== undefined ? this.isDeliveryWorkFlow : <any>null;
        data["isCooperationWorkflow"] = this.isCooperationWorkflow !== undefined ? this.isCooperationWorkflow : <any>null;
        data["isRegistrable"] = this.isRegistrable !== undefined ? this.isRegistrable : <any>null;
        return data;
    }
}

export interface INotDispensedAdministrationDetailsResponse {
    id: number;
    registrationState?: string | null;
    activeIngredient?: string | null;
    dosageText?: string | null;
    dosageUnit?: string | null;
    drugForm?: string | null;
    drugPackageSizeTitle?: string | null;
    indicationText?: string | null;
    name?: string | null;
    pauseStart?: moment.Moment | null;
    pauseEnd?: moment.Moment | null;
    prescriberDisplayName?: string | null;
    prescriberTitle?: string | null;
    remarks?: string | null;
    sideEffects?: string | null;
    strength?: string | null;
    treatmentEndDate?: moment.Moment | null;
    treatmentStartDate?: moment.Moment | null;
    dosageValue?: number | null;
    tooltip?: string | null;
    isDelegated: boolean;
    delegatedProfessionId: number;
    description?: string | null;
    instructions?: AdministrationInstruction[] | null;
    isDeliveryWorkFlow: boolean;
    isCooperationWorkflow: boolean;
    isRegistrable: boolean;
}

export class PlannedAdministrationNotDispensedRequest implements IPlannedAdministrationNotDispensedRequest {
    prescriptionId!: number;
    registrationTime!: moment.Moment;
    currentRegistrationState?: string | null;
    registrationReason?: string | null;

    constructor(data?: IPlannedAdministrationNotDispensedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionId = _data["prescriptionId"] !== undefined ? _data["prescriptionId"] : <any>null;
            this.registrationTime = _data["registrationTime"] ? moment(_data["registrationTime"].toString()) : <any>null;
            this.currentRegistrationState = _data["currentRegistrationState"] !== undefined ? _data["currentRegistrationState"] : <any>null;
            this.registrationReason = _data["registrationReason"] !== undefined ? _data["registrationReason"] : <any>null;
        }
    }

    static fromJS(data: any): PlannedAdministrationNotDispensedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedAdministrationNotDispensedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionId"] = this.prescriptionId !== undefined ? this.prescriptionId : <any>null;
        data["registrationTime"] = this.registrationTime ? this.registrationTime.toISOString() : <any>null;
        data["currentRegistrationState"] = this.currentRegistrationState !== undefined ? this.currentRegistrationState : <any>null;
        data["registrationReason"] = this.registrationReason !== undefined ? this.registrationReason : <any>null;
        return data;
    }
}

export interface IPlannedAdministrationNotDispensedRequest {
    prescriptionId: number;
    registrationTime: moment.Moment;
    currentRegistrationState?: string | null;
    registrationReason?: string | null;
}

export class UpdateNotDispensedMetadataRequest implements IUpdateNotDispensedMetadataRequest {
    selfAdministrated!: boolean;
    isDelegated!: boolean;
    delegatedProfessionId!: number;
    description?: string | null;

    constructor(data?: IUpdateNotDispensedMetadataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selfAdministrated = _data["selfAdministrated"] !== undefined ? _data["selfAdministrated"] : <any>null;
            this.isDelegated = _data["isDelegated"] !== undefined ? _data["isDelegated"] : <any>null;
            this.delegatedProfessionId = _data["delegatedProfessionId"] !== undefined ? _data["delegatedProfessionId"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateNotDispensedMetadataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotDispensedMetadataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selfAdministrated"] = this.selfAdministrated !== undefined ? this.selfAdministrated : <any>null;
        data["isDelegated"] = this.isDelegated !== undefined ? this.isDelegated : <any>null;
        data["delegatedProfessionId"] = this.delegatedProfessionId !== undefined ? this.delegatedProfessionId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data;
    }
}

export interface IUpdateNotDispensedMetadataRequest {
    selfAdministrated: boolean;
    isDelegated: boolean;
    delegatedProfessionId: number;
    description?: string | null;
}

export class ObservationsRegistrationsResponse implements IObservationsRegistrationsResponse {
    id?: string | null;
    observationsName?: string | null;
    registrationTime!: moment.Moment;
    tags?: string[] | null;

    constructor(data?: IObservationsRegistrationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.observationsName = _data["observationsName"] !== undefined ? _data["observationsName"] : <any>null;
            this.registrationTime = _data["registrationTime"] ? moment(_data["registrationTime"].toString()) : <any>null;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            else {
                this.tags = <any>null;
            }
        }
    }

    static fromJS(data: any): ObservationsRegistrationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationsRegistrationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["observationsName"] = this.observationsName !== undefined ? this.observationsName : <any>null;
        data["registrationTime"] = this.registrationTime ? this.registrationTime.toISOString() : <any>null;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface IObservationsRegistrationsResponse {
    id?: string | null;
    observationsName?: string | null;
    registrationTime: moment.Moment;
    tags?: string[] | null;
}

export class FormResponse implements IFormResponse {
    id?: string | null;
    items?: ItemResponse[] | null;
    observationTimestamp!: moment.Moment;
    formDefinition?: FormDefinitionResponse | null;
    tags?: TagResponse[] | null;
    conditions?: ConditionResponse[] | null;

    protected _discriminator: string;

    constructor(data?: IFormResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "FormResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ItemResponse.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
            this.observationTimestamp = _data["observationTimestamp"] ? moment(_data["observationTimestamp"].toString()) : <any>null;
            this.formDefinition = _data["formDefinition"] ? FormDefinitionResponse.fromJS(_data["formDefinition"]) : <any>null;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagResponse.fromJS(item));
            }
            else {
                this.tags = <any>null;
            }
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(ConditionResponse.fromJS(item));
            }
            else {
                this.conditions = <any>null;
            }
        }
    }

    static fromJS(data: any): FormResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["swagger_discriminator"] = this._discriminator;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>null);
        }
        data["observationTimestamp"] = this.observationTimestamp ? this.observationTimestamp.toISOString() : <any>null;
        data["formDefinition"] = this.formDefinition ? this.formDefinition.toJSON() : <any>null;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IFormResponse {
    id?: string | null;
    items?: ItemResponse[] | null;
    observationTimestamp: moment.Moment;
    formDefinition?: FormDefinitionResponse | null;
    tags?: TagResponse[] | null;
    conditions?: ConditionResponse[] | null;
}

export class ItemResponse implements IItemResponse {
    id?: string | null;
    label?: string | null;
    children?: ItemResponse[] | null;
    importantInformation!: boolean;
    type?: string | null;

    protected _discriminator: string;

    constructor(data?: IItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "ItemResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(ItemResponse.fromJS(item));
            }
            else {
                this.children = <any>null;
            }
            this.importantInformation = _data["importantInformation"] !== undefined ? _data["importantInformation"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): ItemResponse {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "HeaderResponse") {
            let result = new HeaderResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "StaticTextResponse") {
            let result = new StaticTextResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "LinkResponse") {
            let result = new LinkResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "HorizontalRuleResponse") {
            let result = new HorizontalRuleResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "SwitchGroupResponse") {
            let result = new SwitchGroupResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "DivisionGroupResponse") {
            let result = new DivisionGroupResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "InputFieldResponse") {
            let result = new InputFieldResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "RadioGroupResponse") {
            let result = new RadioGroupResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "TextAreaResponse") {
            let result = new TextAreaResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "CheckGroupResponse") {
            let result = new CheckGroupResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "DateTimeResponse") {
            let result = new DateTimeResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "DecimalResponse") {
            let result = new DecimalResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "DropDownResponse") {
            let result = new DropDownResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "DateResponse") {
            let result = new DateResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "NumberResponse") {
            let result = new NumberResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "TextResponse") {
            let result = new TextResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "RadioTreeResponse") {
            let result = new RadioTreeResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "EditableLinkResponse") {
            let result = new EditableLinkResponse();
            result.init(data);
            return result;
        }
        let result = new ItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["swagger_discriminator"] = this._discriminator;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : <any>null);
        }
        data["importantInformation"] = this.importantInformation !== undefined ? this.importantInformation : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}

export interface IItemResponse {
    id?: string | null;
    label?: string | null;
    children?: ItemResponse[] | null;
    importantInformation: boolean;
    type?: string | null;
}

export class HeaderResponse extends ItemResponse implements IHeaderResponse {

    constructor(data?: IHeaderResponse) {
        super(data);
        this._discriminator = "HeaderResponse";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): HeaderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HeaderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IHeaderResponse extends IItemResponse {
}

export class StaticTextResponse extends ItemResponse implements IStaticTextResponse {

    constructor(data?: IStaticTextResponse) {
        super(data);
        this._discriminator = "StaticTextResponse";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): StaticTextResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StaticTextResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStaticTextResponse extends IItemResponse {
}

export class LinkResponse extends ItemResponse implements ILinkResponse {
    link?: string | null;

    constructor(data?: ILinkResponse) {
        super(data);
        this._discriminator = "LinkResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.link = _data["link"] !== undefined ? _data["link"] : <any>null;
        }
    }

    static fromJS(data: any): LinkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LinkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link !== undefined ? this.link : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ILinkResponse extends IItemResponse {
    link?: string | null;
}

export class HorizontalRuleResponse extends ItemResponse implements IHorizontalRuleResponse {

    constructor(data?: IHorizontalRuleResponse) {
        super(data);
        this._discriminator = "HorizontalRuleResponse";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): HorizontalRuleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HorizontalRuleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IHorizontalRuleResponse extends IItemResponse {
}

export class SwitchGroupResponse extends ItemResponse implements ISwitchGroupResponse {
    selected!: boolean;

    constructor(data?: ISwitchGroupResponse) {
        super(data);
        this._discriminator = "SwitchGroupResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.selected = _data["selected"] !== undefined ? _data["selected"] : <any>null;
        }
    }

    static fromJS(data: any): SwitchGroupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchGroupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selected"] = this.selected !== undefined ? this.selected : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISwitchGroupResponse extends IItemResponse {
    selected: boolean;
}

export class DivisionGroupResponse extends ItemResponse implements IDivisionGroupResponse {
    expanded!: boolean;

    constructor(data?: IDivisionGroupResponse) {
        super(data);
        this._discriminator = "DivisionGroupResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.expanded = _data["expanded"] !== undefined ? _data["expanded"] : <any>null;
        }
    }

    static fromJS(data: any): DivisionGroupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DivisionGroupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expanded"] = this.expanded !== undefined ? this.expanded : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDivisionGroupResponse extends IItemResponse {
    expanded: boolean;
}

export class InputFieldResponse extends ItemResponse implements IInputFieldResponse {
    tooltip?: string | null;
    unit?: string | null;
    required!: boolean;
    systemManaged!: boolean;
    markup?: string | null;
    conceptName?: string | null;

    constructor(data?: IInputFieldResponse) {
        super(data);
        this._discriminator = "InputFieldResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tooltip = _data["tooltip"] !== undefined ? _data["tooltip"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
            this.required = _data["required"] !== undefined ? _data["required"] : <any>null;
            this.systemManaged = _data["systemManaged"] !== undefined ? _data["systemManaged"] : <any>null;
            this.markup = _data["markup"] !== undefined ? _data["markup"] : <any>null;
            this.conceptName = _data["conceptName"] !== undefined ? _data["conceptName"] : <any>null;
        }
    }

    static fromJS(data: any): InputFieldResponse {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "RadioGroupResponse") {
            let result = new RadioGroupResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "TextAreaResponse") {
            let result = new TextAreaResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "CheckGroupResponse") {
            let result = new CheckGroupResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "DateTimeResponse") {
            let result = new DateTimeResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "DecimalResponse") {
            let result = new DecimalResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "DropDownResponse") {
            let result = new DropDownResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "DateResponse") {
            let result = new DateResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "NumberResponse") {
            let result = new NumberResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "TextResponse") {
            let result = new TextResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "RadioTreeResponse") {
            let result = new RadioTreeResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "EditableLinkResponse") {
            let result = new EditableLinkResponse();
            result.init(data);
            return result;
        }
        let result = new InputFieldResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tooltip"] = this.tooltip !== undefined ? this.tooltip : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        data["required"] = this.required !== undefined ? this.required : <any>null;
        data["systemManaged"] = this.systemManaged !== undefined ? this.systemManaged : <any>null;
        data["markup"] = this.markup !== undefined ? this.markup : <any>null;
        data["conceptName"] = this.conceptName !== undefined ? this.conceptName : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IInputFieldResponse extends IItemResponse {
    tooltip?: string | null;
    unit?: string | null;
    required: boolean;
    systemManaged: boolean;
    markup?: string | null;
    conceptName?: string | null;
}

export class RadioGroupResponse extends InputFieldResponse implements IRadioGroupResponse {
    value?: ValueConceptResponse | null;
    possibleValues?: ValueConceptResponse[] | null;

    constructor(data?: IRadioGroupResponse) {
        super(data);
        this._discriminator = "RadioGroupResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? ValueConceptResponse.fromJS(_data["value"]) : <any>null;
            if (Array.isArray(_data["possibleValues"])) {
                this.possibleValues = [] as any;
                for (let item of _data["possibleValues"])
                    this.possibleValues!.push(ValueConceptResponse.fromJS(item));
            }
            else {
                this.possibleValues = <any>null;
            }
        }
    }

    static fromJS(data: any): RadioGroupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RadioGroupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>null;
        if (Array.isArray(this.possibleValues)) {
            data["possibleValues"] = [];
            for (let item of this.possibleValues)
                data["possibleValues"].push(item ? item.toJSON() : <any>null);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IRadioGroupResponse extends IInputFieldResponse {
    value?: ValueConceptResponse | null;
    possibleValues?: ValueConceptResponse[] | null;
}

export class ValueConceptResponse implements IValueConceptResponse {
    id?: string | null;
    name?: string | null;

    constructor(data?: IValueConceptResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): ValueConceptResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValueConceptResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IValueConceptResponse {
    id?: string | null;
    name?: string | null;
}

export class TextAreaResponse extends InputFieldResponse implements ITextAreaResponse {
    value?: string | null;

    constructor(data?: ITextAreaResponse) {
        super(data);
        this._discriminator = "TextAreaResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): TextAreaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TextAreaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITextAreaResponse extends IInputFieldResponse {
    value?: string | null;
}

export class CheckGroupResponse extends InputFieldResponse implements ICheckGroupResponse {
    value?: ValueConceptResponse[] | null;
    possibleValues?: ValueConceptResponse[] | null;

    constructor(data?: ICheckGroupResponse) {
        super(data);
        this._discriminator = "CheckGroupResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(ValueConceptResponse.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
            if (Array.isArray(_data["possibleValues"])) {
                this.possibleValues = [] as any;
                for (let item of _data["possibleValues"])
                    this.possibleValues!.push(ValueConceptResponse.fromJS(item));
            }
            else {
                this.possibleValues = <any>null;
            }
        }
    }

    static fromJS(data: any): CheckGroupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckGroupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.possibleValues)) {
            data["possibleValues"] = [];
            for (let item of this.possibleValues)
                data["possibleValues"].push(item ? item.toJSON() : <any>null);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICheckGroupResponse extends IInputFieldResponse {
    value?: ValueConceptResponse[] | null;
    possibleValues?: ValueConceptResponse[] | null;
}

export class DateTimeResponse extends InputFieldResponse implements IDateTimeResponse {
    value?: moment.Moment | null;

    constructor(data?: IDateTimeResponse) {
        super(data);
        this._discriminator = "DateTimeResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? moment(_data["value"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): DateTimeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDateTimeResponse extends IInputFieldResponse {
    value?: moment.Moment | null;
}

export class DecimalResponse extends InputFieldResponse implements IDecimalResponse {
    value?: number | null;

    constructor(data?: IDecimalResponse) {
        super(data);
        this._discriminator = "DecimalResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): DecimalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DecimalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDecimalResponse extends IInputFieldResponse {
    value?: number | null;
}

export class DropDownResponse extends InputFieldResponse implements IDropDownResponse {
    value?: ValueConceptResponse | null;
    possibleValues?: ValueConceptResponse[] | null;

    constructor(data?: IDropDownResponse) {
        super(data);
        this._discriminator = "DropDownResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? ValueConceptResponse.fromJS(_data["value"]) : <any>null;
            if (Array.isArray(_data["possibleValues"])) {
                this.possibleValues = [] as any;
                for (let item of _data["possibleValues"])
                    this.possibleValues!.push(ValueConceptResponse.fromJS(item));
            }
            else {
                this.possibleValues = <any>null;
            }
        }
    }

    static fromJS(data: any): DropDownResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DropDownResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>null;
        if (Array.isArray(this.possibleValues)) {
            data["possibleValues"] = [];
            for (let item of this.possibleValues)
                data["possibleValues"].push(item ? item.toJSON() : <any>null);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDropDownResponse extends IInputFieldResponse {
    value?: ValueConceptResponse | null;
    possibleValues?: ValueConceptResponse[] | null;
}

export class DateResponse extends InputFieldResponse implements IDateResponse {
    value?: moment.Moment | null;

    constructor(data?: IDateResponse) {
        super(data);
        this._discriminator = "DateResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? moment(_data["value"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): DateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDateResponse extends IInputFieldResponse {
    value?: moment.Moment | null;
}

export class NumberResponse extends InputFieldResponse implements INumberResponse {
    value?: number | null;

    constructor(data?: INumberResponse) {
        super(data);
        this._discriminator = "NumberResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): NumberResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NumberResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INumberResponse extends IInputFieldResponse {
    value?: number | null;
}

export class TextResponse extends InputFieldResponse implements ITextResponse {
    value?: string | null;

    constructor(data?: ITextResponse) {
        super(data);
        this._discriminator = "TextResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): TextResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TextResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITextResponse extends IInputFieldResponse {
    value?: string | null;
}

export class RadioTreeResponse extends InputFieldResponse implements IRadioTreeResponse {
    value?: any | null;

    constructor(data?: IRadioTreeResponse) {
        super(data);
        this._discriminator = "RadioTreeResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): RadioTreeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RadioTreeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IRadioTreeResponse extends IInputFieldResponse {
    value?: any | null;
}

export class EditableLinkResponse extends InputFieldResponse implements IEditableLinkResponse {
    value?: string | null;
    link?: string | null;
    linkTitle?: string | null;

    constructor(data?: IEditableLinkResponse) {
        super(data);
        this._discriminator = "EditableLinkResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.link = _data["link"] !== undefined ? _data["link"] : <any>null;
            this.linkTitle = _data["linkTitle"] !== undefined ? _data["linkTitle"] : <any>null;
        }
    }

    static fromJS(data: any): EditableLinkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditableLinkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["link"] = this.link !== undefined ? this.link : <any>null;
        data["linkTitle"] = this.linkTitle !== undefined ? this.linkTitle : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEditableLinkResponse extends IInputFieldResponse {
    value?: string | null;
    link?: string | null;
    linkTitle?: string | null;
}

export class FormDefinitionResponse implements IFormDefinitionResponse {
    id!: number;
    title?: string | null;
    tagsRequired!: boolean;

    constructor(data?: IFormDefinitionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.tagsRequired = _data["tagsRequired"] !== undefined ? _data["tagsRequired"] : <any>null;
        }
    }

    static fromJS(data: any): FormDefinitionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormDefinitionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["tagsRequired"] = this.tagsRequired !== undefined ? this.tagsRequired : <any>null;
        return data;
    }
}

export interface IFormDefinitionResponse {
    id: number;
    title?: string | null;
    tagsRequired: boolean;
}

export class TagResponse implements ITagResponse {
    id!: number;
    name?: string | null;
    description?: string | null;
    active!: boolean;

    constructor(data?: ITagResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
        }
    }

    static fromJS(data: any): TagResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TagResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        return data;
    }
}

export interface ITagResponse {
    id: number;
    name?: string | null;
    description?: string | null;
    active: boolean;
}

export class ConditionResponse implements IConditionResponse {
    id!: number;
    name?: string | null;
    active!: boolean;

    constructor(data?: IConditionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
        }
    }

    static fromJS(data: any): ConditionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        return data;
    }
}

export interface IConditionResponse {
    id: number;
    name?: string | null;
    active: boolean;
}

export class FormPrototypeResponse implements IFormPrototypeResponse {
    id?: string | null;
    items?: ItemResponse[] | null;
    tags?: TagResponse[] | null;
    availableTags?: TagResponse[] | null;
    availableInitialActions?: AvailableActionResponse2[] | null;
    availableConditions?: AvailableConditionResponse[] | null;
    availablePathwayPlacements?: AvailablePathwayPlacementResponse[] | null;
    formDefinition?: FormDefinitionResponse | null;

    constructor(data?: IFormPrototypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ItemResponse.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagResponse.fromJS(item));
            }
            else {
                this.tags = <any>null;
            }
            if (Array.isArray(_data["availableTags"])) {
                this.availableTags = [] as any;
                for (let item of _data["availableTags"])
                    this.availableTags!.push(TagResponse.fromJS(item));
            }
            else {
                this.availableTags = <any>null;
            }
            if (Array.isArray(_data["availableInitialActions"])) {
                this.availableInitialActions = [] as any;
                for (let item of _data["availableInitialActions"])
                    this.availableInitialActions!.push(AvailableActionResponse2.fromJS(item));
            }
            else {
                this.availableInitialActions = <any>null;
            }
            if (Array.isArray(_data["availableConditions"])) {
                this.availableConditions = [] as any;
                for (let item of _data["availableConditions"])
                    this.availableConditions!.push(AvailableConditionResponse.fromJS(item));
            }
            else {
                this.availableConditions = <any>null;
            }
            if (Array.isArray(_data["availablePathwayPlacements"])) {
                this.availablePathwayPlacements = [] as any;
                for (let item of _data["availablePathwayPlacements"])
                    this.availablePathwayPlacements!.push(AvailablePathwayPlacementResponse.fromJS(item));
            }
            else {
                this.availablePathwayPlacements = <any>null;
            }
            this.formDefinition = _data["formDefinition"] ? FormDefinitionResponse.fromJS(_data["formDefinition"]) : <any>null;
        }
    }

    static fromJS(data: any): FormPrototypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormPrototypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.availableTags)) {
            data["availableTags"] = [];
            for (let item of this.availableTags)
                data["availableTags"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.availableInitialActions)) {
            data["availableInitialActions"] = [];
            for (let item of this.availableInitialActions)
                data["availableInitialActions"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.availableConditions)) {
            data["availableConditions"] = [];
            for (let item of this.availableConditions)
                data["availableConditions"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.availablePathwayPlacements)) {
            data["availablePathwayPlacements"] = [];
            for (let item of this.availablePathwayPlacements)
                data["availablePathwayPlacements"].push(item ? item.toJSON() : <any>null);
        }
        data["formDefinition"] = this.formDefinition ? this.formDefinition.toJSON() : <any>null;
        return data;
    }
}

export interface IFormPrototypeResponse {
    id?: string | null;
    items?: ItemResponse[] | null;
    tags?: TagResponse[] | null;
    availableTags?: TagResponse[] | null;
    availableInitialActions?: AvailableActionResponse2[] | null;
    availableConditions?: AvailableConditionResponse[] | null;
    availablePathwayPlacements?: AvailablePathwayPlacementResponse[] | null;
    formDefinition?: FormDefinitionResponse | null;
}

export class AvailableActionResponse2 implements IAvailableActionResponse2 {
    id!: number;
    name?: string | null;

    constructor(data?: IAvailableActionResponse2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): AvailableActionResponse2 {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableActionResponse2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IAvailableActionResponse2 {
    id: number;
    name?: string | null;
}

export class AvailableConditionResponse implements IAvailableConditionResponse {
    id!: number;
    name?: string | null;
    groupName?: string | null;
    law?: string | null;
    status!: Status;

    constructor(data?: IAvailableConditionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.groupName = _data["groupName"] !== undefined ? _data["groupName"] : <any>null;
            this.law = _data["law"] !== undefined ? _data["law"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): AvailableConditionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableConditionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["groupName"] = this.groupName !== undefined ? this.groupName : <any>null;
        data["law"] = this.law !== undefined ? this.law : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IAvailableConditionResponse {
    id: number;
    name?: string | null;
    groupName?: string | null;
    law?: string | null;
    status: Status;
}

export class AvailablePathwayPlacementResponse implements IAvailablePathwayPlacementResponse {
    children?: AvailablePathwayPlacementResponse[] | null;
    recommended!: boolean;
    name?: string | null;
    programPathwayId!: number;
    active!: boolean;

    constructor(data?: IAvailablePathwayPlacementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(AvailablePathwayPlacementResponse.fromJS(item));
            }
            else {
                this.children = <any>null;
            }
            this.recommended = _data["recommended"] !== undefined ? _data["recommended"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.programPathwayId = _data["programPathwayId"] !== undefined ? _data["programPathwayId"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
        }
    }

    static fromJS(data: any): AvailablePathwayPlacementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AvailablePathwayPlacementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : <any>null);
        }
        data["recommended"] = this.recommended !== undefined ? this.recommended : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["programPathwayId"] = this.programPathwayId !== undefined ? this.programPathwayId : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        return data;
    }
}

export interface IAvailablePathwayPlacementResponse {
    children?: AvailablePathwayPlacementResponse[] | null;
    recommended: boolean;
    name?: string | null;
    programPathwayId: number;
    active: boolean;
}

export class ObservationsTypeResponse implements IObservationsTypeResponse {
    id!: number;
    title?: string | null;

    constructor(data?: IObservationsTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): ObservationsTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationsTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data;
    }
}

export interface IObservationsTypeResponse {
    id: number;
    title?: string | null;
}

export class CreateRegistrationRequest implements ICreateRegistrationRequest {
    form?: FormRequest | null;
    actionId?: number | null;
    selectedProgramPathwayId?: number | null;
    conditions?: ConditionRequest[] | null;

    constructor(data?: ICreateRegistrationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.form = _data["form"] ? FormRequest.fromJS(_data["form"]) : <any>null;
            this.actionId = _data["actionId"] !== undefined ? _data["actionId"] : <any>null;
            this.selectedProgramPathwayId = _data["selectedProgramPathwayId"] !== undefined ? _data["selectedProgramPathwayId"] : <any>null;
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(ConditionRequest.fromJS(item));
            }
            else {
                this.conditions = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateRegistrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegistrationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["form"] = this.form ? this.form.toJSON() : <any>null;
        data["actionId"] = this.actionId !== undefined ? this.actionId : <any>null;
        data["selectedProgramPathwayId"] = this.selectedProgramPathwayId !== undefined ? this.selectedProgramPathwayId : <any>null;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface ICreateRegistrationRequest {
    form?: FormRequest | null;
    actionId?: number | null;
    selectedProgramPathwayId?: number | null;
    conditions?: ConditionRequest[] | null;
}

export class FormRequest implements IFormRequest {
    id!: number;
    observationTimestamp?: moment.Moment | null;
    items?: ItemRequest[] | null;
    tags?: TagRequest[] | null;

    constructor(data?: IFormRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.observationTimestamp = _data["observationTimestamp"] ? moment(_data["observationTimestamp"].toString()) : <any>null;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ItemRequest.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagRequest.fromJS(item));
            }
            else {
                this.tags = <any>null;
            }
        }
    }

    static fromJS(data: any): FormRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FormRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["observationTimestamp"] = this.observationTimestamp ? this.observationTimestamp.toISOString() : <any>null;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>null);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IFormRequest {
    id: number;
    observationTimestamp?: moment.Moment | null;
    items?: ItemRequest[] | null;
    tags?: TagRequest[] | null;
}

export class ItemRequest implements IItemRequest {
    id?: string | null;
    children?: ItemRequest[] | null;

    protected _discriminator: string;

    constructor(data?: IItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "ItemRequest";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(ItemRequest.fromJS(item));
            }
            else {
                this.children = <any>null;
            }
        }
    }

    static fromJS(data: any): ItemRequest {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "HeaderRequest") {
            let result = new HeaderRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "StaticTextRequest") {
            let result = new StaticTextRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "LinkRequest") {
            let result = new LinkRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "HorizontalRuleRequest") {
            let result = new HorizontalRuleRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "SwitchGroupRequest") {
            let result = new SwitchGroupRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "DivisionGroupRequest") {
            let result = new DivisionGroupRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "InputFieldRequest") {
            let result = new InputFieldRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "RadioGroupRequest") {
            let result = new RadioGroupRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "TextAreaRequest") {
            let result = new TextAreaRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "CheckGroupRequest") {
            let result = new CheckGroupRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "DateTimeRequest") {
            let result = new DateTimeRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "DecimalRequest") {
            let result = new DecimalRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "DropDownRequest") {
            let result = new DropDownRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "DateRequest") {
            let result = new DateRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "NumberRequest") {
            let result = new NumberRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "TextRequest") {
            let result = new TextRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "RadioTreeRequest") {
            let result = new RadioTreeRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "EditableLinkRequest") {
            let result = new EditableLinkRequest();
            result.init(data);
            return result;
        }
        let result = new ItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["swagger_discriminator"] = this._discriminator;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IItemRequest {
    id?: string | null;
    children?: ItemRequest[] | null;
}

export class HeaderRequest extends ItemRequest implements IHeaderRequest {

    constructor(data?: IHeaderRequest) {
        super(data);
        this._discriminator = "HeaderRequest";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): HeaderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HeaderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IHeaderRequest extends IItemRequest {
}

export class StaticTextRequest extends ItemRequest implements IStaticTextRequest {

    constructor(data?: IStaticTextRequest) {
        super(data);
        this._discriminator = "StaticTextRequest";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): StaticTextRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StaticTextRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IStaticTextRequest extends IItemRequest {
}

export class LinkRequest extends ItemRequest implements ILinkRequest {

    constructor(data?: ILinkRequest) {
        super(data);
        this._discriminator = "LinkRequest";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): LinkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LinkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ILinkRequest extends IItemRequest {
}

export class HorizontalRuleRequest extends ItemRequest implements IHorizontalRuleRequest {

    constructor(data?: IHorizontalRuleRequest) {
        super(data);
        this._discriminator = "HorizontalRuleRequest";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): HorizontalRuleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HorizontalRuleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IHorizontalRuleRequest extends IItemRequest {
}

export class SwitchGroupRequest extends ItemRequest implements ISwitchGroupRequest {

    constructor(data?: ISwitchGroupRequest) {
        super(data);
        this._discriminator = "SwitchGroupRequest";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SwitchGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISwitchGroupRequest extends IItemRequest {
}

export class DivisionGroupRequest extends ItemRequest implements IDivisionGroupRequest {

    constructor(data?: IDivisionGroupRequest) {
        super(data);
        this._discriminator = "DivisionGroupRequest";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DivisionGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DivisionGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDivisionGroupRequest extends IItemRequest {
}

export class InputFieldRequest extends ItemRequest implements IInputFieldRequest {

    constructor(data?: IInputFieldRequest) {
        super(data);
        this._discriminator = "InputFieldRequest";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): InputFieldRequest {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "RadioGroupRequest") {
            let result = new RadioGroupRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "TextAreaRequest") {
            let result = new TextAreaRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "CheckGroupRequest") {
            let result = new CheckGroupRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "DateTimeRequest") {
            let result = new DateTimeRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "DecimalRequest") {
            let result = new DecimalRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "DropDownRequest") {
            let result = new DropDownRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "DateRequest") {
            let result = new DateRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "NumberRequest") {
            let result = new NumberRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "TextRequest") {
            let result = new TextRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "RadioTreeRequest") {
            let result = new RadioTreeRequest();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "EditableLinkRequest") {
            let result = new EditableLinkRequest();
            result.init(data);
            return result;
        }
        let result = new InputFieldRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IInputFieldRequest extends IItemRequest {
}

export class RadioGroupRequest extends InputFieldRequest implements IRadioGroupRequest {
    value?: ValueConceptRequest | null;

    constructor(data?: IRadioGroupRequest) {
        super(data);
        this._discriminator = "RadioGroupRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? ValueConceptRequest.fromJS(_data["value"]) : <any>null;
        }
    }

    static fromJS(data: any): RadioGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RadioGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IRadioGroupRequest extends IInputFieldRequest {
    value?: ValueConceptRequest | null;
}

export class ValueConceptRequest implements IValueConceptRequest {
    id?: string | null;
    name?: string | null;

    constructor(data?: IValueConceptRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): ValueConceptRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValueConceptRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IValueConceptRequest {
    id?: string | null;
    name?: string | null;
}

export class TextAreaRequest extends InputFieldRequest implements ITextAreaRequest {
    value?: string | null;

    constructor(data?: ITextAreaRequest) {
        super(data);
        this._discriminator = "TextAreaRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): TextAreaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TextAreaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITextAreaRequest extends IInputFieldRequest {
    value?: string | null;
}

export class CheckGroupRequest extends InputFieldRequest implements ICheckGroupRequest {
    value?: ValueConceptRequest[] | null;

    constructor(data?: ICheckGroupRequest) {
        super(data);
        this._discriminator = "CheckGroupRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(ValueConceptRequest.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): CheckGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item ? item.toJSON() : <any>null);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICheckGroupRequest extends IInputFieldRequest {
    value?: ValueConceptRequest[] | null;
}

export class DateTimeRequest extends InputFieldRequest implements IDateTimeRequest {
    value?: moment.Moment | null;

    constructor(data?: IDateTimeRequest) {
        super(data);
        this._discriminator = "DateTimeRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? moment(_data["value"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): DateTimeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDateTimeRequest extends IInputFieldRequest {
    value?: moment.Moment | null;
}

export class DecimalRequest extends InputFieldRequest implements IDecimalRequest {
    value?: number | null;

    constructor(data?: IDecimalRequest) {
        super(data);
        this._discriminator = "DecimalRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): DecimalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DecimalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDecimalRequest extends IInputFieldRequest {
    value?: number | null;
}

export class DropDownRequest extends InputFieldRequest implements IDropDownRequest {
    value?: ValueConceptRequest | null;

    constructor(data?: IDropDownRequest) {
        super(data);
        this._discriminator = "DropDownRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? ValueConceptRequest.fromJS(_data["value"]) : <any>null;
        }
    }

    static fromJS(data: any): DropDownRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DropDownRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDropDownRequest extends IInputFieldRequest {
    value?: ValueConceptRequest | null;
}

export class DateRequest extends InputFieldRequest implements IDateRequest {
    value?: moment.Moment | null;

    constructor(data?: IDateRequest) {
        super(data);
        this._discriminator = "DateRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? moment(_data["value"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): DateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDateRequest extends IInputFieldRequest {
    value?: moment.Moment | null;
}

export class NumberRequest extends InputFieldRequest implements INumberRequest {
    value?: number | null;

    constructor(data?: INumberRequest) {
        super(data);
        this._discriminator = "NumberRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): NumberRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NumberRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INumberRequest extends IInputFieldRequest {
    value?: number | null;
}

export class TextRequest extends InputFieldRequest implements ITextRequest {
    value?: string | null;

    constructor(data?: ITextRequest) {
        super(data);
        this._discriminator = "TextRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): TextRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TextRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITextRequest extends IInputFieldRequest {
    value?: string | null;
}

export class RadioTreeRequest extends InputFieldRequest implements IRadioTreeRequest {
    value?: any | null;

    constructor(data?: IRadioTreeRequest) {
        super(data);
        this._discriminator = "RadioTreeRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): RadioTreeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RadioTreeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IRadioTreeRequest extends IInputFieldRequest {
    value?: any | null;
}

export class EditableLinkRequest extends InputFieldRequest implements IEditableLinkRequest {
    value?: string | null;

    constructor(data?: IEditableLinkRequest) {
        super(data);
        this._discriminator = "EditableLinkRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): EditableLinkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditableLinkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEditableLinkRequest extends IInputFieldRequest {
    value?: string | null;
}

export class TagRequest implements ITagRequest {
    id!: number;
    name?: string | null;
    description?: string | null;
    active!: boolean;

    constructor(data?: ITagRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
        }
    }

    static fromJS(data: any): TagRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TagRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        return data;
    }
}

export interface ITagRequest {
    id: number;
    name?: string | null;
    description?: string | null;
    active: boolean;
}

export class ConditionRequest implements IConditionRequest {
    id!: number;
    name?: string | null;
    active!: boolean;

    constructor(data?: IConditionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
        }
    }

    static fromJS(data: any): ConditionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        return data;
    }
}

export interface IConditionRequest {
    id: number;
    name?: string | null;
    active: boolean;
}

export class InitiateNexusSessionResponse implements IInitiateNexusSessionResponse {
    status!: InitiateNexusSessionStatus;
    employeeNexusInfo?: EmployeeNexusInfoResponse | null;

    constructor(data?: IInitiateNexusSessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.employeeNexusInfo = _data["employeeNexusInfo"] ? EmployeeNexusInfoResponse.fromJS(_data["employeeNexusInfo"]) : <any>null;
        }
    }

    static fromJS(data: any): InitiateNexusSessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InitiateNexusSessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["employeeNexusInfo"] = this.employeeNexusInfo ? this.employeeNexusInfo.toJSON() : <any>null;
        return data;
    }
}

export interface IInitiateNexusSessionResponse {
    status: InitiateNexusSessionStatus;
    employeeNexusInfo?: EmployeeNexusInfoResponse | null;
}

export enum InitiateNexusSessionStatus {
    Success = "Success",
    InitialNexusUserCouplingRequired = "InitialNexusUserCouplingRequired",
    UpdateNexusUserCouplingRequired = "UpdateNexusUserCouplingRequired",
    ConflictingNexusUser = "ConflictingNexusUser",
}

export class EmployeeNexusInfoResponse implements IEmployeeNexusInfoResponse {
    requestedTokenEmployeeName!: string;
    existingTokenEmployeeName?: string | null;
    employeeIdForNexusUserInUse?: string | null;
    idToken?: string | null;

    constructor(data?: IEmployeeNexusInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestedTokenEmployeeName = _data["requestedTokenEmployeeName"] !== undefined ? _data["requestedTokenEmployeeName"] : <any>null;
            this.existingTokenEmployeeName = _data["existingTokenEmployeeName"] !== undefined ? _data["existingTokenEmployeeName"] : <any>null;
            this.employeeIdForNexusUserInUse = _data["employeeIdForNexusUserInUse"] !== undefined ? _data["employeeIdForNexusUserInUse"] : <any>null;
            this.idToken = _data["idToken"] !== undefined ? _data["idToken"] : <any>null;
        }
    }

    static fromJS(data: any): EmployeeNexusInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeNexusInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestedTokenEmployeeName"] = this.requestedTokenEmployeeName !== undefined ? this.requestedTokenEmployeeName : <any>null;
        data["existingTokenEmployeeName"] = this.existingTokenEmployeeName !== undefined ? this.existingTokenEmployeeName : <any>null;
        data["employeeIdForNexusUserInUse"] = this.employeeIdForNexusUserInUse !== undefined ? this.employeeIdForNexusUserInUse : <any>null;
        data["idToken"] = this.idToken !== undefined ? this.idToken : <any>null;
        return data;
    }
}

export interface IEmployeeNexusInfoResponse {
    requestedTokenEmployeeName: string;
    existingTokenEmployeeName?: string | null;
    employeeIdForNexusUserInUse?: string | null;
    idToken?: string | null;
}

export class InitiateNexusSessionRequest implements IInitiateNexusSessionRequest {
    code?: string | null;
    redirectUri?: string | null;
    codeVerifier?: string | null;

    constructor(data?: IInitiateNexusSessionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.redirectUri = _data["redirectUri"] !== undefined ? _data["redirectUri"] : <any>null;
            this.codeVerifier = _data["codeVerifier"] !== undefined ? _data["codeVerifier"] : <any>null;
        }
    }

    static fromJS(data: any): InitiateNexusSessionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InitiateNexusSessionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["redirectUri"] = this.redirectUri !== undefined ? this.redirectUri : <any>null;
        data["codeVerifier"] = this.codeVerifier !== undefined ? this.codeVerifier : <any>null;
        return data;
    }
}

export interface IInitiateNexusSessionRequest {
    code?: string | null;
    redirectUri?: string | null;
    codeVerifier?: string | null;
}

export class InstructionIdAndNameResponse implements IInstructionIdAndNameResponse {
    id!: number;
    measurementDefinition?: MeasurementDefinitionResponse | null;

    constructor(data?: IInstructionIdAndNameResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.measurementDefinition = _data["measurementDefinition"] ? MeasurementDefinitionResponse.fromJS(_data["measurementDefinition"]) : <any>null;
        }
    }

    static fromJS(data: any): InstructionIdAndNameResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InstructionIdAndNameResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["measurementDefinition"] = this.measurementDefinition ? this.measurementDefinition.toJSON() : <any>null;
        return data;
    }
}

export interface IInstructionIdAndNameResponse {
    id: number;
    measurementDefinition?: MeasurementDefinitionResponse | null;
}

export class MeasurementDefinitionResponse implements IMeasurementDefinitionResponse {
    name?: string | null;
    active!: boolean;

    constructor(data?: IMeasurementDefinitionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
        }
    }

    static fromJS(data: any): MeasurementDefinitionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementDefinitionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        return data;
    }
}

export interface IMeasurementDefinitionResponse {
    name?: string | null;
    active: boolean;
}

export class NexusHealthMeasurementResponse implements INexusHealthMeasurementResponse {
    name?: string | null;
    id?: number | null;
    measurements?: MeasurementResponse[] | null;
    numberOfPages!: number;
    currentPage!: number;
    pageSize!: number;

    constructor(data?: INexusHealthMeasurementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            if (Array.isArray(_data["measurements"])) {
                this.measurements = [] as any;
                for (let item of _data["measurements"])
                    this.measurements!.push(MeasurementResponse.fromJS(item));
            }
            else {
                this.measurements = <any>null;
            }
            this.numberOfPages = _data["numberOfPages"] !== undefined ? _data["numberOfPages"] : <any>null;
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
        }
    }

    static fromJS(data: any): NexusHealthMeasurementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NexusHealthMeasurementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        if (Array.isArray(this.measurements)) {
            data["measurements"] = [];
            for (let item of this.measurements)
                data["measurements"].push(item ? item.toJSON() : <any>null);
        }
        data["numberOfPages"] = this.numberOfPages !== undefined ? this.numberOfPages : <any>null;
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        return data;
    }
}

export interface INexusHealthMeasurementResponse {
    name?: string | null;
    id?: number | null;
    measurements?: MeasurementResponse[] | null;
    numberOfPages: number;
    currentPage: number;
    pageSize: number;
}

export class MeasurementResponse implements IMeasurementResponse {
    name?: string | null;
    value?: string | null;
    date!: moment.Moment;
    comment?: string | null;
    measurements?: MeasurementResponse[] | null;
    id!: number;
    employeeId!: number;
    measuredBy?: string | null;
    isValueOutsideBoundary!: boolean;
    boundaryValue?: BoundaryValueResponse | null;

    constructor(data?: IMeasurementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            if (Array.isArray(_data["measurements"])) {
                this.measurements = [] as any;
                for (let item of _data["measurements"])
                    this.measurements!.push(MeasurementResponse.fromJS(item));
            }
            else {
                this.measurements = <any>null;
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.measuredBy = _data["measuredBy"] !== undefined ? _data["measuredBy"] : <any>null;
            this.isValueOutsideBoundary = _data["isValueOutsideBoundary"] !== undefined ? _data["isValueOutsideBoundary"] : <any>null;
            this.boundaryValue = _data["boundaryValue"] ? BoundaryValueResponse.fromJS(_data["boundaryValue"]) : <any>null;
        }
    }

    static fromJS(data: any): MeasurementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        if (Array.isArray(this.measurements)) {
            data["measurements"] = [];
            for (let item of this.measurements)
                data["measurements"].push(item ? item.toJSON() : <any>null);
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["measuredBy"] = this.measuredBy !== undefined ? this.measuredBy : <any>null;
        data["isValueOutsideBoundary"] = this.isValueOutsideBoundary !== undefined ? this.isValueOutsideBoundary : <any>null;
        data["boundaryValue"] = this.boundaryValue ? this.boundaryValue.toJSON() : <any>null;
        return data;
    }
}

export interface IMeasurementResponse {
    name?: string | null;
    value?: string | null;
    date: moment.Moment;
    comment?: string | null;
    measurements?: MeasurementResponse[] | null;
    id: number;
    employeeId: number;
    measuredBy?: string | null;
    isValueOutsideBoundary: boolean;
    boundaryValue?: BoundaryValueResponse | null;
}

export class BoundaryValueResponse implements IBoundaryValueResponse {
    type?: string | null;
    label?: string | null;
    date!: moment.Moment;
    boundaryComment?: string | null;
    unit?: string | null;

    protected _discriminator: string;

    constructor(data?: IBoundaryValueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BoundaryValueResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>null;
            this.boundaryComment = _data["boundaryComment"] !== undefined ? _data["boundaryComment"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
        }
    }

    static fromJS(data: any): BoundaryValueResponse {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "NumberBoundaryValueResponse") {
            let result = new NumberBoundaryValueResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "DecimalBoundaryValueResponse") {
            let result = new DecimalBoundaryValueResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "DropDownBoundaryValueResponse") {
            let result = new DropDownBoundaryValueResponse();
            result.init(data);
            return result;
        }
        let result = new BoundaryValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["swagger_discriminator"] = this._discriminator;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["boundaryComment"] = this.boundaryComment !== undefined ? this.boundaryComment : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        return data;
    }
}

export interface IBoundaryValueResponse {
    type?: string | null;
    label?: string | null;
    date: moment.Moment;
    boundaryComment?: string | null;
    unit?: string | null;
}

export class NumberBoundaryValueResponse extends BoundaryValueResponse implements INumberBoundaryValueResponse {
    minValue?: string | null;
    maxValue?: string | null;

    constructor(data?: INumberBoundaryValueResponse) {
        super(data);
        this._discriminator = "NumberBoundaryValueResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minValue = _data["minValue"] !== undefined ? _data["minValue"] : <any>null;
            this.maxValue = _data["maxValue"] !== undefined ? _data["maxValue"] : <any>null;
        }
    }

    static fromJS(data: any): NumberBoundaryValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NumberBoundaryValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minValue"] = this.minValue !== undefined ? this.minValue : <any>null;
        data["maxValue"] = this.maxValue !== undefined ? this.maxValue : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INumberBoundaryValueResponse extends IBoundaryValueResponse {
    minValue?: string | null;
    maxValue?: string | null;
}

export class DecimalBoundaryValueResponse extends BoundaryValueResponse implements IDecimalBoundaryValueResponse {
    minValue?: string | null;
    maxValue?: string | null;

    constructor(data?: IDecimalBoundaryValueResponse) {
        super(data);
        this._discriminator = "DecimalBoundaryValueResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minValue = _data["minValue"] !== undefined ? _data["minValue"] : <any>null;
            this.maxValue = _data["maxValue"] !== undefined ? _data["maxValue"] : <any>null;
        }
    }

    static fromJS(data: any): DecimalBoundaryValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DecimalBoundaryValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minValue"] = this.minValue !== undefined ? this.minValue : <any>null;
        data["maxValue"] = this.maxValue !== undefined ? this.maxValue : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDecimalBoundaryValueResponse extends IBoundaryValueResponse {
    minValue?: string | null;
    maxValue?: string | null;
}

export class DropDownBoundaryValueResponse extends BoundaryValueResponse implements IDropDownBoundaryValueResponse {
    minValue?: PossibleValueResponse | null;
    maxValue?: PossibleValueResponse | null;
    possibleValues?: PossibleValueResponse[] | null;

    constructor(data?: IDropDownBoundaryValueResponse) {
        super(data);
        this._discriminator = "DropDownBoundaryValueResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minValue = _data["minValue"] ? PossibleValueResponse.fromJS(_data["minValue"]) : <any>null;
            this.maxValue = _data["maxValue"] ? PossibleValueResponse.fromJS(_data["maxValue"]) : <any>null;
            if (Array.isArray(_data["possibleValues"])) {
                this.possibleValues = [] as any;
                for (let item of _data["possibleValues"])
                    this.possibleValues!.push(PossibleValueResponse.fromJS(item));
            }
            else {
                this.possibleValues = <any>null;
            }
        }
    }

    static fromJS(data: any): DropDownBoundaryValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DropDownBoundaryValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minValue"] = this.minValue ? this.minValue.toJSON() : <any>null;
        data["maxValue"] = this.maxValue ? this.maxValue.toJSON() : <any>null;
        if (Array.isArray(this.possibleValues)) {
            data["possibleValues"] = [];
            for (let item of this.possibleValues)
                data["possibleValues"].push(item ? item.toJSON() : <any>null);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDropDownBoundaryValueResponse extends IBoundaryValueResponse {
    minValue?: PossibleValueResponse | null;
    maxValue?: PossibleValueResponse | null;
    possibleValues?: PossibleValueResponse[] | null;
}

export class PossibleValueResponse implements IPossibleValueResponse {
    id!: number;
    version!: number;
    name?: string | null;
    active!: boolean;
    numericRepresentation!: number;
    marker?: any | null;

    constructor(data?: IPossibleValueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            this.numericRepresentation = _data["numericRepresentation"] !== undefined ? _data["numericRepresentation"] : <any>null;
            this.marker = _data["marker"] !== undefined ? _data["marker"] : <any>null;
        }
    }

    static fromJS(data: any): PossibleValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PossibleValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        data["numericRepresentation"] = this.numericRepresentation !== undefined ? this.numericRepresentation : <any>null;
        data["marker"] = this.marker !== undefined ? this.marker : <any>null;
        return data;
    }
}

export interface IPossibleValueResponse {
    id: number;
    version: number;
    name?: string | null;
    active: boolean;
    numericRepresentation: number;
    marker?: any | null;
}

export class NexusHealthMeasurementPrototypeResponse implements INexusHealthMeasurementPrototypeResponse {
    id!: number;
    observationDate!: moment.Moment;
    fields?: FieldResponse[] | null;
    comment?: string | null;
    definition?: DefinitionResponse | null;
    instruction?: InstructionResponse | null;
    patient?: PatientResponse | null;

    constructor(data?: INexusHealthMeasurementPrototypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.observationDate = _data["observationDate"] ? moment(_data["observationDate"].toString()) : <any>null;
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(FieldResponse.fromJS(item));
            }
            else {
                this.fields = <any>null;
            }
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.definition = _data["definition"] ? DefinitionResponse.fromJS(_data["definition"]) : <any>null;
            this.instruction = _data["instruction"] ? InstructionResponse.fromJS(_data["instruction"]) : <any>null;
            this.patient = _data["patient"] ? PatientResponse.fromJS(_data["patient"]) : <any>null;
        }
    }

    static fromJS(data: any): NexusHealthMeasurementPrototypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NexusHealthMeasurementPrototypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["observationDate"] = this.observationDate ? this.observationDate.toISOString() : <any>null;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item ? item.toJSON() : <any>null);
        }
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["definition"] = this.definition ? this.definition.toJSON() : <any>null;
        data["instruction"] = this.instruction ? this.instruction.toJSON() : <any>null;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>null;
        return data;
    }
}

export interface INexusHealthMeasurementPrototypeResponse {
    id: number;
    observationDate: moment.Moment;
    fields?: FieldResponse[] | null;
    comment?: string | null;
    definition?: DefinitionResponse | null;
    instruction?: InstructionResponse | null;
    patient?: PatientResponse | null;
}

export class FieldResponse implements IFieldResponse {
    type?: string | null;
    label?: string | null;
    value?: any | null;
    unit?: string | null;
    date?: any | null;
    questionId!: number;
    required!: boolean;
    tooltip?: string | null;
    id!: number;
    possibleValues?: PossibleValueResponse[] | null;

    constructor(data?: IFieldResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
            this.date = _data["date"] !== undefined ? _data["date"] : <any>null;
            this.questionId = _data["questionId"] !== undefined ? _data["questionId"] : <any>null;
            this.required = _data["required"] !== undefined ? _data["required"] : <any>null;
            this.tooltip = _data["tooltip"] !== undefined ? _data["tooltip"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            if (Array.isArray(_data["possibleValues"])) {
                this.possibleValues = [] as any;
                for (let item of _data["possibleValues"])
                    this.possibleValues!.push(PossibleValueResponse.fromJS(item));
            }
            else {
                this.possibleValues = <any>null;
            }
        }
    }

    static fromJS(data: any): FieldResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FieldResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        data["date"] = this.date !== undefined ? this.date : <any>null;
        data["questionId"] = this.questionId !== undefined ? this.questionId : <any>null;
        data["required"] = this.required !== undefined ? this.required : <any>null;
        data["tooltip"] = this.tooltip !== undefined ? this.tooltip : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        if (Array.isArray(this.possibleValues)) {
            data["possibleValues"] = [];
            for (let item of this.possibleValues)
                data["possibleValues"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IFieldResponse {
    type?: string | null;
    label?: string | null;
    value?: any | null;
    unit?: string | null;
    date?: any | null;
    questionId: number;
    required: boolean;
    tooltip?: string | null;
    id: number;
    possibleValues?: PossibleValueResponse[] | null;
}

export class DefinitionResponse implements IDefinitionResponse {
    sequenceId!: number;
    name?: string | null;
    active!: boolean;
    createDate!: moment.Moment;
    id!: number;
    version!: number;

    constructor(data?: IDefinitionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sequenceId = _data["sequenceId"] !== undefined ? _data["sequenceId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            this.createDate = _data["createDate"] ? moment(_data["createDate"].toString()) : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
        }
    }

    static fromJS(data: any): DefinitionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DefinitionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequenceId"] = this.sequenceId !== undefined ? this.sequenceId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        return data;
    }
}

export interface IDefinitionResponse {
    sequenceId: number;
    name?: string | null;
    active: boolean;
    createDate: moment.Moment;
    id: number;
    version: number;
}

export class InstructionResponse implements IInstructionResponse {
    patientActivityType?: string | null;
    measurementDefinition?: any | null;
    active!: boolean;
    activityIdentifier?: any | null;
    id!: number;
    boundary?: BoundaryResponse | null;

    constructor(data?: IInstructionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientActivityType = _data["patientActivityType"] !== undefined ? _data["patientActivityType"] : <any>null;
            this.measurementDefinition = _data["measurementDefinition"] !== undefined ? _data["measurementDefinition"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            this.activityIdentifier = _data["activityIdentifier"] !== undefined ? _data["activityIdentifier"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.boundary = _data["boundary"] ? BoundaryResponse.fromJS(_data["boundary"]) : <any>null;
        }
    }

    static fromJS(data: any): InstructionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InstructionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientActivityType"] = this.patientActivityType !== undefined ? this.patientActivityType : <any>null;
        data["measurementDefinition"] = this.measurementDefinition !== undefined ? this.measurementDefinition : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        data["activityIdentifier"] = this.activityIdentifier !== undefined ? this.activityIdentifier : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["boundary"] = this.boundary ? this.boundary.toJSON() : <any>null;
        return data;
    }
}

export interface IInstructionResponse {
    patientActivityType?: string | null;
    measurementDefinition?: any | null;
    active: boolean;
    activityIdentifier?: any | null;
    id: number;
    boundary?: BoundaryResponse | null;
}

export class BoundaryResponse implements IBoundaryResponse {
    boundaryValueResources?: BoundaryValueResponse[] | null;

    constructor(data?: IBoundaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["boundaryValueResources"])) {
                this.boundaryValueResources = [] as any;
                for (let item of _data["boundaryValueResources"])
                    this.boundaryValueResources!.push(BoundaryValueResponse.fromJS(item));
            }
            else {
                this.boundaryValueResources = <any>null;
            }
        }
    }

    static fromJS(data: any): BoundaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BoundaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.boundaryValueResources)) {
            data["boundaryValueResources"] = [];
            for (let item of this.boundaryValueResources)
                data["boundaryValueResources"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IBoundaryResponse {
    boundaryValueResources?: BoundaryValueResponse[] | null;
}

export class PatientResponse implements IPatientResponse {
    id!: number;
    version!: number;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    fullReversedName?: string | null;
    homePhoneNumber?: string | null;
    mobilePhoneNumber?: string | null;
    workPhoneNumber?: string | null;
    currentAddress?: CurrentAddressResponse | null;
    currentAddressIndicator?: string | null;
    age!: number;
    gender?: string | null;
    patientStatus?: string | null;
    telephonesRestricted!: boolean;
    imageId?: any | null;

    constructor(data?: IPatientResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.middleName = _data["middleName"] !== undefined ? _data["middleName"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.fullReversedName = _data["fullReversedName"] !== undefined ? _data["fullReversedName"] : <any>null;
            this.homePhoneNumber = _data["homePhoneNumber"] !== undefined ? _data["homePhoneNumber"] : <any>null;
            this.mobilePhoneNumber = _data["mobilePhoneNumber"] !== undefined ? _data["mobilePhoneNumber"] : <any>null;
            this.workPhoneNumber = _data["workPhoneNumber"] !== undefined ? _data["workPhoneNumber"] : <any>null;
            this.currentAddress = _data["currentAddress"] ? CurrentAddressResponse.fromJS(_data["currentAddress"]) : <any>null;
            this.currentAddressIndicator = _data["currentAddressIndicator"] !== undefined ? _data["currentAddressIndicator"] : <any>null;
            this.age = _data["age"] !== undefined ? _data["age"] : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : <any>null;
            this.patientStatus = _data["patientStatus"] !== undefined ? _data["patientStatus"] : <any>null;
            this.telephonesRestricted = _data["telephonesRestricted"] !== undefined ? _data["telephonesRestricted"] : <any>null;
            this.imageId = _data["imageId"] !== undefined ? _data["imageId"] : <any>null;
        }
    }

    static fromJS(data: any): PatientResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PatientResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["middleName"] = this.middleName !== undefined ? this.middleName : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["fullReversedName"] = this.fullReversedName !== undefined ? this.fullReversedName : <any>null;
        data["homePhoneNumber"] = this.homePhoneNumber !== undefined ? this.homePhoneNumber : <any>null;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber !== undefined ? this.mobilePhoneNumber : <any>null;
        data["workPhoneNumber"] = this.workPhoneNumber !== undefined ? this.workPhoneNumber : <any>null;
        data["currentAddress"] = this.currentAddress ? this.currentAddress.toJSON() : <any>null;
        data["currentAddressIndicator"] = this.currentAddressIndicator !== undefined ? this.currentAddressIndicator : <any>null;
        data["age"] = this.age !== undefined ? this.age : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        data["patientStatus"] = this.patientStatus !== undefined ? this.patientStatus : <any>null;
        data["telephonesRestricted"] = this.telephonesRestricted !== undefined ? this.telephonesRestricted : <any>null;
        data["imageId"] = this.imageId !== undefined ? this.imageId : <any>null;
        return data;
    }
}

export interface IPatientResponse {
    id: number;
    version: number;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    fullReversedName?: string | null;
    homePhoneNumber?: string | null;
    mobilePhoneNumber?: string | null;
    workPhoneNumber?: string | null;
    currentAddress?: CurrentAddressResponse | null;
    currentAddressIndicator?: string | null;
    age: number;
    gender?: string | null;
    patientStatus?: string | null;
    telephonesRestricted: boolean;
    imageId?: any | null;
}

export class CurrentAddressResponse implements ICurrentAddressResponse {
    addressLine1?: string | null;
    addressLine2?: any | null;
    addressLine3?: any | null;
    addressLine4?: any | null;
    addressLine5?: any | null;
    administrativeAreaCode?: any | null;
    countryCode?: string | null;
    postalCode?: string | null;
    postalDistrict?: string | null;
    restricted!: boolean;
    geoCoordinates?: GeoCoordinatesResponse | null;

    constructor(data?: ICurrentAddressResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressLine1 = _data["addressLine1"] !== undefined ? _data["addressLine1"] : <any>null;
            this.addressLine2 = _data["addressLine2"] !== undefined ? _data["addressLine2"] : <any>null;
            this.addressLine3 = _data["addressLine3"] !== undefined ? _data["addressLine3"] : <any>null;
            this.addressLine4 = _data["addressLine4"] !== undefined ? _data["addressLine4"] : <any>null;
            this.addressLine5 = _data["addressLine5"] !== undefined ? _data["addressLine5"] : <any>null;
            this.administrativeAreaCode = _data["administrativeAreaCode"] !== undefined ? _data["administrativeAreaCode"] : <any>null;
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : <any>null;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : <any>null;
            this.postalDistrict = _data["postalDistrict"] !== undefined ? _data["postalDistrict"] : <any>null;
            this.restricted = _data["restricted"] !== undefined ? _data["restricted"] : <any>null;
            this.geoCoordinates = _data["geoCoordinates"] ? GeoCoordinatesResponse.fromJS(_data["geoCoordinates"]) : <any>null;
        }
    }

    static fromJS(data: any): CurrentAddressResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentAddressResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressLine1"] = this.addressLine1 !== undefined ? this.addressLine1 : <any>null;
        data["addressLine2"] = this.addressLine2 !== undefined ? this.addressLine2 : <any>null;
        data["addressLine3"] = this.addressLine3 !== undefined ? this.addressLine3 : <any>null;
        data["addressLine4"] = this.addressLine4 !== undefined ? this.addressLine4 : <any>null;
        data["addressLine5"] = this.addressLine5 !== undefined ? this.addressLine5 : <any>null;
        data["administrativeAreaCode"] = this.administrativeAreaCode !== undefined ? this.administrativeAreaCode : <any>null;
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : <any>null;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : <any>null;
        data["postalDistrict"] = this.postalDistrict !== undefined ? this.postalDistrict : <any>null;
        data["restricted"] = this.restricted !== undefined ? this.restricted : <any>null;
        data["geoCoordinates"] = this.geoCoordinates ? this.geoCoordinates.toJSON() : <any>null;
        return data;
    }
}

export interface ICurrentAddressResponse {
    addressLine1?: string | null;
    addressLine2?: any | null;
    addressLine3?: any | null;
    addressLine4?: any | null;
    addressLine5?: any | null;
    administrativeAreaCode?: any | null;
    countryCode?: string | null;
    postalCode?: string | null;
    postalDistrict?: string | null;
    restricted: boolean;
    geoCoordinates?: GeoCoordinatesResponse | null;
}

export class GeoCoordinatesResponse implements IGeoCoordinatesResponse {
    x!: number;
    y!: number;
    present!: boolean;

    constructor(data?: IGeoCoordinatesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"] !== undefined ? _data["x"] : <any>null;
            this.y = _data["y"] !== undefined ? _data["y"] : <any>null;
            this.present = _data["present"] !== undefined ? _data["present"] : <any>null;
        }
    }

    static fromJS(data: any): GeoCoordinatesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GeoCoordinatesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x !== undefined ? this.x : <any>null;
        data["y"] = this.y !== undefined ? this.y : <any>null;
        data["present"] = this.present !== undefined ? this.present : <any>null;
        return data;
    }
}

export interface IGeoCoordinatesResponse {
    x: number;
    y: number;
    present: boolean;
}

export class CreateMeasurementRequest implements ICreateMeasurementRequest {
    observationDate!: moment.Moment;
    comment?: string | null;
    fields?: FieldRequest[] | null;
    id!: number;
    definition?: DefinitionRequest | null;
    instruction?: InstructionRequest | null;
    patient?: PatientRequest | null;

    constructor(data?: ICreateMeasurementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.observationDate = _data["observationDate"] ? moment(_data["observationDate"].toString()) : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(FieldRequest.fromJS(item));
            }
            else {
                this.fields = <any>null;
            }
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.definition = _data["definition"] ? DefinitionRequest.fromJS(_data["definition"]) : <any>null;
            this.instruction = _data["instruction"] ? InstructionRequest.fromJS(_data["instruction"]) : <any>null;
            this.patient = _data["patient"] ? PatientRequest.fromJS(_data["patient"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateMeasurementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMeasurementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["observationDate"] = this.observationDate ? this.observationDate.toISOString() : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item ? item.toJSON() : <any>null);
        }
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["definition"] = this.definition ? this.definition.toJSON() : <any>null;
        data["instruction"] = this.instruction ? this.instruction.toJSON() : <any>null;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>null;
        return data;
    }
}

export interface ICreateMeasurementRequest {
    observationDate: moment.Moment;
    comment?: string | null;
    fields?: FieldRequest[] | null;
    id: number;
    definition?: DefinitionRequest | null;
    instruction?: InstructionRequest | null;
    patient?: PatientRequest | null;
}

export class FieldRequest implements IFieldRequest {
    type?: string | null;
    label?: string | null;
    value?: any | null;
    unit?: string | null;
    date?: any | null;
    questionId!: number;
    required!: boolean;
    tooltip?: string | null;
    id!: number;
    possibleValues?: PossibleValueRequest[] | null;

    constructor(data?: IFieldRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.unit = _data["unit"] !== undefined ? _data["unit"] : <any>null;
            this.date = _data["date"] !== undefined ? _data["date"] : <any>null;
            this.questionId = _data["questionId"] !== undefined ? _data["questionId"] : <any>null;
            this.required = _data["required"] !== undefined ? _data["required"] : <any>null;
            this.tooltip = _data["tooltip"] !== undefined ? _data["tooltip"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            if (Array.isArray(_data["possibleValues"])) {
                this.possibleValues = [] as any;
                for (let item of _data["possibleValues"])
                    this.possibleValues!.push(PossibleValueRequest.fromJS(item));
            }
            else {
                this.possibleValues = <any>null;
            }
        }
    }

    static fromJS(data: any): FieldRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FieldRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["unit"] = this.unit !== undefined ? this.unit : <any>null;
        data["date"] = this.date !== undefined ? this.date : <any>null;
        data["questionId"] = this.questionId !== undefined ? this.questionId : <any>null;
        data["required"] = this.required !== undefined ? this.required : <any>null;
        data["tooltip"] = this.tooltip !== undefined ? this.tooltip : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        if (Array.isArray(this.possibleValues)) {
            data["possibleValues"] = [];
            for (let item of this.possibleValues)
                data["possibleValues"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IFieldRequest {
    type?: string | null;
    label?: string | null;
    value?: any | null;
    unit?: string | null;
    date?: any | null;
    questionId: number;
    required: boolean;
    tooltip?: string | null;
    id: number;
    possibleValues?: PossibleValueRequest[] | null;
}

export class PossibleValueRequest implements IPossibleValueRequest {
    id!: number;
    version!: number;
    name?: string | null;
    active!: boolean;
    numericRepresentation!: number;
    marker?: any | null;

    constructor(data?: IPossibleValueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            this.numericRepresentation = _data["numericRepresentation"] !== undefined ? _data["numericRepresentation"] : <any>null;
            this.marker = _data["marker"] !== undefined ? _data["marker"] : <any>null;
        }
    }

    static fromJS(data: any): PossibleValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PossibleValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        data["numericRepresentation"] = this.numericRepresentation !== undefined ? this.numericRepresentation : <any>null;
        data["marker"] = this.marker !== undefined ? this.marker : <any>null;
        return data;
    }
}

export interface IPossibleValueRequest {
    id: number;
    version: number;
    name?: string | null;
    active: boolean;
    numericRepresentation: number;
    marker?: any | null;
}

export class DefinitionRequest implements IDefinitionRequest {
    sequenceId!: number;
    name?: string | null;
    active!: boolean;
    createDate!: moment.Moment;
    id!: number;
    version!: number;

    constructor(data?: IDefinitionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sequenceId = _data["sequenceId"] !== undefined ? _data["sequenceId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            this.createDate = _data["createDate"] ? moment(_data["createDate"].toString()) : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
        }
    }

    static fromJS(data: any): DefinitionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DefinitionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequenceId"] = this.sequenceId !== undefined ? this.sequenceId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        return data;
    }
}

export interface IDefinitionRequest {
    sequenceId: number;
    name?: string | null;
    active: boolean;
    createDate: moment.Moment;
    id: number;
    version: number;
}

export class InstructionRequest implements IInstructionRequest {
    patientActivityType?: string | null;
    measurementDefinition?: any | null;
    active!: boolean;
    activityIdentifier?: any | null;
    id!: number;
    boundary?: any | null;

    constructor(data?: IInstructionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientActivityType = _data["patientActivityType"] !== undefined ? _data["patientActivityType"] : <any>null;
            this.measurementDefinition = _data["measurementDefinition"] !== undefined ? _data["measurementDefinition"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            this.activityIdentifier = _data["activityIdentifier"] !== undefined ? _data["activityIdentifier"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.boundary = _data["boundary"] !== undefined ? _data["boundary"] : <any>null;
        }
    }

    static fromJS(data: any): InstructionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InstructionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientActivityType"] = this.patientActivityType !== undefined ? this.patientActivityType : <any>null;
        data["measurementDefinition"] = this.measurementDefinition !== undefined ? this.measurementDefinition : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        data["activityIdentifier"] = this.activityIdentifier !== undefined ? this.activityIdentifier : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["boundary"] = this.boundary !== undefined ? this.boundary : <any>null;
        return data;
    }
}

export interface IInstructionRequest {
    patientActivityType?: string | null;
    measurementDefinition?: any | null;
    active: boolean;
    activityIdentifier?: any | null;
    id: number;
    boundary?: any | null;
}

export class PatientRequest implements IPatientRequest {
    id!: number;
    version!: number;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    fullReversedName?: string | null;
    homePhoneNumber?: string | null;
    mobilePhoneNumber?: string | null;
    workPhoneNumber?: string | null;
    currentAddress?: CurrentAddressRequest | null;
    currentAddressIndicator?: string | null;
    age!: number;
    gender?: string | null;
    patientStatus?: string | null;
    telephonesRestricted!: boolean;
    imageId?: any | null;

    constructor(data?: IPatientRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.middleName = _data["middleName"] !== undefined ? _data["middleName"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.fullReversedName = _data["fullReversedName"] !== undefined ? _data["fullReversedName"] : <any>null;
            this.homePhoneNumber = _data["homePhoneNumber"] !== undefined ? _data["homePhoneNumber"] : <any>null;
            this.mobilePhoneNumber = _data["mobilePhoneNumber"] !== undefined ? _data["mobilePhoneNumber"] : <any>null;
            this.workPhoneNumber = _data["workPhoneNumber"] !== undefined ? _data["workPhoneNumber"] : <any>null;
            this.currentAddress = _data["currentAddress"] ? CurrentAddressRequest.fromJS(_data["currentAddress"]) : <any>null;
            this.currentAddressIndicator = _data["currentAddressIndicator"] !== undefined ? _data["currentAddressIndicator"] : <any>null;
            this.age = _data["age"] !== undefined ? _data["age"] : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : <any>null;
            this.patientStatus = _data["patientStatus"] !== undefined ? _data["patientStatus"] : <any>null;
            this.telephonesRestricted = _data["telephonesRestricted"] !== undefined ? _data["telephonesRestricted"] : <any>null;
            this.imageId = _data["imageId"] !== undefined ? _data["imageId"] : <any>null;
        }
    }

    static fromJS(data: any): PatientRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PatientRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["middleName"] = this.middleName !== undefined ? this.middleName : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["fullReversedName"] = this.fullReversedName !== undefined ? this.fullReversedName : <any>null;
        data["homePhoneNumber"] = this.homePhoneNumber !== undefined ? this.homePhoneNumber : <any>null;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber !== undefined ? this.mobilePhoneNumber : <any>null;
        data["workPhoneNumber"] = this.workPhoneNumber !== undefined ? this.workPhoneNumber : <any>null;
        data["currentAddress"] = this.currentAddress ? this.currentAddress.toJSON() : <any>null;
        data["currentAddressIndicator"] = this.currentAddressIndicator !== undefined ? this.currentAddressIndicator : <any>null;
        data["age"] = this.age !== undefined ? this.age : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        data["patientStatus"] = this.patientStatus !== undefined ? this.patientStatus : <any>null;
        data["telephonesRestricted"] = this.telephonesRestricted !== undefined ? this.telephonesRestricted : <any>null;
        data["imageId"] = this.imageId !== undefined ? this.imageId : <any>null;
        return data;
    }
}

export interface IPatientRequest {
    id: number;
    version: number;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    fullName?: string | null;
    fullReversedName?: string | null;
    homePhoneNumber?: string | null;
    mobilePhoneNumber?: string | null;
    workPhoneNumber?: string | null;
    currentAddress?: CurrentAddressRequest | null;
    currentAddressIndicator?: string | null;
    age: number;
    gender?: string | null;
    patientStatus?: string | null;
    telephonesRestricted: boolean;
    imageId?: any | null;
}

export class CurrentAddressRequest implements ICurrentAddressRequest {
    addressLine1?: string | null;
    addressLine2?: any | null;
    addressLine3?: any | null;
    addressLine4?: any | null;
    addressLine5?: any | null;
    administrativeAreaCode?: any | null;
    countryCode?: string | null;
    postalCode?: string | null;
    postalDistrict?: string | null;
    restricted!: boolean;
    geoCoordinates?: GeoCoordinatesRequest | null;

    constructor(data?: ICurrentAddressRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressLine1 = _data["addressLine1"] !== undefined ? _data["addressLine1"] : <any>null;
            this.addressLine2 = _data["addressLine2"] !== undefined ? _data["addressLine2"] : <any>null;
            this.addressLine3 = _data["addressLine3"] !== undefined ? _data["addressLine3"] : <any>null;
            this.addressLine4 = _data["addressLine4"] !== undefined ? _data["addressLine4"] : <any>null;
            this.addressLine5 = _data["addressLine5"] !== undefined ? _data["addressLine5"] : <any>null;
            this.administrativeAreaCode = _data["administrativeAreaCode"] !== undefined ? _data["administrativeAreaCode"] : <any>null;
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : <any>null;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : <any>null;
            this.postalDistrict = _data["postalDistrict"] !== undefined ? _data["postalDistrict"] : <any>null;
            this.restricted = _data["restricted"] !== undefined ? _data["restricted"] : <any>null;
            this.geoCoordinates = _data["geoCoordinates"] ? GeoCoordinatesRequest.fromJS(_data["geoCoordinates"]) : <any>null;
        }
    }

    static fromJS(data: any): CurrentAddressRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentAddressRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressLine1"] = this.addressLine1 !== undefined ? this.addressLine1 : <any>null;
        data["addressLine2"] = this.addressLine2 !== undefined ? this.addressLine2 : <any>null;
        data["addressLine3"] = this.addressLine3 !== undefined ? this.addressLine3 : <any>null;
        data["addressLine4"] = this.addressLine4 !== undefined ? this.addressLine4 : <any>null;
        data["addressLine5"] = this.addressLine5 !== undefined ? this.addressLine5 : <any>null;
        data["administrativeAreaCode"] = this.administrativeAreaCode !== undefined ? this.administrativeAreaCode : <any>null;
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : <any>null;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : <any>null;
        data["postalDistrict"] = this.postalDistrict !== undefined ? this.postalDistrict : <any>null;
        data["restricted"] = this.restricted !== undefined ? this.restricted : <any>null;
        data["geoCoordinates"] = this.geoCoordinates ? this.geoCoordinates.toJSON() : <any>null;
        return data;
    }
}

export interface ICurrentAddressRequest {
    addressLine1?: string | null;
    addressLine2?: any | null;
    addressLine3?: any | null;
    addressLine4?: any | null;
    addressLine5?: any | null;
    administrativeAreaCode?: any | null;
    countryCode?: string | null;
    postalCode?: string | null;
    postalDistrict?: string | null;
    restricted: boolean;
    geoCoordinates?: GeoCoordinatesRequest | null;
}

export class GeoCoordinatesRequest implements IGeoCoordinatesRequest {
    x!: number;
    y!: number;
    present!: boolean;

    constructor(data?: IGeoCoordinatesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"] !== undefined ? _data["x"] : <any>null;
            this.y = _data["y"] !== undefined ? _data["y"] : <any>null;
            this.present = _data["present"] !== undefined ? _data["present"] : <any>null;
        }
    }

    static fromJS(data: any): GeoCoordinatesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GeoCoordinatesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x !== undefined ? this.x : <any>null;
        data["y"] = this.y !== undefined ? this.y : <any>null;
        data["present"] = this.present !== undefined ? this.present : <any>null;
        return data;
    }
}

export interface IGeoCoordinatesRequest {
    x: number;
    y: number;
    present: boolean;
}

export class UpdateFormRequest implements IUpdateFormRequest {
    form?: FormRequest | null;
    actionId!: number;

    constructor(data?: IUpdateFormRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.form = _data["form"] ? FormRequest.fromJS(_data["form"]) : <any>null;
            this.actionId = _data["actionId"] !== undefined ? _data["actionId"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateFormRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFormRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["form"] = this.form ? this.form.toJSON() : <any>null;
        data["actionId"] = this.actionId !== undefined ? this.actionId : <any>null;
        return data;
    }
}

export interface IUpdateFormRequest {
    form?: FormRequest | null;
    actionId: number;
}

export class ConfigurationResponse implements IConfigurationResponse {
    nexusAuthUrl?: string | null;
    nexusBaseUrl?: string | null;
    authorizationCodeClientId?: string | null;

    constructor(data?: IConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nexusAuthUrl = _data["nexusAuthUrl"] !== undefined ? _data["nexusAuthUrl"] : <any>null;
            this.nexusBaseUrl = _data["nexusBaseUrl"] !== undefined ? _data["nexusBaseUrl"] : <any>null;
            this.authorizationCodeClientId = _data["authorizationCodeClientId"] !== undefined ? _data["authorizationCodeClientId"] : <any>null;
        }
    }

    static fromJS(data: any): ConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nexusAuthUrl"] = this.nexusAuthUrl !== undefined ? this.nexusAuthUrl : <any>null;
        data["nexusBaseUrl"] = this.nexusBaseUrl !== undefined ? this.nexusBaseUrl : <any>null;
        data["authorizationCodeClientId"] = this.authorizationCodeClientId !== undefined ? this.authorizationCodeClientId : <any>null;
        return data;
    }
}

export interface IConfigurationResponse {
    nexusAuthUrl?: string | null;
    nexusBaseUrl?: string | null;
    authorizationCodeClientId?: string | null;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}